(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[239],{

/***/ 63666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ getImageByClass; }
/* harmony export */ });
/* harmony import */ var _shared_utils_content_content_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5626);
/* harmony import */ var _shared_utils_reader_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16484);
/* harmony import */ var _EgwWebFont__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37462);



var getImageByClass = function getImageByClass(className) {
  var darkTheme = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  // As ussualy name of classname is same as icon name
  var iconValue = _EgwWebFont__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z[className];

  if (!iconValue) {
    switch (className) {
      case "manuscript-releases":
        return _EgwWebFont__WEBPACK_IMPORTED_MODULE_2__/* ["default"].manuscript */ .Z.manuscript;

      case "EGW":
      case "biography":
        return darkTheme ? _EgwWebFont__WEBPACK_IMPORTED_MODULE_2__/* ["default"]["ellen-dark"] */ .Z["ellen-dark"] : _EgwWebFont__WEBPACK_IMPORTED_MODULE_2__/* ["default"]["ellen-light"] */ .Z["ellen-light"];

      case _shared_utils_content_content_constants__WEBPACK_IMPORTED_MODULE_0__/* .BOOK_TYPE.apl */ ._i.apl:
        return _EgwWebFont__WEBPACK_IMPORTED_MODULE_2__/* ["default"]["adventist-library"] */ .Z["adventist-library"];

      case "bible":
      case "bibleCommentary":
      case _shared_utils_reader_constants__WEBPACK_IMPORTED_MODULE_1__/* .BOOK_REAL_TYPE.bibleVersions */ .aE.bibleVersions:
        return _EgwWebFont__WEBPACK_IMPORTED_MODULE_2__/* ["default"].bible */ .Z.bible;

      case _shared_utils_reader_constants__WEBPACK_IMPORTED_MODULE_1__/* .BOOK_REAL_TYPE.bibleConcordances */ .aE.bibleConcordances:
        return _EgwWebFont__WEBPACK_IMPORTED_MODULE_2__/* ["default"].concordances */ .Z.concordances;

      case "bible-commentaries":
        return _EgwWebFont__WEBPACK_IMPORTED_MODULE_2__/* ["default"].commentaries */ .Z.commentaries;

      case "bible-dictionaries":
        return _EgwWebFont__WEBPACK_IMPORTED_MODULE_2__/* ["default"].dictionaries */ .Z.dictionaries;

      case "bible-sdasi":
        return _EgwWebFont__WEBPACK_IMPORTED_MODULE_2__/* ["default"]["sda-scripture-Index"] */ .Z["sda-scripture-Index"];

      case "devotionals":
      case "devotional":
        return _EgwWebFont__WEBPACK_IMPORTED_MODULE_2__/* ["default"].devotionals */ .Z.devotionals;

      case _shared_utils_content_content_constants__WEBPACK_IMPORTED_MODULE_0__/* .FOLDER_TYPE.egwwritings */ .S.egwwritings:
      case "modern-english":
        return _EgwWebFont__WEBPACK_IMPORTED_MODULE_2__/* ["default"]["modern-english"] */ .Z["modern-english"];

      case "conflict":
        return _EgwWebFont__WEBPACK_IMPORTED_MODULE_2__/* ["default"]["conflict-of-the-ages-series"] */ .Z["conflict-of-the-ages-series"];

      case "chapter":
      case "para":
        return _EgwWebFont__WEBPACK_IMPORTED_MODULE_2__/* ["default"].content */ .Z.content;

      case "books":
        return _EgwWebFont__WEBPACK_IMPORTED_MODULE_2__/* ["default"].books */ .Z.books;

      case "book":
      case _shared_utils_content_content_constants__WEBPACK_IMPORTED_MODULE_0__/* .CONTENT_CLASSES.TITLES_BOOK */ .J8.TITLES_BOOK:
      case _shared_utils_content_content_constants__WEBPACK_IMPORTED_MODULE_0__/* .CONTENT_CLASSES.CATEGORIES_BOOK */ .J8.CATEGORIES_BOOK:
        return _EgwWebFont__WEBPACK_IMPORTED_MODULE_2__/* ["default"]["book-open"] */ .Z["book-open"];

      case "info":
        return _EgwWebFont__WEBPACK_IMPORTED_MODULE_2__/* ["default"].information */ .Z.information;

      case "donate":
        return _EgwWebFont__WEBPACK_IMPORTED_MODULE_2__/* ["default"].donate */ .Z.donate;

      case "all-collections":
        return _EgwWebFont__WEBPACK_IMPORTED_MODULE_2__/* ["default"]["all-collections"] */ .Z["all-collections"];

      case "study-center":
        return _EgwWebFont__WEBPACK_IMPORTED_MODULE_2__/* ["default"]["study-center"] */ .Z["study-center"];

      case "subscription":
        return _EgwWebFont__WEBPACK_IMPORTED_MODULE_2__/* ["default"].subscription */ .Z.subscription;

      case "faq":
        return _EgwWebFont__WEBPACK_IMPORTED_MODULE_2__/* ["default"].faq */ .Z.faq;

      case "contact-us":
        return _EgwWebFont__WEBPACK_IMPORTED_MODULE_2__/* ["default"]["contact-us"] */ .Z["contact-us"];

      case "settings":
        return _EgwWebFont__WEBPACK_IMPORTED_MODULE_2__/* ["default"].settings */ .Z.settings;

      case "category":
        return null;

      case _shared_utils_content_content_constants__WEBPACK_IMPORTED_MODULE_0__/* .CONTENT_CLASSES.CATEGORIES_ROOT */ .J8.CATEGORIES_ROOT:
        return _EgwWebFont__WEBPACK_IMPORTED_MODULE_2__/* ["default"].tree */ .Z.tree;

      case _shared_utils_content_content_constants__WEBPACK_IMPORTED_MODULE_0__/* .CONTENT_CLASSES.TITLES_ROOT */ .J8.TITLES_ROOT:
        return _EgwWebFont__WEBPACK_IMPORTED_MODULE_2__/* ["default"].titles */ .Z.titles;

      default:
        return _EgwWebFont__WEBPACK_IMPORTED_MODULE_2__/* ["default"]["folder-close"] */ .Z["folder-close"];
    }
  }

  return iconValue || _EgwWebFont__WEBPACK_IMPORTED_MODULE_2__/* ["default"]["folder-close"] */ .Z["folder-close"];
};

/***/ }),

/***/ 64666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ad": function() { return /* binding */ ChevronDoubleLeftIcon; },
/* harmony export */   "CR": function() { return /* binding */ ThemeDayIcon; },
/* harmony export */   "Ew": function() { return /* binding */ ThemeDuskIcon; },
/* harmony export */   "GQ": function() { return /* binding */ SignInIcon; },
/* harmony export */   "Oi": function() { return /* binding */ ThemeHumanWhiteIcon; },
/* harmony export */   "PU": function() { return /* binding */ ThemeDawnIcon; },
/* harmony export */   "T4": function() { return /* binding */ ThemeHumanBlackIcon; },
/* harmony export */   "XC": function() { return /* binding */ ChevronRightIcon; },
/* harmony export */   "Z6": function() { return /* binding */ ThemeDarkIcon; },
/* harmony export */   "a3": function() { return /* binding */ ChevronDoubleRightIcon; },
/* harmony export */   "aA": function() { return /* binding */ ShareIcon; },
/* harmony export */   "bv": function() { return /* binding */ SubscribeIcon; },
/* harmony export */   "ct": function() { return /* binding */ GoogleTranslateIcon; },
/* harmony export */   "eZ": function() { return /* binding */ BookCircle; },
/* harmony export */   "wy": function() { return /* binding */ ChevronLeftIcon; }
/* harmony export */ });
/* unused harmony exports EGWLogo, CloseIcon, ContentIcon, FullScreenIcon, CheckNoIcon, DotsVerticalIcon, SortIcon */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* eslint-disable max-len */

var EGWLogo = function EGWLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "698",
    height: "446",
    viewBox: "0 0 698 446",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M418.15 145.41C419.25 156.15 420.36 166.9 421.44 177.64C421.69 180.13 422.24 182.67 421.92 185.1C421.63 187.38 420.86 190.96 419.44 191.44C417.14 192.22 413.49 191.81 411.56 190.36C403.38 184.23 397.6 176.16 394.5 166.3C388.88 148.43 388.08 130.3 391.98 112.04C399.66 76.0801 413.67 43.2301 438.09 15.0501C451.03 0.120054 467.22 -1.58995 484.66 1.00005C493.18 2.26005 499.47 8.18005 503.93 15.7301C510.44 26.7501 513.14 38.8601 514.29 51.4001C515.28 62.1701 515.81 72.9901 516.9 83.7601C517.21 86.8601 518.76 89.8401 519.74 92.8801C522.24 91.0601 525.55 89.77 527.1 87.34C534.51 75.8 541.62 64.0701 548.47 52.1901C552.41 45.3501 555.53 38.0301 559.26 31.0601C560.82 28.1501 562.63 25.1701 565.03 22.9901C567.25 20.9601 570.36 18.9701 573.13 18.9001C574.47 18.8601 576.93 23.1601 577.17 25.6501C578.01 34.7101 578.99 43.9101 578.36 52.9401C576.64 77.4201 574.02 101.83 571.95 126.28C570.44 144.1 569.21 161.95 567.86 179.79C567.77 181.04 567.29 182.37 567.58 183.51C568.46 186.98 569.63 190.37 570.69 193.79C572.71 191.33 575.28 189.15 576.67 186.38C585.82 168.13 594.29 149.37 608.21 134.16C614.56 127.22 622.1 120.77 630.28 116.21C647.81 106.43 668.03 110.73 680.99 126.08C690.25 137.05 697.72 149.03 697.19 164.26C696.82 174.83 692.56 178.14 684.09 172.04C664.52 157.94 642.24 166.56 626.4 181.28C607.1 199.21 592.83 220.71 582.9 244.71C570.82 273.91 560.34 303.79 549.46 333.47C538.43 363.56 527.81 393.81 516.84 423.93C514.85 429.38 512.47 434.82 509.38 439.69C507.89 442.04 504.37 444.16 501.67 444.28C500 444.35 496.9 440.63 496.62 438.34C495.66 430.57 494.43 422.5 495.53 414.86C501.78 371.22 508.9 327.71 515.26 284.09C518.8 259.82 521.6 235.43 524.38 211.05C525.94 197.42 526.82 183.7 527.88 170.01C528.1 167.16 528.08 164.19 527.46 161.44C527.3 160.71 523.55 159.75 523.04 160.32C520.85 162.76 519.06 165.62 517.47 168.52C497.34 205.26 484.03 244.68 472.07 284.62C463.6 312.93 455.94 341.5 446.55 369.5C441.02 386 433.49 401.95 425.56 417.48C421.49 425.45 415.3 432.74 408.73 438.93C400.47 446.71 390.85 442.88 390.47 431.52C390.14 421.69 391.36 411.47 393.91 401.95C408.44 347.68 423.48 293.54 438.53 239.41C450.46 196.5 463.34 153.75 468.12 109.32C470.2 89.9701 469.05 70.2601 469.23 50.7101C469.25 48.6901 468.62 46.5601 467.88 44.6501C465.25 37.9001 460.74 36.2201 455.42 40.8801C450.79 44.9401 446.49 49.7501 443.31 55.0001C426.5 82.7001 418.01 112.78 418.15 145.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.92 62.53C226.79 94.2 213.81 119.66 189.99 139.9C189.04 140.71 187.99 141.39 187 142.16C170.03 155.32 169.71 155.46 178.64 175.11C182.88 184.44 179.57 190.7 173.42 197.39C159.66 212.4 145.43 227.12 133.08 243.25C116.25 265.23 103.98 290.09 97.2899 316.94C94.1499 329.55 94.9399 343.26 94.9299 356.48C94.9299 361.21 97.3899 366.14 99.4899 370.62C101.54 374.99 103.59 380.72 109.86 379.71C115.88 378.74 114.99 372.73 115.53 368.49C117.16 355.71 117.76 342.79 119.74 330.07C123.78 304.12 131.91 279.92 151.9 261.3C161.79 252.1 172.95 246.88 186.83 247.51C200.11 248.11 208.79 254.64 213.4 266.63C219.12 281.48 219.16 297.08 215.74 312.18C207.96 346.61 190.82 375.48 161.81 396.54C159.45 398.25 157.04 399.91 154.84 401.81C151.15 405 150.52 408.92 153.26 412.93C155.85 416.73 159.65 418.6 164.08 416.58C168.22 414.7 172.12 412.23 175.95 409.76C180.49 406.82 184.55 402.97 189.37 400.71C192.77 399.12 198.21 397.85 200.71 399.5C203.25 401.18 204.38 406.66 204.27 410.41C203.52 434.21 178.78 451 156.15 443.28C145.29 439.57 135.78 433.42 128.6 424.52C122.42 416.86 116.01 414.1 105.88 416.48C84.8399 421.42 62.1399 409 50.3899 386.98C38.8599 365.38 35.7499 342.11 38.1399 317.96C42.9699 269.08 67.3799 229.27 96.7299 191.79C101.34 185.9 106.59 180.5 111.24 174.64C112.62 172.9 112.98 170.35 113.8 168.17C111.23 167.32 108.48 165.41 106.13 165.81C94.8299 167.76 84.6499 172.59 76.2099 180.4C46.9199 207.51 28.7499 240.11 27.1799 280.83C26.9699 286.4 28.2799 293.13 20.4499 295.17C14.5099 296.71 9.16993 293.56 5.50993 284.69C2.68993 277.88 -0.0600706 270.35 -0.0100706 263.15C0.229929 225.52 10.4499 191.65 39.9699 165.9C53.3399 154.23 68.7899 146.24 85.4099 140.35C90.1199 138.68 94.8399 136.99 99.6599 135.73C107.48 133.69 111.45 128.98 112.42 120.85C113.56 111.37 115.19 101.9 117.3 92.59C123.71 64.28 136.59 39.54 158.39 19.84C183.17 -2.56 215.73 6.84 224.33 39.22C226.36 46.76 226.77 54.74 227.92 62.53ZM182.32 301.38C182.32 297.16 182.5 295.47 182.29 293.84C181.2 285.21 176.34 283 169.73 288.62C165.68 292.07 161.17 296.02 159.25 300.72C153.62 314.48 148.78 328.6 144.47 342.83C142.71 348.66 142.6 355.15 142.77 361.31C142.85 364.17 144.79 368.45 146.98 369.33C148.93 370.11 152.51 367.24 155.16 365.63C156.52 364.81 157.45 363.25 158.51 361.98C173.76 343.69 179.23 321.69 182.32 301.38ZM197.74 66.75C197.2 60.58 198.8 53.61 192.09 50.94C185.37 48.26 181.57 54.28 177.61 58.34C175.02 60.99 172.93 64.17 170.87 67.27C162.69 79.62 158.2 93.44 155.74 107.88C155.19 111.14 155.71 115.77 157.7 118.03C161.15 121.94 165.53 118.92 168.86 116.53C186.05 104.17 195.52 87.29 197.74 66.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.39 373.75C233.63 356.21 237.63 340.13 244.39 324.74C246.36 320.26 249.09 315.79 252.51 312.34C259.84 304.94 267.18 307 270.07 317.2C271.16 321.04 271.41 325.57 270.5 329.43C267.84 340.74 264.2 351.82 261.35 363.1C259.53 370.3 257.42 377.67 257.35 384.99C257.3 390.49 259.29 396.6 262.11 401.42C267.93 411.4 278.62 413.57 287.79 406.59C292.59 402.94 296.78 397.8 299.69 392.47C316.89 360.98 325.96 326.99 329.6 291.44C330.36 284 331.22 276.54 331.47 269.07C331.73 261.07 329.16 259.18 321.63 262.48C309.22 267.93 296.59 271.03 282.91 270.5C265.33 269.82 252.27 261.84 245.32 246.12C241.03 236.42 239.22 225.53 237.12 215.01C235.66 207.71 235.9 200.08 234.82 192.68C233.84 185.96 231.79 184.97 225.59 187.01C210.35 192.02 208.91 190.73 208.81 174.75C208.74 162.8 213.76 154.57 224.92 150.82C235.3 147.32 239.8 139.74 242.32 129.88C249.81 100.56 261.04 72.9101 280.41 49.2301C292.6 34.3201 306.14 20.6201 323.57 11.9401C331.63 7.9301 340.58 4.7901 349.45 3.5301C368.82 0.790096 382.42 12.6001 384.32 32.1301C385.99 49.3501 381.72 65.1301 372.96 79.8601C361.94 98.3901 346.98 113.36 330.36 126.75C321.61 133.8 312.18 140.02 303.62 147.28C287.83 160.67 285.49 174.99 295.43 192.81C301.49 203.66 309.54 206.97 321.54 203.57C336.35 199.37 348.3 190.35 359.85 180.74C372.89 169.89 375.93 170.41 378.21 186.66C386.93 248.95 385.41 310.33 359.32 369.04C349.07 392.11 335.33 412.82 316.14 429.57C305.23 439.09 293.49 445.28 278.07 445.56C260.29 445.89 249.42 436.32 243.07 420.75C236.94 405.64 233.45 389.75 234.39 373.75ZM356.98 56.4601C356.64 43.4601 350 38.7901 341.12 43.6201C333.9 47.5401 327 52.5401 321.03 58.2001C306.13 72.3201 297.87 90.4401 292.57 109.95C291.93 112.31 293.09 115.45 294.26 117.81C294.59 118.48 298.36 118.35 299.8 117.42C319.38 104.74 338.87 91.8101 351.15 71.1401C354.24 65.9201 355.71 59.7401 356.98 56.4601Z"
  }));
};
var BookCircle = function BookCircle(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: "60",
    height: "60",
    viewBox: "0 0 60 60"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M30 5C34.9445 5 39.778 6.46622 43.8893 9.21326C48.0005 11.9603 51.2048 15.8648 53.097 20.4329C54.9892 25.0011 55.4843 30.0277 54.5196 34.8773C53.555 39.7268 51.174 44.1814 47.6777 47.6777C44.1814 51.174 39.7268 53.555 34.8773 54.5196C30.0277 55.4843 25.0011 54.9892 20.4329 53.097C15.8648 51.2048 11.9603 48.0005 9.21327 43.8893C6.46624 39.778 5.00001 34.9445 5.00001 30C5.00001 23.3696 7.63393 17.0107 12.3223 12.3223C17.0108 7.63392 23.3696 5 30 5V5ZM30 60C24.0666 60 18.2664 58.2405 13.3329 54.9441C8.39943 51.6476 4.55426 46.9623 2.28363 41.4805C0.0129986 35.9987 -0.581102 29.9667 0.576455 24.1473C1.73401 18.3279 4.59123 12.9824 8.78681 8.78679C12.9824 4.59122 18.3279 1.734 24.1473 0.57644C29.9667 -0.581117 35.9987 0.0129833 41.4805 2.28361C46.9623 4.55424 51.6477 8.39942 54.9441 13.3329C58.2405 18.2664 60 24.0666 60 30C60 37.9565 56.8393 45.5871 51.2132 51.2132C45.5871 56.8393 37.9565 60 30 60ZM30 2C24.4621 2 19.0486 3.64217 14.444 6.71885C9.83947 9.79553 6.25064 14.1685 4.13139 19.2849C2.01213 24.4012 1.45764 30.0311 2.53803 35.4625C3.61841 40.894 6.28515 45.8831 10.201 49.799C14.1169 53.7149 19.106 56.3816 24.5375 57.462C29.969 58.5424 35.5988 57.9879 40.7152 55.8686C45.8315 53.7494 50.2045 50.1605 53.2812 45.556C56.3578 40.9514 58 35.5379 58 30C58 22.5739 55.05 15.452 49.799 10.201C44.548 4.94999 37.4261 2 30 2V2Z"
  }));
};
var CloseIcon = function CloseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 8.41535L16.0873 2.32839C16.5249 1.89054 17.2345 1.89054 17.6719 2.32839C18.1093 2.76584 18.1093 3.47536 17.6719 3.91278L11.5844 10.0001L17.6717 16.0872C18.1092 16.5249 18.1092 17.2343 17.6717 17.6718C17.2343 18.1094 16.5247 18.1094 16.0871 17.6718L9.99987 11.5846L3.9127 17.6716C3.47507 18.1095 2.76552 18.1095 2.32809 17.6716C1.89064 17.2342 1.89064 16.5246 2.32809 16.0872L8.41562 9.99989L2.32827 3.91277C1.89081 3.47513 1.89081 2.76569 2.32827 2.32823C2.76573 1.8906 3.47525 1.8906 3.91288 2.32823L10.0001 8.41535Z"
  }));
};
var ShareIcon = function ShareIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: "22",
    height: "22",
    viewBox: "0 0 22 22"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3596 15.4L6.36276 11.8397C6.30358 11.9279 6.24032 12.0132 6.17324 12.0955C6.06489 12.2283 5.94658 12.3531 5.81943 12.4687C5.20128 13.0306 4.37418 13.3749 3.46556 13.3749C1.55465 13.3749 0 11.8542 0 9.98508C0 8.11593 1.55465 6.59525 3.46556 6.59525C4.37404 6.59525 5.20122 6.93948 5.81943 7.50121C5.95249 7.62211 6.07587 7.75309 6.1883 7.89288C6.24993 7.96951 6.30827 8.04879 6.36311 8.13051L12.3606 4.59729C12.2581 4.33541 12.1862 4.05871 12.152 3.77085C12.1372 3.64585 12.1294 3.51874 12.1294 3.38983C12.1294 1.52068 13.6841 0 15.595 0C17.5059 0 19.0606 1.52068 19.0606 3.38983C19.0606 5.25898 17.5059 6.77966 15.595 6.77966C14.6688 6.77966 13.8279 6.42145 13.2064 5.83996C13.0979 5.73842 12.996 5.63007 12.9016 5.51563C12.8197 5.41642 12.7435 5.31264 12.6732 5.20475L6.68332 8.73322C6.78912 8.99284 6.86432 9.26766 6.90247 9.5537C6.92131 9.69492 6.93111 9.83887 6.93111 9.98508C6.93111 10.131 6.92134 10.2747 6.90256 10.4157C6.86442 10.702 6.7891 10.9771 6.68298 11.2369L12.6715 14.7925C12.7472 14.6768 12.8296 14.5647 12.9193 14.4571C12.9897 14.3728 13.0647 14.2913 13.1445 14.2132C13.164 14.1941 13.1837 14.1753 13.2037 14.1567C13.8511 13.5522 14.697 13.2203 15.595 13.2203C16.5207 13.2203 17.3909 13.5729 18.0455 14.2132C18.7001 14.8532 19.0606 15.7047 19.0606 16.6102C19.0606 17.5156 18.7001 18.3671 18.0455 19.0071C17.3909 19.6475 16.5207 20 15.595 20C14.6694 20 13.7991 19.6475 13.1445 19.0071C12.4899 18.3671 12.1294 17.5156 12.1294 16.6102C12.1294 16.4816 12.137 16.3542 12.1518 16.2285C12.1854 15.9427 12.2561 15.665 12.3596 15.4ZM13.8268 15.7663L13.7568 15.9455C13.6728 16.1609 13.6294 16.384 13.6294 16.6102C13.6294 17.1072 13.8237 17.5734 14.1931 17.9345C14.564 18.2973 15.0566 18.5 15.595 18.5C16.1334 18.5 16.6257 18.2976 16.9966 17.9348C17.366 17.5737 17.5606 17.1072 17.5606 16.6102C17.5606 16.1132 17.3663 15.6469 16.9969 15.2858C16.626 14.923 16.1334 14.7203 15.595 14.7203C15.0566 14.7203 14.5643 14.9227 14.1934 15.2855C14.0974 15.3794 14.0086 15.4886 13.9264 15.6142L13.8268 15.7663ZM5.22195 9.1219L5.11756 8.96634C4.76822 8.44575 4.16219 8.09525 3.46556 8.09525C2.35166 8.09525 1.5 8.97543 1.5 9.98508C1.5 10.9947 2.35166 11.8749 3.46556 11.8749C4.16203 11.8749 4.76778 11.5246 5.11721 11.0038L5.2212 10.8489L5.29432 10.6698C5.38336 10.4518 5.43111 10.2222 5.43111 9.98508C5.43111 9.74794 5.38334 9.51795 5.29423 9.29928L5.22195 9.1219ZM13.8264 4.22681L13.9301 4.38616C14.2775 4.9196 14.8898 5.27966 15.595 5.27966C16.7089 5.27966 17.5606 4.39949 17.5606 3.38983C17.5606 2.38017 16.7089 1.5 15.595 1.5C14.4811 1.5 13.6294 2.38017 13.6294 3.38983C13.6294 3.61548 13.6737 3.8367 13.7575 4.05079L13.8264 4.22681Z"
  }));
};
var ContentIcon = function ContentIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 14H4.5C4.22386 14 4 14.2239 4 14.5C4 14.7761 4.22386 15 4.5 15H13.5C13.7761 15 14 14.7761 14 14.5C14 14.2239 13.7761 14 13.5 14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 11H7.5C7.22386 11 7 11.2239 7 11.5C7 11.7761 7.22386 12 7.5 12H13.5C13.7761 12 14 11.7761 14 11.5C14 11.2239 13.7761 11 13.5 11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 11H4.5C4.22386 11 4 11.2239 4 11.5C4 11.7761 4.22386 12 4.5 12H5.5C5.77614 12 6 11.7761 6 11.5C6 11.2239 5.77614 11 5.5 11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 8H4.5C4.22386 8 4 8.22386 4 8.5C4 8.77614 4.22386 9 4.5 9H13.5C13.7761 9 14 8.77614 14 8.5C14 8.22386 13.7761 8 13.5 8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 5H7.5C7.22386 5 7 5.22386 7 5.5C7 5.77614 7.22386 6 7.5 6H13.5C13.7761 6 14 5.77614 14 5.5C14 5.22386 13.7761 5 13.5 5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 5H4.5C4.22386 5 4 5.22386 4 5.5C4 5.77614 4.22386 6 4.5 6H5.5C5.77614 6 6 5.77614 6 5.5C6 5.22386 5.77614 5 5.5 5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.25 1C0.25 0.585786 0.585786 0.25 1 0.25H17C17.4142 0.25 17.75 0.585786 17.75 1V19C17.75 19.4142 17.4142 19.75 17 19.75H1C0.585786 19.75 0.25 19.4142 0.25 19V1ZM1.75 1.75V18.25H16.25V1.75H1.75Z"
  }));
};
var FullScreenIcon = function FullScreenIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M0 1.77778V4.44444C0 4.93536 0.397969 5.33333 0.888889 5.33333C1.37981 5.33333 1.77778 4.93536 1.77778 4.44444V1.77778H4.44444C4.93536 1.77778 5.33333 1.37981 5.33333 0.888889C5.33333 0.397969 4.93536 0 4.44444 0H1.77778C0.8 0 0 0.8 0 1.77778ZM1.77778 11.5556C1.77778 11.0646 1.37981 10.6667 0.888889 10.6667C0.397969 10.6667 0 11.0646 0 11.5556V14.2222C0 15.2 0.8 16 1.77778 16H4.44445C4.93537 16 5.33333 15.602 5.33333 15.1111C5.33333 14.6202 4.93536 14.2222 4.44445 14.2222H1.77778V11.5556ZM14.2222 14.2222H11.5556C11.0646 14.2222 10.6667 14.6202 10.6667 15.1111C10.6667 15.602 11.0646 16 11.5556 16H14.2222C15.2 16 16 15.2 16 14.2222V11.5556C16 11.0646 15.602 10.6667 15.1111 10.6667C14.6202 10.6667 14.2222 11.0646 14.2222 11.5556V14.2222ZM14.2222 0H11.5556C11.0646 0 10.6667 0.397969 10.6667 0.888889C10.6667 1.37981 11.0646 1.77778 11.5556 1.77778H14.2222V4.44445C14.2222 4.93537 14.6202 5.33333 15.1111 5.33333C15.602 5.33333 16 4.93536 16 4.44445V1.77778C16 0.8 15.2 0 14.2222 0Z"
  }));
};
var SubscribeIcon = function SubscribeIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: "22",
    height: "20",
    viewBox: "0 0 22 20"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M21.133 14.9C21.233 14.4 20.333 14.3 19.233 14C18.233 13.7 17.333 13.4 17.333 13.4C17.533 13.4 18.233 13.5 19.133 13.5C19.333 13.5 19.633 13.5 19.833 13.5C20.933 13.4 21.333 13.1 20.433 12.9C19.533 12.8 17.633 12.7 15.633 12C15.333 11.9 15.033 11.7 14.733 11.6C14.933 11.6 15.033 11.5 15.133 11.4C15.633 11 15.133 10.8 15.133 10.8C15.133 10.8 16.033 10.7 16.533 10.4C17.033 10.1 16.533 9.7 16.533 9.7C16.533 9.7 17.433 9.6 17.833 9.1C18.233 8.6 17.833 8.4 17.833 8.4C18.333 8.2 18.833 7.7 18.833 7.3C18.833 7 18.433 6.9 18.333 6.9C18.333 6.9 18.533 6.9 18.733 6.6C19.033 6.3 19.133 5.9 19.033 5.7C18.933 5.6 18.833 5.6 18.833 5.6C18.733 5.6 18.733 5.6 18.633 5.6C18.633 5.6 18.733 5.5 18.933 5.1C19.133 4.6 19.133 4.2 18.933 4.2C18.733 4.2 18.533 4.4 18.533 4.4C18.533 4.4 18.533 4.3 18.733 3.8C18.933 3.1 18.933 2.7 18.733 2.7C18.533 2.7 18.233 3 18.233 3C18.233 3 18.333 1.4 18.033 1.4C18.033 1.6 17.833 1.9 17.833 1.9C17.833 0.9 17.333 0 17.133 0C17.033 0 17.033 0.2 17.133 0.7C17.333 2.3 16.133 4.7 13.733 6.2C13.733 6.1 13.833 6.1 13.833 6C13.933 5.6 13.833 5.4 13.733 5.3C13.733 5.3 13.733 5.3 13.633 5.3C13.533 5.3 13.433 5.4 13.433 5.4C13.433 5.4 13.433 5.4 13.433 4.9C13.433 4.6 13.233 4.3 13.133 4.3C12.933 4.4 12.833 4.6 12.833 4.6C12.833 4.6 12.833 4.5 12.733 4.1C12.633 3.7 12.433 3.4 12.333 3.4C12.233 3.6 12.033 4 12.033 4C12.033 4 12.033 3.9 11.933 3.6C11.833 3.3 11.633 3 11.433 3C11.433 3 11.333 3 11.333 3.1C11.233 3.2 11.233 3.5 11.233 3.5C10.833 2.9 10.333 2.5 10.033 2.5H9.93301C9.83301 2.5 9.93301 2.7 10.133 3C10.833 3.9 11.033 6 10.133 7.8C9.43301 7 8.83301 6.8 8.33301 6.8C8.13301 6.8 7.93301 6.9 7.63301 6.9C7.03301 7.1 6.93301 7.7 6.83301 8C6.73301 8.1 6.43301 8.3 6.33301 8.4C6.33301 8.4 6.63301 8.4 6.93301 8.5C7.13301 8.9 7.53301 9.2 7.53301 9.2C7.53301 9.2 7.63301 9.8 7.73301 10.7C7.73301 11.1 7.93301 11.6 8.23301 12.1H5.23301H0.833008V13.4V20H11.933V14.1C12.233 14.1 12.433 14.1 12.633 14.1C13.233 14.1 13.733 14 13.933 14C14.033 14 14.133 14 14.133 14C14.233 14.1 16.933 17.4 17.233 17.7C17.333 17.9 17.633 18 17.733 18C17.933 18 18.033 17.9 18.033 17.6C17.933 17 16.833 15.6 16.833 15.6C16.833 15.6 17.733 16.4 18.233 16.8C18.433 17 18.833 17.1 19.033 17.1C19.233 17.1 19.233 17 19.133 16.8C18.833 16.2 18.333 15.6 18.333 15.6C18.333 15.6 19.133 16 20.033 16.3C20.233 16.4 20.433 16.5 20.533 16.5C20.833 16.5 20.933 16.2 20.733 16.1C20.333 15.6 18.533 14.9 18.533 14.9C18.833 15 19.733 15.1 20.333 15.1C20.833 15.1 21.133 15.1 21.133 14.9ZM1.83301 13.1H10.633L6.33301 16.4L1.83301 13.1ZM1.83301 19V14.4L6.33301 17.7L10.833 14.2V19H1.83301ZM17.733 14.6C17.733 14.7 17.633 14.9 17.733 15C17.633 15 17.633 14.9 17.633 14.9C17.433 14.7 17.233 14.7 16.933 14.7C16.733 14.7 16.433 14.8 16.233 15C16.133 14.9 16.033 14.7 15.933 14.6C15.033 13.6 15.033 13.5 14.933 13.4C14.833 13.3 14.733 13.3 14.633 13.2C14.433 13.1 14.133 13.1 13.933 13.1C13.833 13.1 13.633 13.1 13.433 13.1C13.233 13.1 12.933 13.1 12.533 13.1C12.333 13.1 12.133 13.1 11.833 13.1H11.733V13V12H9.33301C9.33301 11.8 9.23301 11.6 9.13301 11.5C8.83301 11 8.83301 10.7 8.83301 10.7V10.6C8.63301 9.6 8.53301 9 8.53301 9C8.53301 8.7 8.33301 8.5 8.13301 8.3C8.13301 8.3 7.93301 8.2 7.93301 8.1C8.03301 7.9 8.03301 7.9 8.13301 7.9H8.23301C8.33301 7.8 8.43301 7.8 8.53301 7.8C8.83301 7.8 9.33301 8.2 9.63301 8.5C9.83301 8.7 10.133 8.8 10.333 8.8C10.433 8.8 10.433 8.8 10.433 8.8C10.733 8.8 11.033 8.6 11.233 8.3C11.733 7.3 12.033 6.2 11.933 5.2C12.033 5.4 12.133 5.5 12.333 5.6C12.333 5.8 12.433 6 12.633 6.2C12.633 6.2 12.633 6.2 12.633 6.3C12.633 6.7 12.833 7 13.133 7.2C13.233 7.3 13.433 7.3 13.633 7.3C13.833 7.3 14.033 7.2 14.133 7.1C15.633 6.2 16.733 4.9 17.433 3.6C17.533 3.8 17.633 3.9 17.733 4C17.533 4.4 17.533 4.8 17.733 5.1L17.833 5.2C17.833 5.4 17.833 5.6 17.833 5.9C17.833 6 17.933 6.1 17.933 6.2C17.633 6.4 17.533 6.7 17.533 7C17.533 7.2 17.633 7.4 17.733 7.5C17.333 7.6 17.133 8 17.033 8.4C17.033 8.5 17.033 8.5 17.033 8.6C16.933 8.7 16.733 8.7 16.633 8.7C16.233 8.7 15.833 9 15.733 9.4C15.733 9.5 15.733 9.6 15.733 9.7C15.533 9.7 15.333 9.8 15.233 9.8C14.733 9.9 14.433 10.2 14.333 10.7V10.8C14.033 11 13.833 11.2 13.833 11.5C13.733 12 14.033 12.5 14.533 12.6C14.633 12.6 14.733 12.7 14.833 12.7C15.033 12.8 15.233 12.9 15.433 12.9C15.733 13 16.133 13.1 16.433 13.2C16.333 13.7 16.633 14.1 17.133 14.3C17.133 14.4 17.333 14.5 17.733 14.6Z"
  }));
};
var CheckNoIcon = function CheckNoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12",
    height: "12",
    viewBox: "0 0 12 12"
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: "1",
    y: "1",
    width: "10",
    height: "10",
    strokeWidth: "1",
    stroke: "#9F9F9F",
    fill: "none"
  }));
};
var DotsVerticalIcon = function DotsVerticalIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("ellipse", {
    cx: "10.0001",
    cy: "16.6667",
    rx: "2.38095",
    ry: "2.38095",
    transform: "rotate(-90 10.0001 16.6667)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "10.0001",
    cy: "10",
    r: "2.38095",
    transform: "rotate(-90 10.0001 10)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: "10.0001",
    cy: "3.33328",
    rx: "2.38095",
    ry: "2.38095",
    transform: "rotate(-90 10.0001 3.33328)"
  }));
};
var SortIcon = function SortIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14.7475 18.5C14.6475 18.5 14.5475 18.48 14.4575 18.44C14.3675 18.4 14.2875 18.35 14.2175 18.28L10.2175 14.28C9.9275 13.99 9.9275 13.51 10.2175 13.22C10.5075 12.93 10.9875 12.93 11.2775 13.22L13.9975 15.94V1.75C13.9975 1.34 14.3375 1 14.7475 1C15.1575 1 15.4975 1.34 15.4975 1.75V15.94L18.2175 13.22C18.5075 12.93 18.9875 12.93 19.2775 13.22C19.5675 13.51 19.5675 13.99 19.2775 14.28L15.2775 18.28C15.2075 18.35 15.1275 18.41 15.0375 18.44C14.9475 18.48 14.8475 18.5 14.7475 18.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.7475 18.4999C5.3375 18.4999 4.9975 18.1599 4.9975 17.7499V3.55995L2.2775 6.27995C1.9875 6.56995 1.5075 6.56995 1.2175 6.27995C0.9275 5.98995 0.9275 5.50995 1.2175 5.21995L5.2175 1.21995C5.2875 1.14995 5.3675 1.08995 5.4575 1.05995C5.6375 0.989946 5.8575 0.989946 6.0375 1.05995C6.1275 1.09995 6.2075 1.14995 6.2775 1.21995L10.2775 5.21995C10.5675 5.50995 10.5675 5.98995 10.2775 6.27995C9.9875 6.56995 9.5075 6.56995 9.2175 6.27995L6.4975 3.55995V17.7499C6.4975 18.1599 6.1575 18.4999 5.7475 18.4999Z"
  }));
};
var ThemeDayIcon = function ThemeDayIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: "28",
    height: "28",
    viewBox: "0 0 28 28",
    fill: "none"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
    cx: "14",
    cy: "14",
    r: "13",
    fill: "white"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M28 14C28 6.26816 21.7318 0 14 0C6.26816 0 0 6.26816 0 14C0 21.7318 6.26816 28 14 28C21.7318 28 28 21.7318 28 14ZM1.27272 14C1.27272 6.97072 6.97072 1.27272 14 1.27272C21.0293 1.27272 26.7273 6.97072 26.7273 14C26.7273 21.0293 21.0293 26.7273 14 26.7273C6.97072 26.7273 1.27272 21.0293 1.27272 14Z",
    fill: "#9F9F9F"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M8.7793 19.0002H11.2153C12.7553 19.0002 13.5113 18.1462 13.5113 16.5782V11.6222C13.5113 10.0542 12.7553 9.2002 11.2153 9.2002H8.7793V19.0002ZM11.1873 10.6002C11.6773 10.6002 11.9713 10.8522 11.9713 11.5522V16.6482C11.9713 17.3482 11.6773 17.6002 11.1873 17.6002H10.3193V10.6002H11.1873Z",
    fill: "#115B77"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M16.4311 19.0002H17.9711V15.7522L19.9171 9.2002H18.4471L17.2711 13.6662L16.0951 9.2002H14.4851L16.4311 15.7522V19.0002Z",
    fill: "#115B77"
  }));
};
var ThemeDawnIcon = function ThemeDawnIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: "28",
    height: "28",
    viewBox: "0 0 28 28",
    fill: "none"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
    cx: "14",
    cy: "14",
    r: "13",
    fill: "#F0E8D9"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M28 14C28 6.26816 21.7318 0 14 0C6.26816 0 0 6.26816 0 14C0 21.7318 6.26816 28 14 28C21.7318 28 28 21.7318 28 14ZM1.27272 14C1.27272 6.97072 6.97072 1.27272 14 1.27272C21.0293 1.27272 26.7273 6.97072 26.7273 14C26.7273 21.0293 21.0293 26.7273 14 26.7273C6.97072 26.7273 1.27272 21.0293 1.27272 14Z",
    fill: "#9F9F9F"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M7.50781 19.0002H9.94381C11.4838 19.0002 12.2398 18.1462 12.2398 16.5782V11.6222C12.2398 10.0542 11.4838 9.2002 9.94381 9.2002H7.50781V19.0002ZM9.91581 10.6002C10.4058 10.6002 10.6998 10.8522 10.6998 11.5522V16.6482C10.6998 17.3482 10.4058 17.6002 9.91581 17.6002H9.04781V10.6002H9.91581Z",
    fill: "#9F9F9F"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M17.8987 19.0002H19.9427L21.0347 9.2002H19.6907L18.8927 16.9842L18.1227 9.2002H16.6387L15.8967 16.9282L15.0707 9.2002H13.5727L14.6647 19.0002H16.7787L17.3387 13.7782L17.8987 19.0002Z",
    fill: "#9F9F9F"
  }));
};
var ThemeDuskIcon = function ThemeDuskIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: "28",
    height: "28",
    viewBox: "0 0 28 28",
    fill: "none"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
    cx: "14",
    cy: "14",
    r: "13",
    fill: "#565657"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 26.74C21.0361 26.74 26.74 21.0361 26.74 14C26.74 6.96389 21.0361 1.26 14 1.26C6.96389 1.26 1.26 6.96389 1.26 14C1.26 21.0361 6.96389 26.74 14 26.74ZM14 28C21.732 28 28 21.732 28 14C28 6.26801 21.732 0 14 0C6.26801 0 0 6.26801 0 14C0 21.732 6.26801 28 14 28Z",
    fill: "#9F9F9F"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M8.10547 19.0002H10.5415C12.0815 19.0002 12.8375 18.1462 12.8375 16.5782V11.6222C12.8375 10.0542 12.0815 9.2002 10.5415 9.2002H8.10547V19.0002ZM10.5135 10.6002C11.0035 10.6002 11.2975 10.8522 11.2975 11.5522V16.6482C11.2975 17.3482 11.0035 17.6002 10.5135 17.6002H9.64547V10.6002H10.5135Z",
    fill: "#E1C492"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M18.0343 19.0002H19.6163L17.4743 13.5682L19.6163 9.2002H18.0763L16.0603 13.4702V9.2002H14.5203V19.0002H16.0603V15.9902L16.5363 15.0942L18.0343 19.0002Z",
    fill: "#E1C492"
  }));
};
var ThemeDarkIcon = function ThemeDarkIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: "28",
    height: "28",
    viewBox: "0 0 28 28",
    fill: "none"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
    cx: "14",
    cy: "14",
    r: "13",
    fill: "#293243"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0617 26.7234C21.0546 26.7234 26.7234 21.0546 26.7234 14.0617C26.7234 7.06883 21.0546 1.4 14.0617 1.4C7.06883 1.4 1.4 7.06883 1.4 14.0617C1.4 21.0546 7.06883 26.7234 14.0617 26.7234ZM14.0617 28.1234C21.8278 28.1234 28.1234 21.8278 28.1234 14.0617C28.1234 6.29563 21.8278 0 14.0617 0C6.29563 0 0 6.29563 0 14.0617C0 21.8278 6.29563 28.1234 14.0617 28.1234Z",
    fill: "#9F9F9F"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M7.66602 18.9563H10.102C11.642 18.9563 12.398 18.1023 12.398 16.5343V11.5783C12.398 10.0102 11.642 9.15625 10.102 9.15625H7.66602V18.9563ZM10.074 10.5563C10.564 10.5563 10.858 10.8083 10.858 11.5083V16.6043C10.858 17.3043 10.564 17.5563 10.074 17.5563H9.20602V10.5563H10.074Z",
    fill: "#22B78A"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M16.2089 9.15625H14.0669V18.9563H15.4109V12.0263L16.5589 18.9563H18.0149L19.0789 11.9283V18.9563H20.5349V9.15625H18.3929L17.3429 16.1143L16.2089 9.15625Z",
    fill: "#22B78A"
  }));
};
var ThemeHumanWhiteIcon = function ThemeHumanWhiteIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: "28",
    height: "28",
    viewBox: "0 0 28 28",
    fill: "none"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("ellipse", {
    cx: "13.9386",
    cy: "14.0002",
    rx: "14.0617",
    ry: "14.0617",
    fill: "white"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M28 14C28 6.26816 21.7318 0 14 0C6.26816 0 0 6.26816 0 14C0 21.7318 6.26816 28 14 28C21.7318 28 28 21.7318 28 14ZM1.27272 14C1.27272 6.97072 6.97072 1.27272 14 1.27272C21.0293 1.27272 26.7273 6.97072 26.7273 14C26.7273 21.0293 21.0293 26.7273 14 26.7273C6.97072 26.7273 1.27272 21.0293 1.27272 14Z",
    fill: "#9F9F9F"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M15.889 22.3941C16.0672 22.7862 16.4237 23.0001 16.8158 23.0001C16.9584 23.0001 17.1009 22.9644 17.2435 22.8931C17.7782 22.6436 17.992 22.0377 17.7425 21.503C17.7425 21.503 15.7821 17.0118 15.4257 15.3722C15.2831 14.8019 15.2118 13.2692 15.1761 12.5563C15.1761 12.3068 15.3187 12.0929 15.5326 12.0216L19.9168 10.7028C20.4515 10.5602 20.7723 9.95427 20.6297 9.41961C20.4871 8.88495 19.8812 8.56415 19.3465 8.70672C19.3465 8.70672 15.2831 10.0256 13.8217 10.0256C12.3959 10.0256 8.3681 8.74237 8.3681 8.74237C7.83344 8.59979 7.22748 8.8493 7.04926 9.38396C6.87104 9.95427 7.19184 10.5602 7.76215 10.7028L12.1464 12.0216C12.3603 12.0929 12.5385 12.3068 12.5028 12.5563C12.4672 13.2692 12.3959 14.8019 12.2533 15.3722C11.8969 17.0118 9.93644 21.503 9.93644 21.503C9.68693 22.0377 9.93644 22.6436 10.4355 22.8931C10.578 22.9644 10.7206 23.0001 10.8632 23.0001C11.2553 23.0001 11.6474 22.7862 11.7899 22.3941L13.893 18.1168L15.889 22.3941Z",
    fill: "#115B77"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M13.8926 8.99215C14.995 8.99215 15.8886 8.09848 15.8886 6.99608C15.8886 5.89367 14.995 5 13.8926 5C12.7902 5 11.8965 5.89367 11.8965 6.99608C11.8965 8.09848 12.7902 8.99215 13.8926 8.99215Z",
    fill: "#115B77"
  }));
};
var ThemeHumanBlackIcon = function ThemeHumanBlackIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: "28",
    height: "28",
    viewBox: "0 0 28 28",
    fill: "none"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
    cx: "14",
    cy: "14",
    r: "13",
    fill: "#293243"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M28 14C28 6.26816 21.7318 0 14 0C6.26816 0 0 6.26816 0 14C0 21.7318 6.26816 28 14 28C21.7318 28 28 21.7318 28 14ZM1.27272 14C1.27272 6.97072 6.97072 1.27272 14 1.27272C21.0293 1.27272 26.7273 6.97072 26.7273 14C26.7273 21.0293 21.0293 26.7273 14 26.7273C6.97072 26.7273 1.27272 21.0293 1.27272 14Z",
    fill: "#9F9F9F"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M15.889 22.3941C16.0672 22.7862 16.4237 23.0001 16.8158 23.0001C16.9584 23.0001 17.1009 22.9644 17.2435 22.8931C17.7782 22.6436 17.992 22.0377 17.7425 21.503C17.7425 21.503 15.7821 17.0118 15.4257 15.3722C15.2831 14.8019 15.2118 13.2692 15.1761 12.5563C15.1761 12.3068 15.3187 12.0929 15.5326 12.0216L19.9168 10.7028C20.4515 10.5602 20.7723 9.95427 20.6297 9.41961C20.4871 8.88495 19.8812 8.56415 19.3465 8.70672C19.3465 8.70672 15.2831 10.0256 13.8217 10.0256C12.3959 10.0256 8.3681 8.74237 8.3681 8.74237C7.83344 8.59979 7.22748 8.8493 7.04926 9.38396C6.87104 9.95427 7.19184 10.5602 7.76215 10.7028L12.1464 12.0216C12.3603 12.0929 12.5385 12.3068 12.5028 12.5563C12.4672 13.2692 12.3959 14.8019 12.2533 15.3722C11.8969 17.0118 9.93644 21.503 9.93644 21.503C9.68693 22.0377 9.93644 22.6436 10.4355 22.8931C10.578 22.9644 10.7206 23.0001 10.8632 23.0001C11.2553 23.0001 11.6474 22.7862 11.7899 22.3941L13.893 18.1168L15.889 22.3941Z",
    fill: "white"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M13.8926 8.99215C14.995 8.99215 15.8886 8.09848 15.8886 6.99608C15.8886 5.89367 14.995 5 13.8926 5C12.7902 5 11.8965 5.89367 11.8965 6.99608C11.8965 8.09848 12.7902 8.99215 13.8926 8.99215Z",
    fill: "white"
  }));
};
var SignInIcon = function SignInIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: "80",
    height: "80",
    viewBox: "0 0 80 80"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M78.6503 69.3359H77.3172V21.3459C77.3172 18.3965 74.9344 16.0137 71.985 16.0137H59.5876C57.388 5.1993 46.8402 -1.79925 36.0092 0.400296C28.1441 1.99996 21.9954 8.14868 20.3958 16.0137H7.99833C5.04895 16.0137 2.66611 18.3965 2.66611 21.3459V69.3359H1.33306C0.599875 69.3359 0 69.9358 0 70.669V74.6682C0 77.6175 2.38284 80.0004 5.33222 80.0004H74.6511C77.6005 80.0004 79.9833 77.6175 79.9833 74.6682V70.669C79.9833 69.9358 79.3835 69.3359 78.6503 69.3359ZM27.4776 8.01538C30.7436 4.59942 35.276 2.68315 39.9917 2.68315C49.5563 2.66649 57.3047 10.4149 57.3214 19.9796C57.3214 24.7119 55.4051 29.2276 51.9892 32.4936V25.3451C51.9892 21.3959 49.1064 18.0466 45.2072 17.4467C46.1404 16.2803 46.6569 14.8306 46.6569 13.3476C46.6569 9.66503 43.6742 6.68232 39.9917 6.68232C36.3091 6.68232 33.3264 9.66503 33.3264 13.3476C33.3264 14.8473 33.8429 16.2803 34.7761 17.4467C30.8769 18.0466 27.9942 21.3959 27.9942 25.3451V32.4936C21.0956 25.8783 20.8623 14.9306 27.4776 8.01538ZM43.9908 26.6782V36.8594C41.3581 37.5092 38.6253 37.5092 35.9925 36.8594V26.6782H33.3264V36.0095C32.3933 35.6096 31.5101 35.1431 30.6603 34.5932V25.3451C30.6603 22.3957 33.0431 20.0129 35.9925 20.0129H43.9908C46.9402 20.0129 49.3231 22.3957 49.3231 25.3451V34.5932C48.4732 35.1431 47.5901 35.6096 46.6569 36.0095V26.6782H43.9908ZM35.9925 13.3476C35.9925 11.1314 37.7755 9.34843 39.9917 9.34843C42.2079 9.34843 43.9908 11.1314 43.9908 13.3476C43.9908 15.5638 42.2079 17.3468 39.9917 17.3468C37.7755 17.3468 35.9925 15.5638 35.9925 13.3476ZM27.9942 35.9762V36.0095H28.0442C35.1094 41.3418 44.874 41.3418 51.9392 36.0095H51.9892V35.9762C55.8884 33.0435 58.6045 28.7944 59.5876 24.012H69.3189V61.3376H10.6644V24.012H20.3958C21.3789 28.7944 24.095 33.0602 27.9942 35.9762ZM5.33222 21.3459C5.33222 19.8796 6.53197 18.6798 7.99833 18.6798H20.0625C20.0292 19.1297 19.9958 19.563 19.9958 20.0129C19.9958 20.4628 20.0292 20.896 20.0625 21.3459H9.33139C8.59821 21.3459 7.99833 21.9458 7.99833 22.679V62.6707C7.99833 63.4038 8.59821 64.0037 9.33139 64.0037H70.6519C71.3851 64.0037 71.985 63.4038 71.985 62.6707V22.679C71.985 21.9458 71.3851 21.3459 70.6519 21.3459H59.9209C59.9542 20.896 59.9875 20.4628 59.9875 20.0129C59.9875 19.563 59.9542 19.1297 59.9209 18.6798H71.985C73.4514 18.6798 74.6511 19.8796 74.6511 21.3459V69.3359H51.9892C51.6392 69.3359 51.2893 69.4692 51.0394 69.7192L48.7565 72.002H31.2102L28.9273 69.7192C28.6774 69.4692 28.3441 69.3359 27.9775 69.3359H5.33222V21.3459ZM77.3172 74.6682C77.3172 76.1345 76.1175 77.3343 74.6511 77.3343H5.33222C3.86586 77.3343 2.66611 76.1345 2.66611 74.6682V72.002H27.4443L29.7271 74.2849C29.9771 74.5349 30.3104 74.6682 30.6769 74.6682H49.3397C49.6896 74.6682 50.0396 74.5349 50.2895 74.2849L52.5724 72.002H77.3172V74.6682Z"
  }));
};
var ChevronDoubleLeftIcon = function ChevronDoubleLeftIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M3.32814 10.7921L10.2079 17.6716C10.6455 18.1095 11.3551 18.1095 11.7925 17.6716C12.23 17.2342 12.23 16.5246 11.7925 16.0872L5.70499 9.99989L11.7923 3.91276C12.2298 3.47513 12.2298 2.76568 11.7923 2.32823C11.3549 1.89059 10.6454 1.89059 10.2077 2.32823L3.32796 9.20786C3.10924 9.4267 2.99999 9.7132 2.99999 9.99985C2.99999 10.2866 3.10945 10.5734 3.32814 10.7921Z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M8.66164 10.7921L15.5414 17.6716C15.979 18.1095 16.6886 18.1095 17.126 17.6716C17.5635 17.2342 17.5635 16.5246 17.126 16.0872L11.0385 9.99989L17.1258 3.91276C17.5633 3.47513 17.5633 2.76568 17.1258 2.32823C16.6884 1.89059 15.9789 1.89059 15.5412 2.32823L8.66146 9.20786C8.44273 9.4267 8.33349 9.7132 8.33349 9.99985C8.33349 10.2866 8.44294 10.5734 8.66164 10.7921Z"
  }));
};
var ChevronLeftIcon = function ChevronLeftIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M5.20754 10.7921L12.0873 17.6716C12.5249 18.1095 13.2345 18.1095 13.6719 17.6716C14.1094 17.2342 14.1094 16.5246 13.6719 16.0872L7.58438 9.99989L13.6717 3.91276C14.1092 3.47513 14.1092 2.76568 13.6717 2.32823C13.2343 1.89059 12.5248 1.89059 12.0871 2.32823L5.20736 9.20786C4.98863 9.4267 4.87939 9.7132 4.87939 9.99985C4.87939 10.2866 4.98884 10.5734 5.20754 10.7921Z"
  }));
};
var ChevronRightIcon = function ChevronRightIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M13.7925 10.7921L6.9127 17.6716C6.47507 18.1095 5.76552 18.1095 5.32809 17.6716C4.89064 17.2342 4.89064 16.5246 5.32809 16.0872L11.4156 9.99988L5.32827 3.91276C4.89081 3.47513 4.89081 2.76568 5.32827 2.32823C5.76573 1.89059 6.47525 1.89059 6.91288 2.32823L13.7926 9.20786C14.0114 9.4267 14.1206 9.7132 14.1206 9.99985C14.1206 10.2866 14.0112 10.5734 13.7925 10.7921Z"
  }));
};
var ChevronDoubleRightIcon = function ChevronDoubleRightIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M16.9326 10.7921L10.0528 17.6716C9.61521 18.1095 8.90565 18.1095 8.46823 17.6716C8.03077 17.2342 8.03077 16.5246 8.46823 16.0872L14.5558 9.99989L8.46841 3.91276C8.03095 3.47513 8.03095 2.76568 8.46841 2.32823C8.90587 1.89059 9.61538 1.89059 10.053 2.32823L16.9328 9.20786C17.1515 9.4267 17.2607 9.7132 17.2607 9.99985C17.2607 10.2866 17.1513 10.5734 16.9326 10.7921Z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M11.5991 10.7921L4.71935 17.6716C4.28171 18.1095 3.57216 18.1095 3.13473 17.6716C2.69728 17.2342 2.69728 16.5246 3.13473 16.0872L9.22226 9.99989L3.13491 3.91276C2.69745 3.47513 2.69745 2.76568 3.13491 2.32823C3.57237 1.89059 4.28189 1.89059 4.71952 2.32823L11.5993 9.20786C11.818 9.4267 11.9273 9.7132 11.9273 9.99985C11.9273 10.2866 11.8178 10.5734 11.5991 10.7921Z"
  }));
};
var GoogleTranslateIcon = function GoogleTranslateIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M20 10C20 4.47725 15.5227 0 10 0C4.47725 0 0 4.47725 0 10C0 15.5227 4.47725 20 10 20C15.5227 20 20 15.5227 20 10ZM0.909085 10C0.909085 4.97909 4.97909 0.909085 10 0.909085C15.0209 0.909085 19.0909 4.97909 19.0909 10C19.0909 15.0209 15.0209 19.0909 10 19.0909C4.97909 19.0909 0.909085 15.0209 0.909085 10Z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M5.09044 4C4.48578 4 4 4.48578 4 5.09044V12.7261C4 13.3321 4.48578 13.8178 5.09044 13.8178H11.6357L8.36305 4H5.09044ZM10.1847 6.18217L10.5452 7.27261H14.9083V14.9083H10.2065L10.5606 15.9987H14.9083C15.5142 15.9987 15.9987 15.5129 15.9987 14.9083V7.27261C15.9987 6.66667 15.5129 6.18217 14.9083 6.18217H10.1847ZM7.30585 6.67817C7.9054 6.67817 8.41291 6.89677 8.79003 7.27261L8.17897 7.83381C8.02045 7.6753 7.74816 7.49505 7.30585 7.49505C6.54778 7.49505 5.94183 8.11633 5.94183 8.8744C5.94183 9.63247 6.54778 10.2704 7.30585 10.2704C8.1892 10.2704 8.50623 9.63247 8.57143 9.31544H7.30585V8.56759H9.38958C9.41643 8.69287 9.42282 8.7798 9.42282 8.93832C9.42282 10.2039 8.57143 11.0872 7.30713 11.0872C6.08757 11.0898 5.09556 10.1042 5.093 8.88335C5.093 8.87951 5.093 8.87568 5.093 8.87184C5.09044 7.64334 6.07862 6.67817 7.30585 6.67817ZM12.1815 8.90892V9.45478H11.2764L11.4516 10.0006H13.2732C13.1262 10.333 13.0713 10.6385 12.6238 11.1627C12.4052 10.9057 12.2314 10.6833 12.1815 10.5465H11.6357C11.7009 10.7804 11.9744 11.1461 12.3017 11.5168C12.2314 11.5871 12.1329 11.6804 12.0447 11.7571L12.1969 12.2148C12.3337 12.0946 12.4692 11.9693 12.6059 11.844C13.162 12.4283 13.7514 12.9677 13.7514 12.9677L14.0569 12.6405C14.0569 12.6405 13.4727 12.0678 12.9498 11.5002C13.2937 11.1179 13.5992 10.6552 13.8166 10.0006H14.3624V9.45478H12.7261V8.90892H12.1815Z"
  }));
};

/***/ }),

/***/ 98861:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60042);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Accordion_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97476);
/* harmony import */ var _Accordion_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Accordion_module_scss__WEBPACK_IMPORTED_MODULE_3__);





var Accordion = function Accordion(_ref) {
  var head = _ref.head,
      body = _ref.body,
      className = _ref.className,
      _ref$isOpenByDefault = _ref.isOpenByDefault,
      isOpenByDefault = _ref$isOpenByDefault === void 0 ? false : _ref$isOpenByDefault,
      children = _ref.children;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("details", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Accordion_module_scss__WEBPACK_IMPORTED_MODULE_3___default().accordion), className),
    open: isOpenByDefault
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("summary", null, head), body !== null && body !== void 0 ? body : children);
};

Accordion.propTypes = {
  head: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().node),
  body: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().node),
  className: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
  isOpenByDefault: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool)
};
/* harmony default export */ __webpack_exports__["Z"] = (Accordion);

/***/ }),

/***/ 97855:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34412);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79894);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60042);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(65218);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _utils_routes_routes__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69994);
/* harmony import */ var _components_index__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(78239);
/* harmony import */ var _shared_store_mainTree_selectors__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47725);
/* harmony import */ var _book_list_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(60219);
/* harmony import */ var _book_list_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_book_list_module_scss__WEBPACK_IMPORTED_MODULE_9__);










var BookCover = next_dynamic__WEBPACK_IMPORTED_MODULE_5___default()(function () {
  return __webpack_require__.e(/* import() */ 657).then(__webpack_require__.bind(__webpack_require__, 33657));
}, {
  ssr: false
});

var BookList = function BookList(_ref) {
  var items = _ref.items,
      isGridView = _ref.isGridView,
      isShowTitle = _ref.isShowTitle,
      isShowTitlesAsLabels = _ref.isShowTitlesAsLabels,
      className = _ref.className,
      onClickItem = _ref.onClickItem;
  var langMap = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_shared_store_mainTree_selectors__WEBPACK_IMPORTED_MODULE_8__/* .selectorMainTreeLangMap */ .Qu);
  var showTitle = isShowTitle && isGridView && langMap;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_4___default()((_book_list_module_scss__WEBPACK_IMPORTED_MODULE_9___default()["book-list"]), className, isGridView ? (_book_list_module_scss__WEBPACK_IMPORTED_MODULE_9___default().grid) : (_book_list_module_scss__WEBPACK_IMPORTED_MODULE_9___default().list))
  }, items.map(function (item, key) {
    var href = (0,_utils_routes_routes__WEBPACK_IMPORTED_MODULE_6__/* .makeBookUrl */ .Q_)(item.id);
    var Wrapper = showTitle ? "div" : react__WEBPACK_IMPORTED_MODULE_0__.Fragment; // TODO: Fast-implementing, pls refactor.

    var view = onClickItem ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      className: (_book_list_module_scss__WEBPACK_IMPORTED_MODULE_9___default()["book-list-item__image"]),
      onClick: function onClick() {
        return onClickItem(item);
      }
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(BookCover, {
      className: (_book_list_module_scss__WEBPACK_IMPORTED_MODULE_9___default()["book-list-item__cover"]),
      book: item
    })) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
      className: (_book_list_module_scss__WEBPACK_IMPORTED_MODULE_9___default()["book-list-item__image"]),
      href: href
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(BookCover, {
      className: (_book_list_module_scss__WEBPACK_IMPORTED_MODULE_9___default()["book-list-item__cover"]),
      book: item
    }));
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, {
      key: key,
      className: (_book_list_module_scss__WEBPACK_IMPORTED_MODULE_9___default()["book-wrapper"])
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      className: (_book_list_module_scss__WEBPACK_IMPORTED_MODULE_9___default()["book-list-item"])
    }, isGridView && view, !isGridView && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, view, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
      key: key,
      href: href,
      className: (_book_list_module_scss__WEBPACK_IMPORTED_MODULE_9___default()["book-list-item-title"])
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, item.title)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      className: (_book_list_module_scss__WEBPACK_IMPORTED_MODULE_9___default()["book-list-item-code"])
    }, item.code))), showTitle && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_index__WEBPACK_IMPORTED_MODULE_7__/* .Typography */ .ZT, {
      align: "center",
      variant: "body3",
      clamp: 2,
      color: "default"
    }, isShowTitlesAsLabels ? item.title : langMap[item.lang]));
  }));
};

BookList.propTypes = {
  items: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().array),
  isGridView: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().bool),
  isShowTitle: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().bool),
  onClickItem: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().func),
  className: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string)
};
/* harmony default export */ __webpack_exports__["Z"] = (BookList);

/***/ }),

/***/ 89566:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Breadcrumbs_BreadcrumbsHeader; }
});

// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__(23615);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./src/next/components/TopPanel/TopPanel.js
var TopPanel = __webpack_require__(53743);
// EXTERNAL MODULE: ../node_modules/classnames/index.js
var classnames = __webpack_require__(60042);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../shared/contexts/TranslateContext.js
var TranslateContext = __webpack_require__(48081);
// EXTERNAL MODULE: ../shared/components/Typography/Typography.js
var Typography = __webpack_require__(21766);
// EXTERNAL MODULE: ../shared/components/IconView/IconView.js
var IconView = __webpack_require__(20844);
// EXTERNAL MODULE: ../shared/utils/content/content.js
var content = __webpack_require__(69051);
// EXTERNAL MODULE: ../shared/assets/EgwWebFont.js
var EgwWebFont = __webpack_require__(59034);
// EXTERNAL MODULE: ../shared/components/Breadcrumbs/BreadcrumbsButtonGoBack.module.scss
var BreadcrumbsButtonGoBack_module = __webpack_require__(84353);
var BreadcrumbsButtonGoBack_module_default = /*#__PURE__*/__webpack_require__.n(BreadcrumbsButtonGoBack_module);
;// CONCATENATED MODULE: ../shared/components/Breadcrumbs/BreadcrumbsButtonGoBack.js









var BreadcrumbsButtonGoBack = function BreadcrumbsButtonGoBack(_ref) {
  var className = _ref.className,
      title = _ref.title,
      disabled = _ref.disabled,
      _ref$showIconBack = _ref.showIconBack,
      showIconBack = _ref$showIconBack === void 0 ? true : _ref$showIconBack,
      _ref$isTranslateLabel = _ref.isTranslateLabel,
      isTranslateLabel = _ref$isTranslateLabel === void 0 ? true : _ref$isTranslateLabel,
      _ref$nsSeparator = _ref.nsSeparator,
      nsSeparator = _ref$nsSeparator === void 0 ? false : _ref$nsSeparator,
      onGoBack = _ref.onGoBack,
      folderType = _ref.folderType;

  var _useSharedTranslation = (0,TranslateContext/* useSharedTranslation */.G)(),
      t = _useSharedTranslation.t;

  var labelFinal;

  if (isTranslateLabel) {
    labelFinal = (0,content/* removeBR */.H8)(t(title, {
      // prevent labels with a colon (":")
      // being considered as the {[namespace]:[key]}
      nsSeparator: nsSeparator ? undefined : false
    }));
  } else {
    labelFinal = title;
  }

  return /*#__PURE__*/react.createElement("button", {
    className: classnames_default()((BreadcrumbsButtonGoBack_module_default()).root, folderType, className),
    disabled: disabled,
    onClick: disabled ? undefined : onGoBack
  }, /*#__PURE__*/react.createElement(Typography/* default */.Z, {
    variant: "h2",
    className: (BreadcrumbsButtonGoBack_module_default())["title-wrap"]
  }, showIconBack && /*#__PURE__*/react.createElement(IconView/* default */.Z, {
    className: (BreadcrumbsButtonGoBack_module_default()).icon,
    icon: EgwWebFont/* default.chevron-left */.Z["chevron-left"]
  }), /*#__PURE__*/react.createElement(Typography/* default */.Z, {
    className: (BreadcrumbsButtonGoBack_module_default()).title,
    threeDots: true,
    fontFamily: Typography/* default.fontFamily.bebas */.Z.fontFamily.bebas
  }, labelFinal)));
};

/* harmony default export */ var Breadcrumbs_BreadcrumbsButtonGoBack = (BreadcrumbsButtonGoBack);
// EXTERNAL MODULE: ../shared/hooks/useMediaQuery.js
var useMediaQuery = __webpack_require__(38295);
;// CONCATENATED MODULE: ./src/next/components/Breadcrumbs/BreadcrumbsHeader.js






function BreadcrumbsHeader(_ref) {
  var className = _ref.className,
      onClickBack = _ref.onClickBack,
      folderType = _ref.folderType,
      title = _ref.title;
  var isMobileOrTablet = (0,useMediaQuery/* default */.Z)(useMediaQuery/* MEDIA_QUERIES.untilDesktopAndDesktop */.q.untilDesktopAndDesktop);
  return /*#__PURE__*/react.createElement(Breadcrumbs_BreadcrumbsButtonGoBack, {
    showIconBack: isMobileOrTablet,
    className: className,
    title: title,
    disabled: !isMobileOrTablet,
    folderType: folderType,
    onGoBack: onClickBack
  });
}

BreadcrumbsHeader.propTypes = {
  className: (prop_types_default()).string,
  classNameTopPanel: (prop_types_default()).string,
  title: (prop_types_default()).string,
  realType: (prop_types_default()).string,
  onClickBack: (prop_types_default()).func
};
/* harmony default export */ var Breadcrumbs_BreadcrumbsHeader = (BreadcrumbsHeader);

/***/ }),

/***/ 28800:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Button_ButtonInstallPWA; }
});

// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/classnames/index.js
var classnames = __webpack_require__(60042);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__(23615);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ../node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(56253);
// EXTERNAL MODULE: ../node_modules/next-i18next/dist/esm/index.js + 22 modules
var esm = __webpack_require__(60098);
// EXTERNAL MODULE: ../shared/utils/sw/sw.constants.js
var sw_constants = __webpack_require__(34855);
// EXTERNAL MODULE: ../shared/components/IconView/IconView.js
var IconView = __webpack_require__(20844);
// EXTERNAL MODULE: ./src/assets/EgwWebFont.js
var EgwWebFont = __webpack_require__(37462);
// EXTERNAL MODULE: ./src/next/components/index.js + 9 modules
var components = __webpack_require__(78239);
// EXTERNAL MODULE: ../shared/components/Typography/Typography.js
var Typography = __webpack_require__(21766);
// EXTERNAL MODULE: ../shared/utils/string/string.js
var string = __webpack_require__(56332);
// EXTERNAL MODULE: ../shared/contexts/modal.js
var modal = __webpack_require__(26933);
// EXTERNAL MODULE: ./src/next/components/Button/DialogInstallInstructions.module.scss
var DialogInstallInstructions_module = __webpack_require__(55170);
var DialogInstallInstructions_module_default = /*#__PURE__*/__webpack_require__.n(DialogInstallInstructions_module);
;// CONCATENATED MODULE: ./src/next/components/Button/DialogInstallInstructions.js









var DialogInstallInstructions = function DialogInstallInstructions() {
  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var _useModalContext = (0,modal/* useModalContext */.v)(),
      onClose = _useModalContext.onClose;

  var body;

  if (lib/* isIOS */.gn) {
    body = /*#__PURE__*/react.createElement("ol", null, /*#__PURE__*/react.createElement("li", {
      className: (DialogInstallInstructions_module_default()).item
    }, "1. ", t("sw:tapBtn"), " ", (0,string/* addQuotes */.XK)(t("share")), /*#__PURE__*/react.createElement("br", null), /*#__PURE__*/react.createElement("img", {
      className: (DialogInstallInstructions_module_default()).image,
      src: "/images/pwa/ios-step-1.png",
      alt: "Share"
    })), /*#__PURE__*/react.createElement("li", {
      className: (DialogInstallInstructions_module_default()).item
    }, "2. ", t("sw:tapBtn"), " ", (0,string/* addQuotes */.XK)(t("sw:btnInstallIOS")), /*#__PURE__*/react.createElement("br", null), /*#__PURE__*/react.createElement("img", {
      className: (DialogInstallInstructions_module_default()).image,
      src: "/images/pwa/ios-step-2.png",
      alt: "Button install"
    })));
  } else if (lib/* isDesktop */.nI && lib/* isChrome */.i7) {
    body = /*#__PURE__*/react.createElement("ol", null, /*#__PURE__*/react.createElement("li", {
      className: (DialogInstallInstructions_module_default()).item
    }, t("sw:tapBtn"), " ", (0,string/* addQuotes */.XK)(t("install")), /*#__PURE__*/react.createElement("br", null), /*#__PURE__*/react.createElement("img", {
      className: (DialogInstallInstructions_module_default()).image,
      src: "/images/pwa/chrome-step-1.png",
      alt: "Install"
    })), /*#__PURE__*/react.createElement(Typography/* default */.Z, {
      variant: "body3"
    }, "(", t("sw:ifNotInstallBtn"), ")"));
  } else {
    body = /*#__PURE__*/react.createElement("ol", null, /*#__PURE__*/react.createElement("li", {
      className: (DialogInstallInstructions_module_default()).item
    }, "1. ", t("sw:tapBtn"), " ", (0,string/* addQuotes */.XK)(t("menu")), /*#__PURE__*/react.createElement("br", null), /*#__PURE__*/react.createElement("img", {
      className: (DialogInstallInstructions_module_default()).image,
      src: "/images/pwa/ff-step-1.png",
      alt: "Menu"
    })), /*#__PURE__*/react.createElement("li", {
      className: (DialogInstallInstructions_module_default()).item
    }, "2. ", t("sw:tapBtn"), " ", (0,string/* addQuotes */.XK)(t("sw:install")), /*#__PURE__*/react.createElement("br", null), /*#__PURE__*/react.createElement("img", {
      className: (DialogInstallInstructions_module_default()).image,
      src: "/images/pwa/ff-step-2.png",
      alt: "Button install"
    })));
  }

  return /*#__PURE__*/react.createElement(react.Fragment, null, body, /*#__PURE__*/react.createElement(components/* Button */.zx, {
    style: {
      margin: "0.9rem auto 0",
      minWidth: "6rem"
    },
    onClick: onClose
  }, t("ok")));
};

var useDialogInstallInstructions = function useDialogInstallInstructions() {
  var _useModalContext2 = (0,modal/* useModalContext */.v)(),
      showModal = _useModalContext2.showModal;

  return (0,react.useCallback)(function () {
    showModal( /*#__PURE__*/react.createElement(DialogInstallInstructions, null), {
      title: "sw:instructions",
      negativeBtn: false
    });
  }, [showModal]);
};

/* harmony default export */ var Button_DialogInstallInstructions = (useDialogInstallInstructions);
// EXTERNAL MODULE: ../shared/hooks/pwa/pwa.js
var pwa = __webpack_require__(79427);
// EXTERNAL MODULE: ./src/next/utils/landing/landing.constants.js
var landing_constants = __webpack_require__(13257);
;// CONCATENATED MODULE: ./src/next/components/Button/ButtonInstallPWA.js
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }














var ButtonInstallPWA = function ButtonInstallPWA(_ref) {
  var className = _ref.className,
      _ref$isRenderAsText = _ref.isRenderAsText,
      isRenderAsText = _ref$isRenderAsText === void 0 ? false : _ref$isRenderAsText,
      variant = _ref.variant,
      color = _ref.color,
      size = _ref.size;

  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var _useState = (0,react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isShown = _useState2[0],
      SetIsShown = _useState2[1];

  var _useState3 = (0,react.useState)(true),
      _useState4 = _slicedToArray(_useState3, 2),
      isCanPrompt = _useState4[0],
      setIsCanPrompt = _useState4[1];

  var openDialogInstallInstructions = Button_DialogInstallInstructions();
  var isCanShowInstallInstructions = (lib/* isAndroid */.Dt || lib/* isDesktop */.nI) && lib/* isChrome */.i7 || lib/* isIOS */.gn && lib/* isSafari */.G6 || lib/* isAndroid */.Dt && lib/* isFirefox */.vU || lib/* isAndroid */.Dt && lib/* isOpera */.f0;
  var isStandAlone = (0,pwa/* useIsStandAlone */.J)();
  var isPWAInstalled = (0,pwa/* useIsStandAloneInstalled */.N)();
  var handleClick = (0,react.useCallback)(function () {
    if (isCanPrompt) {
      __webpack_require__.g.window[sw_constants/* WINDOW_KEY_INSTALL_EVENT */.RY].prompt();
    } else if (isCanShowInstallInstructions) {
      openDialogInstallInstructions();
    }
  }, [openDialogInstallInstructions, isCanShowInstallInstructions, isCanPrompt]);
  (0,react.useEffect)(function () {
    SetIsShown(true);

    var handleCanPromptSuccess = function handleCanPromptSuccess() {
      setIsCanPrompt(true);
    };

    if (__webpack_require__.g.window[sw_constants/* WINDOW_KEY_INSTALL_EVENT */.RY]) {
      handleCanPromptSuccess();
    } else {
      window.addEventListener(sw_constants/* CUSTOM_EVENT_TYPE_STASH_INSTALL_PROMPT */.XQ, handleCanPromptSuccess);
    }

    return function () {
      window.removeEventListener(sw_constants/* CUSTOM_EVENT_TYPE_STASH_INSTALL_PROMPT */.XQ, handleCanPromptSuccess);
    };
  }, []);
  (0,react.useEffect)(function () {
    if (isPWAInstalled || isStandAlone || !isCanShowInstallInstructions) {
      setIsCanPrompt(false);
    }
  }, [isPWAInstalled, isStandAlone, isCanShowInstallInstructions]);

  if (!isCanPrompt) {
    return null;
  }

  return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(components/* Button */.zx, {
    title: t("sw:installEGWWritings"),
    className: classnames_default()(className, landing_constants/* LANDING_SELECTORS.buttonInstallPWA.substring */.QR.buttonInstallPWA.substring(1), {
      hidden: !isShown
    }),
    onClick: handleClick,
    variant: variant !== null && variant !== void 0 ? variant : components/* Button.variant.clear */.zx.variant.clear,
    color: color !== null && color !== void 0 ? color : components/* Button.color.icon */.zx.color.icon,
    size: size !== null && size !== void 0 ? size : components/* Button.size.big */.zx.size.big
  }, !isRenderAsText && /*#__PURE__*/react.createElement(IconView/* default */.Z, {
    icon: EgwWebFont/* default.install */.Z.install
  }), isRenderAsText && t("sw:installEGWWritings")));
};

ButtonInstallPWA.propTypes = {
  className: (prop_types_default()).string,
  isRenderAsText: (prop_types_default()).bool
};
/* harmony default export */ var Button_ButtonInstallPWA = (ButtonInstallPWA);

/***/ }),

/***/ 30508:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79894);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_device_detect__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56253);
/* harmony import */ var _components_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78239);
var _excluded = ["href", "shallow", "linkAs", "idRipple"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }







var LinkButton = function LinkButton(_ref) {
  var href = _ref.href,
      _ref$shallow = _ref.shallow,
      shallow = _ref$shallow === void 0 ? true : _ref$shallow,
      linkAs = _ref.linkAs,
      idRipple = _ref.idRipple,
      props = _objectWithoutProperties(_ref, _excluded);

  if (!href) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_index__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .zx, _extends({
      idRipple: idRipple
    }, props));
  }

  var linkProps = {
    href: href,
    // Prevent displaying a native context menu of a link on Android device in Firefox browser,
    // by preventing passing "href" attribute.
    passHref: !(react_device_detect__WEBPACK_IMPORTED_MODULE_3__/* .isAndroid */ .Dt && react_device_detect__WEBPACK_IMPORTED_MODULE_3__/* .isFirefox */ .vU)
  };

  if (linkAs) {
    linkProps["as"] = linkAs;
  }

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement((next_link__WEBPACK_IMPORTED_MODULE_2___default()), _extends({
    shallow: shallow
  }, linkProps, {
    scroll: false,
    legacyBehavior: true
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_index__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .zx, _extends({
    idRipple: idRipple,
    timeout: react_device_detect__WEBPACK_IMPORTED_MODULE_3__/* .isIOS */ .gn ? 615 : undefined,
    rootTagName: "a"
  }, props)));
};

LinkButton.variant = _components_index__WEBPACK_IMPORTED_MODULE_4__/* .Button.variant */ .zx.variant;
LinkButton.color = _components_index__WEBPACK_IMPORTED_MODULE_4__/* .Button.color */ .zx.color;
LinkButton.size = _components_index__WEBPACK_IMPORTED_MODULE_4__/* .Button.size */ .zx.size;
LinkButton.propTypes = _objectSpread(_objectSpread({}, _components_index__WEBPACK_IMPORTED_MODULE_4__/* .Button.propTypes */ .zx.propTypes), {}, {
  href: prop_types__WEBPACK_IMPORTED_MODULE_1___default().oneOfType([(prop_types__WEBPACK_IMPORTED_MODULE_1___default().string), (prop_types__WEBPACK_IMPORTED_MODULE_1___default().object)]).isRequired,
  idRipple: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  linkAs: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string)
});
/* harmony default export */ __webpack_exports__["Z"] = (LinkButton);

/***/ }),

/***/ 84611:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60042);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _container_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20162);
/* harmony import */ var _container_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_container_module_scss__WEBPACK_IMPORTED_MODULE_3__);




var Container = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref, ref) {
  var _ref$tag = _ref.tag,
      Tag = _ref$tag === void 0 ? "div" : _ref$tag,
      className = _ref.className,
      children = _ref.children;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Tag, {
    ref: ref,
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_container_module_scss__WEBPACK_IMPORTED_MODULE_3___default().container), className)
  }, children);
});
Container.propTypes = {
  children: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().node),
  className: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  tag: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string)
};
/* harmony default export */ __webpack_exports__["Z"] = (Container);

/***/ }),

/***/ 44809:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60042);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34412);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60098);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86677);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_qr_code__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88948);
/* harmony import */ var _shared_utils_viewmode__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(24064);
/* harmony import */ var _store_actions__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(62013);
/* harmony import */ var src_assets_EgwWebFont__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(37462);
/* harmony import */ var _shared_components_IconButton_IconButton__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(75448);
/* harmony import */ var _components_index__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(78239);
/* harmony import */ var _shared_components_Button_Button_constants__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(29718);
/* harmony import */ var _utils_routes_routes_constants__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(46072);
/* harmony import */ var _CreateQRcode_module_scss__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(4037);
/* harmony import */ var _CreateQRcode_module_scss__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_CreateQRcode_module_scss__WEBPACK_IMPORTED_MODULE_14__);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

















var handleImageDownload = function handleImageDownload() {
  var svg = document.getElementById("QRCode");
  var svgData = new XMLSerializer().serializeToString(svg);
  var canvas = document.createElement("canvas");
  var ctx = canvas.getContext("2d");
  var img = new Image();

  img.onload = function () {
    canvas.width = img.width;
    canvas.height = img.height;
    ctx.drawImage(img, 0, 0);
    var pngFile = canvas.toDataURL("image/png");
    var downloadLink = document.createElement("a");
    downloadLink.download = "QRCode";
    downloadLink.href = "".concat(pngFile);
    downloadLink.click();
  };

  img.src = "data:image/svg+xml;base64,".concat(btoa(svgData));
};

var CreateQRcode = function CreateQRcode(_ref) {
  var value = _ref.value;

  var _useTranslation = (0,next_i18next__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$G)(),
      t = _useTranslation.t;

  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
  var isReader = router.asPath.includes(_utils_routes_routes_constants__WEBPACK_IMPORTED_MODULE_13__/* .NEXT_URLS.read */ .h.read);

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(value || ""),
      _useState2 = _slicedToArray(_useState, 2),
      qrCodeValue = _useState2[0],
      setQrCodeValue = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isOpenIconTooltip = _useState4[0],
      setIsOpenIconTooltip = _useState4[1];

  var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useDispatch */ .I0)();
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: (_CreateQRcode_module_scss__WEBPACK_IMPORTED_MODULE_14___default()["qr-code_wrap"])
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: (_CreateQRcode_module_scss__WEBPACK_IMPORTED_MODULE_14___default()["qr-code-image"])
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react_qr_code__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
    size: (0,_shared_utils_viewmode__WEBPACK_IMPORTED_MODULE_7__/* .remToPx */ .cv)(16),
    id: "QRCode",
    value: qrCodeValue
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_index__WEBPACK_IMPORTED_MODULE_11__/* .Typography */ .ZT, {
    tag: "p",
    variant: "body2",
    align: "left",
    color: "text-inactive"
  }, "Link:"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_index__WEBPACK_IMPORTED_MODULE_11__/* .Input */ .II, {
    readOnly: true,
    onChange: function onChange(e) {
      return setQrCodeValue(e.target.value);
    },
    className: (_CreateQRcode_module_scss__WEBPACK_IMPORTED_MODULE_14___default()["qr-code_input"]),
    value: qrCodeValue
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: (_CreateQRcode_module_scss__WEBPACK_IMPORTED_MODULE_14___default()["qr-code_action"])
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_shared_components_IconButton_IconButton__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_CreateQRcode_module_scss__WEBPACK_IMPORTED_MODULE_14___default()["qr-code_icon-button"]), (_CreateQRcode_module_scss__WEBPACK_IMPORTED_MODULE_14___default().tooltip)),
    icon: src_assets_EgwWebFont__WEBPACK_IMPORTED_MODULE_9__/* ["default"].info */ .Z.info,
    size: _shared_components_Button_Button_constants__WEBPACK_IMPORTED_MODULE_12__/* .BUTTON_SIZES.small */ .Gt.small,
    onClick: function onClick(e) {
      e.preventDefault();
      e.stopPropagation();
      setIsOpenIconTooltip(!isOpenIconTooltip);
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_index__WEBPACK_IMPORTED_MODULE_11__/* .Typography */ .ZT, {
    tag: "span",
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_CreateQRcode_module_scss__WEBPACK_IMPORTED_MODULE_14___default().tooltiptext), _defineProperty({}, (_CreateQRcode_module_scss__WEBPACK_IMPORTED_MODULE_14___default().active), isOpenIconTooltip)),
    variant: "body2"
  }, t("qrCodeInfo"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_CreateQRcode_module_scss__WEBPACK_IMPORTED_MODULE_14___default()["qr-code-buttons"]), isReader ? (_CreateQRcode_module_scss__WEBPACK_IMPORTED_MODULE_14___default()["two-column"]) : "")
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_index__WEBPACK_IMPORTED_MODULE_11__/* .Button */ .zx, {
    onClick: function onClick() {
      dispatch(_store_actions__WEBPACK_IMPORTED_MODULE_8__/* .systemActions.actionCopy */ .nm.actionCopy(qrCodeValue, {
        successMessage: t("linkCopied"),
        errorMessage: t("linkNotCopied")
      }));
    },
    size: _shared_components_Button_Button_constants__WEBPACK_IMPORTED_MODULE_12__/* .BUTTON_SIZES.medium */ .Gt.medium,
    className: (_CreateQRcode_module_scss__WEBPACK_IMPORTED_MODULE_14___default()["qr-code_button"])
  }, " ", t("copy")), isReader && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_index__WEBPACK_IMPORTED_MODULE_11__/* .Button */ .zx, {
    onClick: handleImageDownload,
    size: _shared_components_Button_Button_constants__WEBPACK_IMPORTED_MODULE_12__/* .BUTTON_SIZES.medium */ .Gt.medium,
    color: _components_index__WEBPACK_IMPORTED_MODULE_11__/* .Button.color.secondary */ .zx.color.secondary,
    className: (_CreateQRcode_module_scss__WEBPACK_IMPORTED_MODULE_14___default()["qr-code_button"])
  }, " ", t("download")))));
};

CreateQRcode.propTypes = {
  value: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string)
};
/* harmony default export */ __webpack_exports__["Z"] = (CreateQRcode);

/***/ }),

/***/ 50478:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60042);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _delimiter_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3797);
/* harmony import */ var _delimiter_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_delimiter_module_scss__WEBPACK_IMPORTED_MODULE_3__);





var Delimiter = function Delimiter(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_delimiter_module_scss__WEBPACK_IMPORTED_MODULE_3___default().delimiter), className)
  }, "|");
};

Delimiter.propTypes = {
  className: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string)
};
/* harmony default export */ __webpack_exports__["Z"] = (Delimiter);

/***/ }),

/***/ 36037:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Head_Head; }
});

// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/next/head.js
var head = __webpack_require__(88038);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__(23615);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ../node_modules/next/router.js
var router = __webpack_require__(86677);
// EXTERNAL MODULE: ../node_modules/next-i18next/dist/esm/index.js + 22 modules
var esm = __webpack_require__(60098);
// EXTERNAL MODULE: ../shared/utils/content/content.js
var content = __webpack_require__(69051);
// EXTERNAL MODULE: ../shared/utils/url/url.js
var url_url = __webpack_require__(59916);
;// CONCATENATED MODULE: ../shared/utils/metaData/metaData.constants.js
 // title, description and keywords are taken from https://legacy.egwwritings.org

var titleBrief = "EGW";
var titleShortDefault = "EGW Writings";
var titleDefault = "EGW Writings®: The Complete Published Books of Ellen G. White";
var descriptionDefault = "Search, read, listen to, and download Ellen G. White's " + "Writings in multiple languages! Publications are available in epub, mobi, Kindle, MP3 and PDF " + "formats.";
var keywordsDefault = "egw, egwwritings, Ellen G. White Writings, Ellen White, " + "ellenwhite, ellengwhite, ellen g. white, e g white, white estate, " + "ellen g white estate, MP3, Kindle, ePub, PDF, Books, Periodicals, Manuscripts, Biography, " + "most prolific American woman author, most translated woman writer in history, test of a true " + "prophet, spirit of prophecy, Adventist, Pioneer, SDA, Bible, AKJV, ASV, Darby, KJV, WBS, WEB, " + "Young’s Literal, Noah Webster’s 1828 American Dictionary";
var urlImageDefault = (0,url_url/* isUrlHasHttpPart */.Vd)(url_url/* placeHolderImage */.bV) ? url_url/* placeHolderImage */.bV : (0,url_url/* getBaseHost */.UO)() + url_url/* placeHolderImage */.bV;
var altImageDefault = "Default cover of EGW book";
// EXTERNAL MODULE: ../shared/utils/string/string.js
var string = __webpack_require__(56332);
;// CONCATENATED MODULE: ../shared/utils/metaData/metaData.helpers.js

var getMetaTitleFixed = function getMetaTitleFixed(str) {
  return (0,string/* threeDotsIfLongerThan */.s2)(150, str);
};
var getMetaDescriptionFixed = function getMetaDescriptionFixed(str) {
  return (0,string/* threeDotsIfLongerThan */.s2)(150, str);
};
/**
 * @typedef {Object} ItemMetaData
 * @property {string} keyPropKey
 * @property {string} keyPropValue
 * @property {string} key
 * @property {string} value
 */

/**
 * @typedef {ItemMetaData[]} MetaData
 */

/**
 * @params {string} keyPropKey
 * @params {string} keyPropValue
 * @params {string} key
 * @params {string} value
 * @returns {ItemMetaData}
 * @private
 */

var _makeItemMetaData = function _makeItemMetaData(keyPropKey, keyPropValue, key, value) {
  return {
    keyPropKey: keyPropKey,
    keyPropValue: keyPropValue,
    key: key,
    value: value
  };
};

var makeItemMetaDataDefault = function makeItemMetaDataDefault(key, value) {
  return _makeItemMetaData("name", "content", key, value);
};
var makeItemMetaDataOpenGraph = function makeItemMetaDataOpenGraph(key, value) {
  return _makeItemMetaData("property", "content", "og:" + key, value);
};
var makeItemMetaDataTwitter = function makeItemMetaDataTwitter(key, value) {
  return _makeItemMetaData("name", "content", "twitter:" + key, value);
};
;// CONCATENATED MODULE: ../shared/utils/metaData/metaData.common.js


/**
 * Not use it directly in the React!
 * Use only to create another method makeMetaData[NAME]!
 * @param {MetaData} holderMetaData
 * @param {string} title
 * @param {string} description
 * @param {string[]|string}keywords
 * @returns {MetaData}
 * @private
 */

var _makeMetaDataHTMLCommon = function _makeMetaDataHTMLCommon(holderMetaData, title, description, keywords) {
  holderMetaData.push(makeItemMetaDataDefault("title", getMetaTitleFixed(title || titleDefault)), makeItemMetaDataDefault("description", getMetaDescriptionFixed(description || descriptionDefault)));

  if (Array.isArray(keywords)) {
    holderMetaData.push(makeItemMetaDataDefault("keywords", keywords.length ? keywords.join(", ") : keywordsDefault));
  } else {
    holderMetaData.push(makeItemMetaDataDefault("keywords", keywords || keywordsDefault));
  }

  return holderMetaData;
};
/**
 * Not use it directly in the React!
 * Use only to create another method makeMetaData[NAME]!
 * @param {MetaData} holderMetaData
 * @param {string} title
 * @param {string} description
 * @param {string} urlPage
 * @param {string?} urlImage
 * @param {string?} imageAlt
 * @returns {MetaData}
 * @private
 */

var _makeMetaDataOpenGraphCommon = function _makeMetaDataOpenGraphCommon(holderMetaData, title, description, urlPage, urlImage, imageAlt) {
  holderMetaData.push(makeItemMetaDataOpenGraph("type", "website"), makeItemMetaDataOpenGraph("title", getMetaTitleFixed(title || titleDefault)), makeItemMetaDataOpenGraph("description", getMetaDescriptionFixed(description || descriptionDefault)), makeItemMetaDataOpenGraph("url", urlPage), makeItemMetaDataOpenGraph("image", urlImage || urlImageDefault), makeItemMetaDataOpenGraph("image:alt", imageAlt || altImageDefault));
  return holderMetaData;
};
/**
 * Not use it directly in the React!
 * Use only to create another method makeMetaData[NAME]!
 * @param {MetaData} holderMetaData
 * @param {string} title
 * @param {string} description
 * @param {string?} imageUrl
 * @param {string?} imageAlt
 * @param {string?} twitterUsername
 * @returns {MetaData}
 * @private
 */

var _makeMetaDataTwitterCommon = function _makeMetaDataTwitterCommon(holderMetaData, title, description, imageUrl, imageAlt, twitterUsername) {
  holderMetaData.push(makeItemMetaDataTwitter("card", "summary"), makeItemMetaDataTwitter("title", getMetaTitleFixed(title) || titleDefault), makeItemMetaDataTwitter("description", getMetaDescriptionFixed(description) || descriptionDefault), makeItemMetaDataTwitter("image", imageUrl || urlImageDefault), makeItemMetaDataTwitter("image:alt", imageAlt || altImageDefault)); // @username for the website used in the card footer.

  if (twitterUsername) {
    holderMetaData.push(makeItemMetaDataTwitter("site", twitterUsername));
  }

  return holderMetaData;
};
/**
 * Use this method to generate metadata of any common page.
 * @param objHolderMetaData
 * @param {string} title
 * @param {string} description
 * @param {string[]|string} keywords
 * @param {string} urlPage
 * @param {string?} imageUrl
 * @param {string?} imageAlt
 * @param {string?} twitterUsername
 */

var makeMetaDataCommon = function makeMetaDataCommon(objHolderMetaData, title, description, keywords, urlPage, imageUrl, imageAlt, twitterUsername) {
  _makeMetaDataHTMLCommon(objHolderMetaData, title, description, keywords);

  _makeMetaDataOpenGraphCommon(objHolderMetaData, title, description, urlPage, imageUrl, imageAlt);

  _makeMetaDataTwitterCommon(objHolderMetaData, title, description, imageUrl, imageAlt, twitterUsername);

  return objHolderMetaData;
};
;// CONCATENATED MODULE: ../shared/utils/metaData/metaData.book.js




var _fixBookMp3 = function _fixBookMp3(bookMP3) {
  if ((0,url_url/* isUrlHasHttpPart */.Vd)(bookMP3)) {
    return bookMP3;
  }

  return (0,url_url/* makeResourceUrl */.c7)(bookMP3);
};

var _getImageUrlBook = function _getImageUrlBook(book) {
  var url = (0,url_url/* getBookCover */.Ow)(book, true, true);

  if (!(0,url_url/* isUrlHasHttpPart */.Vd)(url)) {
    url = (0,url_url/* getBaseHost */.UO)() + url;
  }

  return url;
};

var _getImageAltBook = function _getImageAltBook(book) {
  return "Cover of the book " + book.code;
};

var _makeMetaDataBook = function _makeMetaDataBook(holderMetaData, book) {
  return _makeMetaDataHTMLCommon(holderMetaData, book.title, book.description, book.code);
};
/**
 * @param {MetaData} holderMetaData
 * @param {{}} book
 * @param {string} urlMp3
 * @param {string} urlPage
 * @returns {MetaData}
 * @private
 */


var _makeMetaDataOpenGraphBook = function _makeMetaDataOpenGraphBook(holderMetaData, book, urlMp3, urlPage) {
  _makeMetaDataOpenGraphCommon(holderMetaData, book.title, book.description, urlPage, _getImageUrlBook(book), _getImageAltBook(book));

  holderMetaData.push(makeItemMetaDataOpenGraph("type", "book"), makeItemMetaDataOpenGraph("book:author", book.author), makeItemMetaDataOpenGraph("book:isbn", book.isbn), makeItemMetaDataOpenGraph("book:release_date", book.pub_year), makeItemMetaDataOpenGraph("book:tag", book.code));

  if (urlMp3) {
    holderMetaData.push(makeItemMetaDataOpenGraph("audio", _fixBookMp3(urlMp3)));
  }

  return holderMetaData;
};

var _makeMetaDataTwitterBook = function _makeMetaDataTwitterBook(holderMetaData, book) {
  return _makeMetaDataTwitterCommon(holderMetaData, book.title, book.description, _getImageUrlBook(book), _getImageAltBook(book));
};
/**
 * @param {MetaData} holderMetaData
 * @param {{}} book
 * @param {string} urlMp3
 * @param {string} urlPage
 * @returns {MetaData}
 */


var makeMetaDataBook = function makeMetaDataBook(holderMetaData, book, urlMp3, urlPage) {
  _makeMetaDataBook(holderMetaData, book);

  _makeMetaDataOpenGraphBook(holderMetaData, book, urlMp3, urlPage);

  _makeMetaDataTwitterBook(holderMetaData, book);

  return holderMetaData;
};
// EXTERNAL MODULE: ../shared/utils/multilang/i18n.js
var i18n = __webpack_require__(54354);
;// CONCATENATED MODULE: ./src/next/components/Head/Head.js
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }












var Head = function Head(_ref) {
  var pageTitle = _ref.pageTitle,
      description = _ref.description,
      keywords = _ref.keywords,
      url = _ref.url,
      book = _ref.book,
      bookMp3 = _ref.bookMp3,
      folder = _ref.folder,
      children = _ref.children;

  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var _useRouter = (0,router.useRouter)(),
      basePath = _useRouter.basePath;

  var pageTitleFixed = (0,content/* removeTags */.av)((0,i18n/* tWithPrefixHandler */.Rs)(t, pageTitle, {
    // prevent labels with a colon (":")
    // being considered as the {[namespace]:[key]}
    nsSeparator: false
  }), " ");
  var pageTitleFinal = pageTitleFixed ? "".concat(pageTitleFixed, " | ").concat(titleShortDefault) : titleShortDefault;
  var jsxMetaTagsFavIcon = /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("link", {
    rel: "shortcut icon",
    href: basePath + "/favicon.ico"
  }), /*#__PURE__*/react.createElement("link", {
    rel: "icon",
    type: "image/png",
    sizes: "16x16",
    href: basePath + "/images/icons/next/favicon16.png"
  }), /*#__PURE__*/react.createElement("link", {
    rel: "icon",
    type: "image/png",
    sizes: "32x32",
    href: basePath + "/images/icons/next/favicon32.png"
  }), /*#__PURE__*/react.createElement("link", {
    rel: "icon",
    type: "image/png",
    sizes: "96x96",
    href: basePath + "/images/icons/next/favicon96.png"
  }), /*#__PURE__*/react.createElement("link", {
    rel: "icon",
    type: "image/png",
    sizes: "192x192",
    href: basePath + "/images/icons/next/favicon192.png"
  }));
  var jsxMetaTagsStandAlone = /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("meta", {
    name: "apple-mobile-web-app-capable",
    content: "yes"
  }), /*#__PURE__*/react.createElement("meta", {
    name: "mobile-web-app-capable",
    content: "yes"
  }));
  var jsxMetaTagsWindows8ModernUITags = /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("meta", {
    name: "msapplication-TileColor",
    content: "#ffffff"
  }), /*#__PURE__*/react.createElement("meta", {
    name: "msapplication-TileImage",
    content: basePath + "/images/icons/ms-icon-144x144.png"
  }));
  /**
   * @type {MetaData}
   */

  var metaData = [];

  if (book) {
    makeMetaDataBook(metaData, book, bookMp3, url);
  } else {
    makeMetaDataCommon(metaData, pageTitleFinal, description, keywords, url);
  }

  var jsxMetaTagsPage = metaData.map(function (itemMetaData) {
    var _props;

    var props = (_props = {}, _defineProperty(_props, itemMetaData.keyPropKey, itemMetaData.key), _defineProperty(_props, itemMetaData.keyPropValue, itemMetaData.value), _props);
    return /*#__PURE__*/react.createElement("meta", _extends({
      key: itemMetaData.key
    }, props));
  });
  return /*#__PURE__*/react.createElement((head_default()), null, /*#__PURE__*/react.createElement("title", null, pageTitleFinal), jsxMetaTagsFavIcon, jsxMetaTagsWindows8ModernUITags, jsxMetaTagsStandAlone, jsxMetaTagsPage, children);
};

Head.propTypes = {
  pageTitle: (prop_types_default()).string,
  description: (prop_types_default()).string,
  keywords: (prop_types_default()).string,
  url: (prop_types_default()).string.isRequired,
  book: (prop_types_default()).object,
  bookMp3: (prop_types_default()).string,
  folder: (prop_types_default()).object,
  children: (prop_types_default()).any
};
/* harmony default export */ var Head_Head = (Head);

/***/ }),

/***/ 75580:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60042);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34412);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60098);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86677);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(65218);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _shared_components_IconView_IconView__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(20844);
/* harmony import */ var _shared_components_IconButton_IconButton__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(75448);
/* harmony import */ var _components_Logotype_Logotype__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(21355);
/* harmony import */ var _components_Container_Container__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(84611);
/* harmony import */ var _shared_components_Backdrop_Backdrop__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(95524);
/* harmony import */ var _components_Button_LinkButton__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(30508);
/* harmony import */ var _components_Header_HeaderForm__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(31760);
/* harmony import */ var _components_Player_PlayerControls__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(86024);
/* harmony import */ var _components_Header_PanelHeaderMenu__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(96970);
/* harmony import */ var _shared_components_Portal_Portal__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(64976);
/* harmony import */ var src_assets_EgwWebFont__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(37462);
/* harmony import */ var _shared_utils_content_content__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(69051);
/* harmony import */ var _store_actions__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(62013);
/* harmony import */ var _hooks_index__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(66040);
/* harmony import */ var _utils_routes_routes_constants__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(46072);
/* harmony import */ var _shared_store_search_selectors__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(24803);
/* harmony import */ var _shared_hooks_useMediaQuery__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(38295);
/* harmony import */ var _utils_MenuItems_constants__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(84257);
/* harmony import */ var _shared_utils_menu__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(35567);
/* harmony import */ var _contexts_auth__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(89284);
/* harmony import */ var _shared_utils_url_url__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(59916);
/* harmony import */ var _assets_CategoryIcons__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(63666);
/* harmony import */ var _hooks_useTheme__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(88130);
/* harmony import */ var _contexts_search__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(38768);
/* harmony import */ var _shared_components_Portal_PortalMainAfter_constants__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(265);
/* harmony import */ var _components_ThreeDots__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(39036);
/* harmony import */ var _hooks_useIsDOMHydratedAfterSSR__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(69286);
/* harmony import */ var _Header_module_scss__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(89259);
/* harmony import */ var _Header_module_scss__WEBPACK_IMPORTED_MODULE_33___default = /*#__PURE__*/__webpack_require__.n(_Header_module_scss__WEBPACK_IMPORTED_MODULE_33__);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }



































var ButtonTheme = next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return __webpack_require__.e(/* import() */ 930).then(__webpack_require__.bind(__webpack_require__, 13930));
}, {
  ssr: false
});
var SearchExampleView = next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return __webpack_require__.e(/* import() */ 919).then(__webpack_require__.bind(__webpack_require__, 82919));
}, {
  ssr: false
});


var Header = function Header(_ref) {
  var _searchParams$queryFu;

  var fullVersionLink = _ref.fullVersionLink;

  var _useTranslation = (0,next_i18next__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$G)(),
      t = _useTranslation.t;

  var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useDispatch */ .I0)();
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isShowMobileForm = _useState2[0],
      setShowMobileForm = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showSearchHelp = _useState4[0],
      setShowSearchExamples = _useState4[1];

  var _useAuthContext = (0,_contexts_auth__WEBPACK_IMPORTED_MODULE_25__/* .useAuthContext */ .E)(),
      isLogin = _useAuthContext.isLogin,
      login = _useAuthContext.login,
      logout = _useAuthContext.logout;

  var _useTheme = (0,_hooks_useTheme__WEBPACK_IMPORTED_MODULE_28__/* .useTheme */ .Fg)(),
      isDarkTheme = _useTheme.isDarkTheme;

  var showSideMenu = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(function (state) {
    return state.system.showSideMenu;
  });
  var showAdvSearchPanel = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(function (state) {
    return state.system.showAdvSearchPanel;
  });
  var searchParams = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(_shared_store_search_selectors__WEBPACK_IMPORTED_MODULE_32__/* .selectorSearchParams */ .im);

  var _useFullScreen = (0,_hooks_index__WEBPACK_IMPORTED_MODULE_20__/* .useFullScreen */ .p0)(),
      fullScreen = _useFullScreen.fullScreen,
      toggleFullScreen = _useFullScreen.toggleFullScreen;

  var _useSearchContext = (0,_contexts_search__WEBPACK_IMPORTED_MODULE_29__/* .useSearchContext */ .A)(),
      search = _useSearchContext.search;

  var isHydrated = (0,_hooks_useIsDOMHydratedAfterSSR__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)();
  var isMobile = (0,_shared_hooks_useMediaQuery__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)(_shared_hooks_useMediaQuery__WEBPACK_IMPORTED_MODULE_22__/* .MEDIA_QUERIES.untilTablet */ .q.untilTablet);
  var isMobileAndHydrated = isMobile && isHydrated;
  var isReader = router.asPath.includes(_utils_routes_routes_constants__WEBPACK_IMPORTED_MODULE_21__/* .NEXT_URLS.read */ .h.read);

  var toggleMenu = function toggleMenu() {
    dispatch(_store_actions__WEBPACK_IMPORTED_MODULE_19__/* .systemActions.setShowSideMenu */ .nm.setShowSideMenu(!showSideMenu));
  };

  var onClickAuth = function onClickAuth() {
    if (isLogin) {
      logout();
    } else {
      login();
    }
  };

  var closeSearchHelp = function closeSearchHelp() {
    setShowSearchExamples(false);
  };

  var hideMobileForm = function hideMobileForm() {
    setShowMobileForm(false);
  };

  var toggleSearchHelp = function toggleSearchHelp() {
    setShowSearchExamples(!showSearchHelp);
  };

  var MenuItemsFinal = [];

  var _iterator = _createForOfIteratorHelper(_utils_MenuItems_constants__WEBPACK_IMPORTED_MODULE_23__/* .MenuItemsList */ .Zs),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var item = _step.value;
      var locations = item.locations,
          label = item.label,
          id = item.id;
      var isLocationSuitable = locations.includes(_shared_utils_menu__WEBPACK_IMPORTED_MODULE_24__/* .MENU_ITEM_LOCATION.MENU */ .u.MENU);
      var isAuthValid = (!item.onlyAuth || isLogin) && (!item.onlyNoAuth || !isLogin);
      var isItemGoToFullApp = label === _utils_MenuItems_constants__WEBPACK_IMPORTED_MODULE_23__/* .goToFullAppLabel */ .rV;

      if (isLocationSuitable && isAuthValid && (!isItemGoToFullApp || isMobileAndHydrated)) {
        var hrefFinal = isItemGoToFullApp ? fullVersionLink : item.url;
        MenuItemsFinal.push(_objectSpread(_objectSpread({}, item), {}, {
          href: hrefFinal,
          label: (0,_shared_utils_content_content__WEBPACK_IMPORTED_MODULE_18__/* .removeBR */ .H8)(t(label)),
          icon: item.icon || (0,_assets_CategoryIcons__WEBPACK_IMPORTED_MODULE_27__/* .getImageByClass */ .o)(item.add_class, isDarkTheme, id),
          onClick: id === _shared_utils_url_url__WEBPACK_IMPORTED_MODULE_26__/* .URLS.login */ .ns.login || id === _shared_utils_url_url__WEBPACK_IMPORTED_MODULE_26__/* .URLS.logout */ .ns.logout ? onClickAuth : undefined
        }));
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  var elemThemeDropDown = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ButtonTheme, {
    className: (_Header_module_scss__WEBPACK_IMPORTED_MODULE_33___default()["dd-theme"]),
    onClick: closeSearchHelp
  });
  var btnMenu = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_shared_components_IconButton_IconButton__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
    icon: src_assets_EgwWebFont__WEBPACK_IMPORTED_MODULE_17__/* ["default"]["burger-menu"] */ .Z["burger-menu"],
    active: showSideMenu,
    className: (_Header_module_scss__WEBPACK_IMPORTED_MODULE_33___default()["menu-button"]),
    onClick: toggleMenu,
    title: t("menu")
  });
  var btnSearchHelp = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_shared_components_IconButton_IconButton__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
    type: "button",
    icon: src_assets_EgwWebFont__WEBPACK_IMPORTED_MODULE_17__/* ["default"].question */ .Z.question,
    active: showSearchHelp,
    className: (_Header_module_scss__WEBPACK_IMPORTED_MODULE_33___default()["header__btn-help"]),
    onClick: toggleSearchHelp,
    title: t("help")
  });
  var btnFilters = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_shared_components_IconButton_IconButton__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
    className: (_Header_module_scss__WEBPACK_IMPORTED_MODULE_33___default()["header__btn-filter"]),
    type: "button",
    icon: src_assets_EgwWebFont__WEBPACK_IMPORTED_MODULE_17__/* ["default"].filter */ .Z.filter,
    active: showAdvSearchPanel,
    onClick: function onClick() {
      return dispatch(_store_actions__WEBPACK_IMPORTED_MODULE_19__/* .systemActions.setShowAdvSearchPanel */ .nm.setShowAdvSearchPanel(!showAdvSearchPanel));
    },
    title: t("filter")
  });
  var btnSearch = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_shared_components_IconButton_IconButton__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
    icon: src_assets_EgwWebFont__WEBPACK_IMPORTED_MODULE_17__/* ["default"].search */ .Z.search,
    type: "button",
    className: (_Header_module_scss__WEBPACK_IMPORTED_MODULE_33___default()["header__btn-filter__mobile"]),
    onClick: function onClick() {
      return setShowMobileForm(true);
    },
    title: t("search")
  });
  var btnPlay = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_Player_PlayerControls__WEBPACK_IMPORTED_MODULE_14__/* .PlayControl */ .b, null);
  var btnFullscreen = isMobileAndHydrated ? null : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_shared_components_IconButton_IconButton__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
    icon: fullScreen ? src_assets_EgwWebFont__WEBPACK_IMPORTED_MODULE_17__/* ["default"]["fullscreen-exit"] */ .Z["fullscreen-exit"] : src_assets_EgwWebFont__WEBPACK_IMPORTED_MODULE_17__/* ["default"].fullscreen */ .Z.fullscreen,
    className: (_Header_module_scss__WEBPACK_IMPORTED_MODULE_33___default()["header__btn-fullscreen"]),
    active: fullScreen,
    title: fullScreen ? t("minimize") : t("fullscreen"),
    onClick: toggleFullScreen
  });
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("header", {
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_Header_module_scss__WEBPACK_IMPORTED_MODULE_33___default().header), _defineProperty({}, (_Header_module_scss__WEBPACK_IMPORTED_MODULE_33___default()["form-focused"]), isShowMobileForm))
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_Container_Container__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
    className: (_Header_module_scss__WEBPACK_IMPORTED_MODULE_33___default()["header__content-wrapper"])
  }, isShowMobileForm && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_shared_components_IconButton_IconButton__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
    className: (_Header_module_scss__WEBPACK_IMPORTED_MODULE_33___default()["header__btn-back"]),
    icon: src_assets_EgwWebFont__WEBPACK_IMPORTED_MODULE_17__/* ["default"]["chevron-left"] */ .Z["chevron-left"],
    onClick: hideMobileForm
  }), isShowMobileForm ? null : btnMenu, !isShowMobileForm && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_Logotype_Logotype__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
    className: (_Header_module_scss__WEBPACK_IMPORTED_MODULE_33___default().header__logo),
    writingsTextClassName: (_Header_module_scss__WEBPACK_IMPORTED_MODULE_33___default()["logo__text-writings"]),
    onClick: function onClick() {
      dispatch(_store_actions__WEBPACK_IMPORTED_MODULE_19__/* .systemActions.setShowAdvSearchPanel */ .nm.setShowAdvSearchPanel(false));
    }
  }), (isShowMobileForm || !isMobileAndHydrated) && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_Header_HeaderForm__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
    initialValue: (_searchParams$queryFu = searchParams.queryFull) !== null && _searchParams$queryFu !== void 0 ? _searchParams$queryFu : searchParams.query,
    className: (_Header_module_scss__WEBPACK_IMPORTED_MODULE_33___default()["header-form"]),
    beforeInput: isMobileAndHydrated ? null : btnFilters,
    afterInput: isMobileAndHydrated ? null : btnSearchHelp,
    onSearch: search
  }), !isShowMobileForm && isMobileAndHydrated && (isReader ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, btnPlay, btnSearch) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, btnSearch, elemThemeDropDown)), btnFullscreen, !isMobileAndHydrated && elemThemeDropDown, isShowMobileForm && isMobileAndHydrated ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_ThreeDots__WEBPACK_IMPORTED_MODULE_30__/* ["default"] */ .Z, {
    className: (_Header_module_scss__WEBPACK_IMPORTED_MODULE_33___default()["header__three-dots"]),
    classNamePopupContent: (_Header_module_scss__WEBPACK_IMPORTED_MODULE_33___default()["three-dots_body"]),
    onShow: closeSearchHelp
  }, function (_ref2) {
    var hide = _ref2.hide;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      className: (_Header_module_scss__WEBPACK_IMPORTED_MODULE_33___default()["click-wrapper"]),
      onClick: function onClick() {
        hide();
        hideMobileForm();
      }
    }, btnMenu, btnFilters, btnSearchHelp), elemThemeDropDown, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_Button_LinkButton__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
      href: "/"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_shared_components_IconView_IconView__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
      icon: src_assets_EgwWebFont__WEBPACK_IMPORTED_MODULE_17__/* ["default"].home */ .Z.home
    })));
  }) : null, !isMobileAndHydrated && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_Button_LinkButton__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
    paddingLess: true,
    title: t("goToFullApp"),
    className: (_Header_module_scss__WEBPACK_IMPORTED_MODULE_33___default()["header__go-to-full-app"]),
    href: fullVersionLink
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_shared_components_IconView_IconView__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
    icon: src_assets_EgwWebFont__WEBPACK_IMPORTED_MODULE_17__/* ["default"]["go-to-full-app"] */ .Z["go-to-full-app"]
  })), showSearchHelp && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_shared_components_Portal_Portal__WEBPACK_IMPORTED_MODULE_16__["default"], {
    id: _shared_components_Portal_PortalMainAfter_constants__WEBPACK_IMPORTED_MODULE_34__/* .EL_ID_PORTAL_MAIN_AFTER */ .t
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    tabIndex: 0
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(SearchExampleView, {
    className: (_Header_module_scss__WEBPACK_IMPORTED_MODULE_33___default()["header__search-help"]),
    onClose: closeSearchHelp,
    onSearch: search
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_shared_components_Backdrop_Backdrop__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
    className: (_Header_module_scss__WEBPACK_IMPORTED_MODULE_33___default()["header__search-help__backdrop"]),
    onClick: closeSearchHelp
  })))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_Header_PanelHeaderMenu__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
    isOpen: showSideMenu,
    links: MenuItemsFinal,
    onClose: toggleMenu
  }));
};

Header.propTypes = {
  fullVersionLink: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string)
};
/* harmony default export */ __webpack_exports__["Z"] = (Header);

/***/ }),

/***/ 31760:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60042);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60098);
/* harmony import */ var _shared_components_SearchField_SearchField__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50439);
/* harmony import */ var _Header_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89259);
/* harmony import */ var _Header_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_Header_module_scss__WEBPACK_IMPORTED_MODULE_5__);







var HeaderForm = function HeaderForm(_ref) {
  var className = _ref.className,
      initialValue = _ref.initialValue,
      beforeInput = _ref.beforeInput,
      afterInput = _ref.afterInput,
      onSearch = _ref.onSearch,
      searchPlaceholder = _ref.searchPlaceholder,
      onClearSearchQuery = _ref.onClearSearchQuery,
      onChange = _ref.onChange;

  var _useTranslation = (0,next_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)(),
      t = _useTranslation.t;

  var refSearchInput = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();

  var handleSearch = function handleSearch(query) {
    if (refSearchInput.current) {
      refSearchInput.current.blur();
    } // trim - 3839.
    // Is here, bcz Reader Search and Global search use this component.
    // But may be need to move trim logic to another place.


    onSearch(query.trim());
  };

  var handleCloseIconClick = function handleCloseIconClick() {
    var _refSearchInput$curre;

    (_refSearchInput$curre = refSearchInput.current) === null || _refSearchInput$curre === void 0 ? void 0 : _refSearchInput$curre.focus(); // UX

    if (onClearSearchQuery) {
      onClearSearchQuery();
    }
  };

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_shared_components_SearchField_SearchField__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Header_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["header-form"]), className),
    ref: refSearchInput,
    slotAfter: afterInput,
    required: true,
    slotBefore: beforeInput,
    value: initialValue,
    onSearch: handleSearch,
    onClear: handleCloseIconClick,
    onChange: onChange,
    placeholder: searchPlaceholder
  });
};

HeaderForm.propTypes = {
  className: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
  inputClassName: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
  initialValue: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
  afterInput: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().node),
  beforeInput: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().node),
  onSearch: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().func),
  searchPlaceholder: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
  onClearSearchQuery: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().func),
  onChange: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().func)
};
/* harmony default export */ __webpack_exports__["Z"] = (HeaderForm);

/***/ }),

/***/ 72612:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ EL_ID_PORTAL_HEADER_ACTIONS_LEFT; },
/* harmony export */   "T": function() { return /* binding */ EL_ID_PORTAL_HEADER_ACTIONS; }
/* harmony export */ });
var EL_ID_PORTAL_HEADER_ACTIONS = "portal-header-actions";
var EL_ID_PORTAL_HEADER_ACTIONS_LEFT = "portal-header-actions-left";

/***/ }),

/***/ 96970:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60042);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65218);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _shared_components_SidePanel_SidePanel__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4234);
/* harmony import */ var _shared_components_Button_CloseButton_CloseButton__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72064);
/* harmony import */ var _components_index__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(78239);
/* harmony import */ var _components_Button_ButtonInstallPWA__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(28800);
/* harmony import */ var _components_Button_LinkButton__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(30508);
/* harmony import */ var _contexts_pageProps__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2978);
/* harmony import */ var _shared_hooks_useMediaQuery__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(38295);
/* harmony import */ var _shared_components_IconView_IconView__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(20844);
/* harmony import */ var _SharePopup_ButtonShare__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(41058);
/* harmony import */ var _PanelHeaderMenu_module_scss__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(72269);
/* harmony import */ var _PanelHeaderMenu_module_scss__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_PanelHeaderMenu_module_scss__WEBPACK_IMPORTED_MODULE_12__);













var ButtonTheme = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function () {
  return __webpack_require__.e(/* import() */ 930).then(__webpack_require__.bind(__webpack_require__, 13930));
}, {
  ssr: false
});

var PanelHeaderMenu = function PanelHeaderMenu(_ref) {
  var _window$history$state;

  var isOpen = _ref.isOpen,
      onClose = _ref.onClose,
      onClickLink = _ref.onClickLink,
      links = _ref.links,
      _ref$isShowQR = _ref.isShowQR,
      isShowQR = _ref$isShowQR === void 0 ? true : _ref$isShowQR,
      _ref$isShowPWA = _ref.isShowPWA,
      isShowPWA = _ref$isShowPWA === void 0 ? true : _ref$isShowPWA,
      _ref$isHiddenByCSS = _ref.isHiddenByCSS,
      isHiddenByCSS = _ref$isHiddenByCSS === void 0 ? false : _ref$isHiddenByCSS;

  var _usePagePropsContext = (0,_contexts_pageProps__WEBPACK_IMPORTED_MODULE_8__/* .usePagePropsContext */ .b)(),
      urlOrigin = _usePagePropsContext.urlOrigin,
      isLanding = _usePagePropsContext.isLanding,
      isBigLanding = _usePagePropsContext.isBigLanding,
      landingBookViewConfig = _usePagePropsContext.landingBookViewConfig;

  var mediaMobile = (0,_shared_hooks_useMediaQuery__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_shared_hooks_useMediaQuery__WEBPACK_IMPORTED_MODULE_9__/* .MEDIA_QUERIES.untilTablet */ .q.untilTablet);
  var isMobile = isLanding ? true : mediaMobile;
  var jsxBtnQR = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_index__WEBPACK_IMPORTED_MODULE_5__/* .ButtonQRCode */ .gY, {
    isHeaderIcon: isMobile,
    withLabel: !isMobile,
    className: (_PanelHeaderMenu_module_scss__WEBPACK_IMPORTED_MODULE_12___default()["btn-qr"])
  });
  var jsxLinks = links.map(function (item) {
    var id = item.id,
        icon = item.icon,
        href = item.href,
        isOnLineOnly = item.isOnLineOnly,
        label = item.label,
        title = item.title,
        _onClick = item.onClick;
    var isExternal = href && href.startsWith("http") && !href.includes(urlOrigin);
    var Wrapper = href ? _components_Button_LinkButton__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z : _components_index__WEBPACK_IMPORTED_MODULE_5__/* .Button */ .zx;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, {
      key: id !== null && id !== void 0 ? id : href,
      id: id !== null && id !== void 0 ? id : "",
      paddingLess: true,
      className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_PanelHeaderMenu_module_scss__WEBPACK_IMPORTED_MODULE_12___default().link), "menu-mobile-links"),
      isOnLineOnly: isOnLineOnly,
      variant: _components_Button_LinkButton__WEBPACK_IMPORTED_MODULE_7__/* ["default"].variant.clear */ .Z.variant.clear,
      color: _components_Button_LinkButton__WEBPACK_IMPORTED_MODULE_7__/* ["default"].color.icon */ .Z.color.icon,
      title: title !== null && title !== void 0 ? title : label,
      target: isExternal ? "_blank" : undefined // href to prevent error "no href value"
      ,
      href: href,
      onClick: function onClick(e) {
        if (_onClick) {
          _onClick(e);
        }

        if (onClickLink) {
          onClickLink(e, item);
        }
      }
    }, icon && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_shared_components_IconView_IconView__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
      className: (_PanelHeaderMenu_module_scss__WEBPACK_IMPORTED_MODULE_12___default()["item-icon"]),
      icon: icon
    }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: label
      }
    }));
  });
  var jsxBtnTheme = (!isLanding || (landingBookViewConfig === null || landingBookViewConfig === void 0 ? void 0 : landingBookViewConfig.hasDarkMode)) && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ButtonTheme, {
    className: (_PanelHeaderMenu_module_scss__WEBPACK_IMPORTED_MODULE_12___default()["dd-theme"])
  });
  var shareData = "window" in __webpack_require__.g && ((_window$history$state = window.history.state) === null || _window$history$state === void 0 ? void 0 : _window$history$state.shareData);
  var rightSideBtn1 = shareData && isLanding ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_SharePopup_ButtonShare__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
    text: shareData.text,
    refCode: shareData.refCode,
    title: shareData.title,
    url: shareData.url,
    className: (_PanelHeaderMenu_module_scss__WEBPACK_IMPORTED_MODULE_12___default()["dd-theme"])
  }) : jsxBtnTheme;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_shared_components_SidePanel_SidePanel__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    isUseLockBodyScroll: true,
    isHiddenByCSS: isHiddenByCSS,
    preventCoverHeader: !isMobile,
    isOpen: isOpen,
    onClose: onClose,
    className: (_PanelHeaderMenu_module_scss__WEBPACK_IMPORTED_MODULE_12___default().root),
    contentProps: {
      className: (_PanelHeaderMenu_module_scss__WEBPACK_IMPORTED_MODULE_12___default().content),
      tag: "nav"
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: (_PanelHeaderMenu_module_scss__WEBPACK_IMPORTED_MODULE_12___default().inner)
  }, isMobile && isShowQR && !isBigLanding && jsxBtnQR, jsxLinks, isMobile && rightSideBtn1, isLanding && isShowPWA && !isBigLanding && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_Button_ButtonInstallPWA__WEBPACK_IMPORTED_MODULE_6__["default"], null), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: (_PanelHeaderMenu_module_scss__WEBPACK_IMPORTED_MODULE_12___default()["wrap-actions"])
  }, !isMobile && jsxBtnQR, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_shared_components_Button_CloseButton_CloseButton__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_PanelHeaderMenu_module_scss__WEBPACK_IMPORTED_MODULE_12___default()["btn-close"]), "menu-mobile-links"),
    onClick: onClose
  }))));
};

/* harmony default export */ __webpack_exports__["Z"] = (PanelHeaderMenu);

/***/ }),

/***/ 139:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60042);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _shared_components_ViewLanguages_ViewLanguages__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90499);
/* harmony import */ var _shared_hooks_useDeviceDetect__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34289);
/* harmony import */ var _shared_components_DropDown_DropDown__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68551);
/* harmony import */ var _shared_utils_select__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(48018);
/* harmony import */ var _LanguageSelector_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41735);
/* harmony import */ var _LanguageSelector_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_LanguageSelector_module_scss__WEBPACK_IMPORTED_MODULE_6__);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









/*const DropDown = dynamic(() => import("@/shared/components/DropDown/DropDown"), {
  ssr: true,
});*/

var LanguageSelector = function LanguageSelector(_ref) {
  var toggleOnClickButton = _ref.toggleOnClickButton,
      isRenderBodyWhenSSR = _ref.isRenderBodyWhenSSR,
      isUseLockBodyScroll = _ref.isUseLockBodyScroll,
      withCheckbox = _ref.withCheckbox,
      hideOnClick = _ref.hideOnClick,
      title = _ref.title,
      langs = _ref.langs,
      currentLang = _ref.currentLang,
      className = _ref.className,
      classNameButton = _ref.classNameButton,
      onClickLanguage = _ref.onClickLanguage,
      button = _ref.button,
      toggleOnMouseOverLeave = _ref.toggleOnMouseOverLeave,
      onShow = _ref.onShow,
      _onHide = _ref.onHide,
      popupProps = _ref.popupProps;

  var _useDeviceDetect = (0,_shared_hooks_useDeviceDetect__WEBPACK_IMPORTED_MODULE_4__.useDeviceDetect)(),
      isRealMobile = _useDeviceDetect.isRealMobile;

  var isValueArray = Array.isArray(currentLang);
  var selectButton = button ? button : function (_ref2) {
    var onClick = _ref2.onClick,
        ref = _ref2.ref;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
      tabIndex: 0,
      ref: ref,
      onClick: onClick,
      className: classNameButton
    }, title);
  };
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_shared_components_DropDown_DropDown__WEBPACK_IMPORTED_MODULE_5__["default"], {
    onShow: onShow,
    isMaxWidthBasedOnButton: false,
    isRenderBodyWhenSSR: isRenderBodyWhenSSR,
    isUseLockBodyScroll: isUseLockBodyScroll,
    toggleOnMouseOverLeave: toggleOnMouseOverLeave,
    toggleOnClickButton: toggleOnClickButton,
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_LanguageSelector_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["language-selector"]), className),
    onHide: function onHide() {
      if (_onHide) {
        _onHide();
      }
    },
    popupProps: _objectSpread({
      hasConstantSizes: true,
      usePositionAbsolute: isRealMobile,
      hideOnScroll: false,
      maxHeight: function maxHeight() {
        return "window" in __webpack_require__.g ? window.innerHeight / 2 : undefined;
      },
      contentProps: {
        className: (_LanguageSelector_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["language-selector__inner"])
      }
    }, popupProps),
    button: selectButton,
    body: function body(_ref3) {
      var hide = _ref3.hide;
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_shared_components_ViewLanguages_ViewLanguages__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        isHideCheckbox: !withCheckbox,
        items: langs,
        itemsChecked: isValueArray ? currentLang : [currentLang],
        onClickItem: function onClickItem(e, item) {
          onClickLanguage((0,_shared_utils_select__WEBPACK_IMPORTED_MODULE_7__/* .getOptionKey */ ._)(item));

          if (hideOnClick) {
            hide(e);
          }
        }
      });
    }
  });
};

LanguageSelector.defaultProps = {
  hideOnClick: true,
  toggleOnMouseOverLeave: true
};
LanguageSelector.propTypes = {
  isRenderBodyWhenSSR: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().bool),
  isUseLockBodyScroll: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().bool),
  toggleOnMouseOverLeave: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().bool),
  hideOnClick: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().bool),
  withCheckbox: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().bool),
  title: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().node),
  button: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().func),
  langs: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().array),
  currentLang: prop_types__WEBPACK_IMPORTED_MODULE_1___default().oneOfType([(prop_types__WEBPACK_IMPORTED_MODULE_1___default().string), (prop_types__WEBPACK_IMPORTED_MODULE_1___default().array)]),
  className: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  classNameButton: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  onClickLanguage: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().func.isRequired)
};
/* harmony default export */ __webpack_exports__["Z"] = (LanguageSelector);

/***/ }),

/***/ 21355:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86677);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _shared_utils_url_url__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59916);
/* harmony import */ var _shared_components_Logotype_Logotype__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48011);






var Logotype = function Logotype(_ref) {
  var className = _ref.className,
      writingsTextClassName = _ref.writingsTextClassName,
      text = _ref.text,
      isShowRegistered = _ref.isShowRegistered,
      onClick = _ref.onClick;
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();

  var handleClick = function handleClick(e) {
    e.preventDefault();

    if (onClick) {
      onClick(e);
    }

    router.push(_shared_utils_url_url__WEBPACK_IMPORTED_MODULE_3__/* .URLS.home */ .ns.home);
  };

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_shared_components_Logotype_Logotype__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    className: className,
    writingsTextClassName: writingsTextClassName,
    text: text,
    isShowLogoWritingsLabel: true,
    isShowRegistered: isShowRegistered,
    isShowLogoLinks: false,
    scrollToTop: !router.asPath || router.route === "/",
    onClick: handleClick
  });
};

Logotype.defaultProps = {
  isShowRegistered: true,
  text: "writings",
  href: "/"
};
Logotype.propTypes = {
  className: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  isShowRegistered: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().bool),
  href: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  text: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  writingsTextClassName: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  onClick: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().func)
};
/* harmony default export */ __webpack_exports__["Z"] = (Logotype);

/***/ }),

/***/ 19162:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ MainLayout_MainLayout; }
});

// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(34412);
// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__(23615);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ../node_modules/next/dynamic.js
var dynamic = __webpack_require__(65218);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../node_modules/next/router.js
var next_router = __webpack_require__(86677);
// EXTERNAL MODULE: ../node_modules/classnames/index.js
var classnames = __webpack_require__(60042);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../node_modules/next-i18next/dist/esm/index.js + 22 modules
var esm = __webpack_require__(60098);
// EXTERNAL MODULE: ../shared/utils/url/url.js
var url_url = __webpack_require__(59916);
// EXTERNAL MODULE: ../shared/utils/init-actions.js
var init_actions = __webpack_require__(4727);
// EXTERNAL MODULE: ./src/next/hooks/index.js
var hooks = __webpack_require__(66040);
// EXTERNAL MODULE: ./src/next/store/actions/index.js + 6 modules
var actions = __webpack_require__(62013);
// EXTERNAL MODULE: ../shared/contexts/modal.js
var modal = __webpack_require__(26933);
// EXTERNAL MODULE: ./src/next/components/Breadcrumbs/BreadcrumbsHeader.js + 1 modules
var BreadcrumbsHeader = __webpack_require__(89566);
// EXTERNAL MODULE: ../shared/components/Breadcrumbs/BreadCrumbs.js + 6 modules
var BreadCrumbs = __webpack_require__(365);
// EXTERNAL MODULE: ../shared/hooks/useMediaQuery.js
var useMediaQuery = __webpack_require__(38295);
// EXTERNAL MODULE: ./src/next/utils/routes/routes.js
var routes = __webpack_require__(69994);
// EXTERNAL MODULE: ./src/next/contexts/history.js
var contexts_history = __webpack_require__(84847);
// EXTERNAL MODULE: ./src/next/utils/routes/routes.constants.js
var routes_constants = __webpack_require__(46072);
// EXTERNAL MODULE: ../shared/utils/content/content.js
var content = __webpack_require__(69051);
// EXTERNAL MODULE: ../shared/utils/breadcrumbs/constants.js
var constants = __webpack_require__(23658);
// EXTERNAL MODULE: ./src/next/components/Breadcrumbs/breadcrumbs.module.scss
var breadcrumbs_module = __webpack_require__(12501);
var breadcrumbs_module_default = /*#__PURE__*/__webpack_require__.n(breadcrumbs_module);
;// CONCATENATED MODULE: ./src/next/components/Breadcrumbs/Breadcrumbs.js
var _excluded = ["title", "breadcrumbs", "folderType", "isLanding"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
















var createBcUrl = function createBcUrl(item) {
  if (item) {
    var id = item.id,
        type = item.type,
        url = item.url;

    if (url) {
      return url;
    }

    if (type === constants/* BreadcrumbType.folder */.k.folder) {
      return routes_constants/* NEXT_URLS.allCollection */.h.allCollection + "/" + item.id;
    }

    if (type === constants/* BreadcrumbType.book */.k.book) {
      return routes_constants/* NEXT_URLS.bookInfo */.h.bookInfo + "/" + (0,content/* getBookIdWithPrefix */.NR)(id);
    }

    if (type === constants/* BreadcrumbType.chapter */.k.chapter) {
      return (0,routes/* makeChapterUrl */.ME)(id);
    }

    if (type === constants/* BreadcrumbType.lang */.k.lang) {
      return routes_constants/* NEXT_URLS.allCollection */.h.allCollection + "/" + item.lang;
    }
  }

  return url_url/* URLS.home */.ns.home;
};

var Breadcrumbs = function Breadcrumbs(_ref) {
  var title = _ref.title,
      breadcrumbs = _ref.breadcrumbs,
      folderType = _ref.folderType,
      isLanding = _ref.isLanding,
      props = _objectWithoutProperties(_ref, _excluded);

  var router = (0,next_router.useRouter)();
  var history = (0,contexts_history/* useCustomHistory */.z)();
  var canHover = (0,useMediaQuery/* default */.Z)(useMediaQuery/* MEDIA_QUERIES.canHover */.q.canHover);

  var handleCrumbClick = function handleCrumbClick(item, index) {
    if (item.type !== constants/* BreadcrumbType.nonClickable */.k.nonClickable) {
      var itemUrl = createBcUrl(item);
      var isMainCrumb = index === 0;

      if (canHover && !isLanding || isMainCrumb) {
        router.push(itemUrl, undefined, {
          shallow: item.type !== constants/* BreadcrumbType.folder */.k.folder
        });
      } else {
        if (item.type === constants/* BreadcrumbType.externalUrl */.k.externalUrl) {
          window.open(itemUrl, "_self");
        } else {
          router.push(itemUrl);
        }
      }
    }
  };

  var handleBackClick = function handleBackClick() {
    if (isLanding) {
      router.push("/");
      return;
    }

    history.back("/");
  };

  return /*#__PURE__*/react.createElement("div", _extends({
    className: classnames_default()((breadcrumbs_module_default()).breadcrumbs, "breadcrumbs")
  }, props), /*#__PURE__*/react.createElement(BreadcrumbsHeader/* default */.Z, {
    folderType: folderType,
    title: title,
    onClickBack: handleBackClick
  }), breadcrumbs && /*#__PURE__*/react.createElement(BreadCrumbs/* default */.Z, {
    folderType: folderType,
    items: breadcrumbs,
    onClickItem: handleCrumbClick
  }));
};

Breadcrumbs.defaultProps = {
  title: "",
  breadcrumbs: []
};
Breadcrumbs.propTypes = {
  title: (prop_types_default()).string,
  breadcrumbs: (prop_types_default()).array,
  realType: (prop_types_default()).string,
  isLanding: (prop_types_default()).bool
};
/* harmony default export */ var Breadcrumbs_Breadcrumbs = (Breadcrumbs);
// EXTERNAL MODULE: ./src/next/components/Container/Container.js
var Container = __webpack_require__(84611);
// EXTERNAL MODULE: ../node_modules/next/link.js
var next_link = __webpack_require__(79894);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../shared/components/AdventistContainer/AdventistContainer.js
var AdventistContainer = __webpack_require__(95804);
// EXTERNAL MODULE: ../node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27693);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./package.json
var package_0 = __webpack_require__(4147);
// EXTERNAL MODULE: ../shared/utils/assembly.js
var assembly = __webpack_require__(76732);
;// CONCATENATED MODULE: ./src/next/components/VersionView/VersionView.js
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }








/**
 * Debug, show last build time
 */

var VersionView = function VersionView(_ref) {
  var link = _ref.link,
      info = _ref.info;
  var versionValue = "Version: ".concat(package_0.version);

  if (info && info.lastCommitTime) {
    var dateVal = dayjs_min_default()(info.lastCommitTime);
    var formatDate = (0,assembly/* isProduction */.yv)() ? "DD.MM.YYYY" : "DD.MM.YYYY HH:MM";
    versionValue += " - ".concat(dateVal.format(formatDate));
  }

  if (link && !(0,assembly/* isProduction */.yv)()) {
    return /*#__PURE__*/react.createElement("span", null, /*#__PURE__*/react.createElement((link_default()), {
      href: (0,url_url/* getMainAppHost */.oq)() + url_url/* URLS.patchNotes */.ns.patchNotes
    }, versionValue));
  }

  return /*#__PURE__*/react.createElement("span", null, versionValue);
};

VersionView.propTypes = {
  link: (prop_types_default()).bool,
  info: (prop_types_default()).any
};
function getServerSideProps() {
  return _getServerSideProps.apply(this, arguments);
}

function _getServerSideProps() {
  _getServerSideProps = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var data, res;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          data = null;
          _context.prev = 1;
          _context.next = 4;
          return fetch("info.json");

        case 4:
          res = _context.sent;
          _context.next = 7;
          return res.json();

        case 7:
          data = _context.sent;
          _context.next = 13;
          break;

        case 10:
          _context.prev = 10;
          _context.t0 = _context["catch"](1);
          console.log("VersionView: ".concat(_context.t0));

        case 13:
          return _context.abrupt("return", {
            props: {
              info: data
            }
          });

        case 14:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 10]]);
  }));
  return _getServerSideProps.apply(this, arguments);
}

/* harmony default export */ var VersionView_VersionView = (VersionView);
// EXTERNAL MODULE: ./src/next/contexts/pageProps.js
var pageProps = __webpack_require__(2978);
// EXTERNAL MODULE: ../shared/components/IconView/IconView.js
var IconView = __webpack_require__(20844);
// EXTERNAL MODULE: ./src/next/utils/landing/landing.constants.js
var landing_constants = __webpack_require__(13257);
// EXTERNAL MODULE: ./src/assets/EgwWebFont.js
var EgwWebFont = __webpack_require__(37462);
// EXTERNAL MODULE: ./src/next/components/Footer/footer.module.scss
var footer_module = __webpack_require__(99214);
var footer_module_default = /*#__PURE__*/__webpack_require__.n(footer_module);
;// CONCATENATED MODULE: ./src/next/components/Footer/Footer.js
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
















var Footer = function Footer(_ref) {
  var _classNames;

  var className = _ref.className;

  var _usePagePropsContext = (0,pageProps/* usePagePropsContext */.b)(),
      isLanding = _usePagePropsContext.isLanding,
      isBigLanding = _usePagePropsContext.isBigLanding,
      landingBookViewConfig = _usePagePropsContext.landingBookViewConfig,
      landingConfigBooksSet = _usePagePropsContext.landingConfigBooksSet,
      landingIdBooksSet = _usePagePropsContext.landingIdBooksSet;

  var year = new Date().getFullYear().toString();
  var copyrightText = "Copyright, &copy; ".concat(year, ". ");
  var ellenCopyright = "Ellen G. White&reg; Estate, Inc.";
  var isRPRACSet = landingIdBooksSet === landing_constants/* idCategoryRPRAC */.v_;
  var withAdventistContainerInFooter = (landingBookViewConfig === null || landingBookViewConfig === void 0 ? void 0 : landingBookViewConfig.withAdventistContainerInFooter) || (landingConfigBooksSet === null || landingConfigBooksSet === void 0 ? void 0 : landingConfigBooksSet.withAdventistContainerInFooter);
  return /*#__PURE__*/react.createElement("footer", {
    className: classnames_default()((footer_module_default()).footer, className, (_classNames = {}, _defineProperty(_classNames, (footer_module_default())["big-landing-footer"], isBigLanding), _defineProperty(_classNames, (footer_module_default())["asi-footer"], isRPRACSet), _classNames))
  }, /*#__PURE__*/react.createElement(Container/* default */.Z, {
    className: (footer_module_default())["footer-container"]
  }, /*#__PURE__*/react.createElement("div", {
    className: (footer_module_default())["footer-copyright"]
  }, /*#__PURE__*/react.createElement("div", {
    className: (footer_module_default())["footer-logo"]
  }, /*#__PURE__*/react.createElement(IconView/* default */.Z, {
    icon: EgwWebFont/* default.logo */.Z.logo
  })), /*#__PURE__*/react.createElement("span", {
    className: (footer_module_default())["footer-logo-small"]
  }, "\xAE")), /*#__PURE__*/react.createElement("div", {
    className: (footer_module_default())["footer-logo-text"]
  }, /*#__PURE__*/react.createElement((link_default()), {
    href: routes_constants/* NEXT_URLS.copirightNotice */.h.copirightNotice,
    passHref: true,
    dangerouslySetInnerHTML: {
      __html: copyrightText
    }
  }), /*#__PURE__*/react.createElement("a", {
    href: "https://whiteestate.org/",
    dangerouslySetInnerHTML: {
      __html: ellenCopyright
    },
    target: "_blank",
    rel: "noopener noreferrer"
  }), /*#__PURE__*/react.createElement("br", null), /*#__PURE__*/react.createElement("a", {
    href: "https://www.google.com/maps/place/Ellen+G+White+Estate,+Inc./@39.061175,-76.9679917,17z/data=!3m1!4b1!4m5!3m4!1s0x89b7c51fc029a6a7:0x8214b4d757510e16!8m2!3d39.061175!4d-76.965803",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "12501 Old Columbia Pike, Silver Spring, MD 20904, USA | Ph# 1.301.680.6540"), !isLanding && /*#__PURE__*/react.createElement("p", null, /*#__PURE__*/react.createElement(VersionView_VersionView, {
    link: true
  })))), withAdventistContainerInFooter && !isRPRACSet && /*#__PURE__*/react.createElement(AdventistContainer/* default */.Z, {
    className: (footer_module_default())["footer-adventist"]
  }), withAdventistContainerInFooter && isRPRACSet && /*#__PURE__*/react.createElement(AdventistContainer/* default */.Z, {
    className: (footer_module_default())["footer-adventist"],
    link: "asiministries.org",
    hideLinkLabel: true,
    iconSrc: (0,url_url/* makeUrlImgASILogo */.q6)()
  }));
};

Footer.propTypes = {
  className: (prop_types_default()).string
};
/* harmony default export */ var Footer_Footer = (Footer);
// EXTERNAL MODULE: ./src/next/components/Header/Header.js
var Header = __webpack_require__(75580);
// EXTERNAL MODULE: ../shared/components/Button/Button.js
var Button = __webpack_require__(18170);
// EXTERNAL MODULE: ../shared/hooks/useCookiesWithOptions.js + 9 modules
var useCookiesWithOptions = __webpack_require__(65482);
// EXTERNAL MODULE: ./src/next/components/index.js + 9 modules
var components = __webpack_require__(78239);
// EXTERNAL MODULE: ./src/next/components/cookiesNotification/CookiesNotification.module.scss
var CookiesNotification_module = __webpack_require__(43278);
var CookiesNotification_module_default = /*#__PURE__*/__webpack_require__.n(CookiesNotification_module);
;// CONCATENATED MODULE: ./src/next/components/cookiesNotification/CookiesNotification.js
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }












var CookiesNotification = function CookiesNotification() {
  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var router = (0,next_router.useRouter)();
  var pathname = router.pathname;

  var _useModalContext = (0,modal/* useModalContext */.v)(),
      showDialog = _useModalContext.showDialog;

  var isInEu = true; //useSelector((state) => state.settings.geoIpData.is_in_eu);

  var _useCookiesWithOption = (0,useCookiesWithOptions/* default */.Z)(["cookiesNotify"]),
      _useCookiesWithOption2 = _slicedToArray(_useCookiesWithOption, 2),
      cookie = _useCookiesWithOption2[0],
      setCookie = _useCookiesWithOption2[1];

  var cookiesNotify = cookie.cookiesNotify;

  var _useState = (0,react.useState)(true),
      _useState2 = _slicedToArray(_useState, 2),
      show = _useState2[0],
      setShow = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showCookiesNotification = _useState4[0],
      setShowCookiesNotification = _useState4[1];

  var onCloseClick = function onCloseClick(event) {
    event && event.preventDefault(); // set maxAge property to 1 year

    setCookie("cookiesNotify", "1", {
      maxAge: 31104000
    });
    setShow(false);
    return true;
  };

  var onClickDecline = function onClickDecline() {
    showDialog(t("decline_cookie_title"), t("decline_cookie_message"), onCloseClick, {
      positiveBtn: t("accept"),
      negativeBtn: t("decline_cookie_negative"),
      noCancelable: true,
      onCancel: function onCancel() {
        document.location.replace((0,url_url/* getTextAppHost */.nb)());
        return true;
      }
    });
  };

  (0,react.useEffect)(function () {
    var isPrivacyPolicyPage = pathname.includes(url_url/* URLS.privacyPolicy */.ns.privacyPolicy);
    setShowCookiesNotification(!cookiesNotify && isInEu && show && !isPrivacyPolicyPage);
  }, [isInEu, cookiesNotify, show, pathname]);

  if (!showCookiesNotification) {
    return null;
  }

  return /*#__PURE__*/react.createElement("div", {
    className: (CookiesNotification_module_default())["cookies-notification"]
  }, /*#__PURE__*/react.createElement(components/* Container */.W2, {
    className: (CookiesNotification_module_default())["cookies-notification-wrapper"]
  }, /*#__PURE__*/react.createElement("div", {
    className: (CookiesNotification_module_default())["cookies-notification-content"]
  }, /*#__PURE__*/react.createElement("div", {
    className: (CookiesNotification_module_default())["cookies-notification-content-title"]
  }, t("cookiesNotificationTitle")), /*#__PURE__*/react.createElement("div", {
    className: (CookiesNotification_module_default())["cookies-notification-content-text"]
  }, t("cookiesNotificationText"), " ", /*#__PURE__*/react.createElement((link_default()), {
    href: url_url/* URLS.privacyPolicy */.ns.privacyPolicy
  }, t("privacyPolicyText")), ".")), /*#__PURE__*/react.createElement("div", {
    className: (CookiesNotification_module_default())["cookies-notification-actions"]
  }, /*#__PURE__*/react.createElement(Button/* default */.Z, {
    color: Button/* default.color.secondary */.Z.color.secondary,
    onClick: onClickDecline,
    className: (CookiesNotification_module_default())["btn-cookies"]
  }, t("decline")), /*#__PURE__*/react.createElement(Button/* default */.Z, {
    onClick: onCloseClick,
    className: (CookiesNotification_module_default())["btn-cookies"]
  }, t("accept")))));
};

/* harmony default export */ var cookiesNotification_CookiesNotification = (CookiesNotification);
// EXTERNAL MODULE: ./src/next/components/Logotype/Logotype.js
var Logotype = __webpack_require__(21355);
// EXTERNAL MODULE: ./src/next/components/Button/LinkButton.js
var LinkButton = __webpack_require__(30508);
// EXTERNAL MODULE: ./src/next/components/SharePopup/ButtonShare.js
var ButtonShare = __webpack_require__(41058);
// EXTERNAL MODULE: ../shared/assets/EgwWebFont.js
var assets_EgwWebFont = __webpack_require__(59034);
// EXTERNAL MODULE: ./src/next/views/BookLanding/BookLanding.constns.js
var BookLanding_constns = __webpack_require__(67052);
// EXTERNAL MODULE: ./src/next/components/Header/PanelHeaderMenu.js
var PanelHeaderMenu = __webpack_require__(96970);
// EXTERNAL MODULE: ../shared/utils/multilang/i18n.js
var i18n = __webpack_require__(54354);
// EXTERNAL MODULE: ./src/next/components/Header/HeaderLanding.constants.js
var HeaderLanding_constants = __webpack_require__(72612);
// EXTERNAL MODULE: ./src/next/utils/MenuItems.constants.js
var MenuItems_constants = __webpack_require__(84257);
// EXTERNAL MODULE: ./src/next/contexts/auth.js
var auth = __webpack_require__(89284);
// EXTERNAL MODULE: ../shared/store/share/constants.js
var share_constants = __webpack_require__(59825);
;// CONCATENATED MODULE: ../shared/store/share/selectors.js

var selectorShareData = function selectorShareData(state) {
  return state[share_constants/* KEY_REDUCER_SHARE */.B].shareData;
};
// EXTERNAL MODULE: ./src/next/views/BookLanding/BookLandingStatic.constans.js
var BookLandingStatic_constans = __webpack_require__(79309);
// EXTERNAL MODULE: ./src/next/components/Header/HeaderLanding.module.scss
var HeaderLanding_module = __webpack_require__(82443);
var HeaderLanding_module_default = /*#__PURE__*/__webpack_require__.n(HeaderLanding_module);
// EXTERNAL MODULE: ./src/next/components/Button/ButtonInstallPWA.js + 1 modules
var ButtonInstallPWA = __webpack_require__(28800);
;// CONCATENATED MODULE: ./src/next/components/Header/HeaderLanding.js
function HeaderLanding_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || HeaderLanding_unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return HeaderLanding_arrayLikeToArray(arr); }

function HeaderLanding_slicedToArray(arr, i) { return HeaderLanding_arrayWithHoles(arr) || HeaderLanding_iterableToArrayLimit(arr, i) || HeaderLanding_unsupportedIterableToArray(arr, i) || HeaderLanding_nonIterableRest(); }

function HeaderLanding_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function HeaderLanding_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return HeaderLanding_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return HeaderLanding_arrayLikeToArray(o, minLen); }

function HeaderLanding_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function HeaderLanding_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function HeaderLanding_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }






























var ButtonTheme = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 930).then(__webpack_require__.bind(__webpack_require__, 13930));
}, {
  ssr: false
});
var LINKS = [MenuItems_constants/* MenuItems.login */.sd.login, {
  href: "/#" + BookLanding_constns/* LANDING_SECTION.ABOUT */.I.ABOUT,
  label: "aboutBook"
}, {
  href: "/#" + BookLanding_constns/* LANDING_SECTION.LANGUAGES */.I.LANGUAGES,
  label: "languages"
}, {
  href: "/#" + BookLanding_constns/* LANDING_SECTION.AUTHOR */.I.AUTHOR,
  label: "author"
}, {
  href: (0,url_url/* getMainAppHost */.oq)(),
  label: "moreBooks"
}, {
  isOnLineOnly: true,
  href: routes_constants/* NEXT_URLS.contactUs */.h.contactUs,
  label: "contact",
  title: "contactUs"
}, MenuItems_constants/* MenuItems.logout */.sd.logout];

var HeaderLanding = function HeaderLanding() {
  var _classnames, _classnames2;

  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var router = (0,next_router.useRouter)();
  var dispatch = (0,es/* useDispatch */.I0)();

  var _usePagePropsContext = (0,pageProps/* usePagePropsContext */.b)(),
      landingBookViewConfig = _usePagePropsContext.landingBookViewConfig,
      isBigLanding = _usePagePropsContext.isBigLanding,
      isSetRPRAC = _usePagePropsContext.isSetRPRAC,
      isSetCONFLICT = _usePagePropsContext.isSetCONFLICT,
      isSetTESTIMONIES = _usePagePropsContext.isSetTESTIMONIES;

  var _useAuthContext = (0,auth/* useAuthContext */.E)(),
      isLogin = _useAuthContext.isLogin,
      login = _useAuthContext.login,
      logout = _useAuthContext.logout;

  var _useState = (0,react.useState)(false),
      _useState2 = HeaderLanding_slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var shareData = (0,es/* useSelector */.v9)(selectorShareData);
  var isReaderPage = router.asPath.includes(routes_constants/* NEXT_URLS.read */.h.read);

  var handleClickAuth = function handleClickAuth(e) {
    e.preventDefault();

    if (isLogin) {
      logout();
    } else {
      login();
    }
  };

  var toggle = function toggle() {
    setIsOpen(function (isOpen) {
      return !isOpen;
    });
  };

  var handleClickItem = function handleClickItem(e, _ref) {
    var id = _ref.id;
    toggle();

    if (id === MenuItems_constants/* MenuItems.login.id */.sd.login.id || id === MenuItems_constants/* MenuItems.logout.id */.sd.logout.id) {
      handleClickAuth(e);
    }
  };

  var btnInstallPWA = /*#__PURE__*/react.createElement(ButtonInstallPWA["default"], {
    className: (HeaderLanding_module_default()).link,
    size: components/* Button.size.default */.zx.size["default"]
  });
  var linksFinal = (0,react.useMemo)(function () {
    if (isBigLanding) {
      var _links = _toConsumableArray(BookLandingStatic_constans/* BIG_LANDING_LINKS */.vG);

      if (isReaderPage) {
        _links.shift();

        _links.unshift({
          href: "/",
          label: "Home",
          id: "openHomeHeadMenuButton"
        });
      }

      return _links;
    }

    var links = [].concat(LINKS);
    var filtered = links.filter(function (l) {
      return (!l.onlyAuth || isLogin) && (!l.onlyNoAuth || !isLogin);
    }); // TODO: Refactor it - move to landing.constants.js

    if (isSetRPRAC) {
      filtered.unshift({
        href: "https://adventistbookcenter.com/asi",
        label: "buy"
      });
    }

    if (isSetRPRAC || isSetCONFLICT) {
      filtered.splice(filtered.findIndex(function (link) {
        return link.label === "languages";
      }), 1);
    }

    if (isSetRPRAC || isSetCONFLICT || isSetTESTIMONIES) {
      filtered.splice(filtered.findIndex(function (link) {
        return link.label === MenuItems_constants/* MenuItems.login.label */.sd.login.label;
      }), 1);
    }

    return (0,i18n/* translateObjectsArray */.iH)(filtered, t, {
      keyOrKeys: ["label", "title"]
    });
  }, [t, isLogin, isBigLanding, isSetRPRAC, isSetCONFLICT, isSetTESTIMONIES, isReaderPage, LINKS]);
  var jsxLinks = linksFinal.map(function (_ref2) {
    var id = _ref2.id,
        href = _ref2.href,
        isOnLineOnly = _ref2.isOnLineOnly,
        label = _ref2.label,
        title = _ref2.title,
        isExternal = _ref2.isExternal;

    if (id === MenuItems_constants/* MenuItems.login.id */.sd.login.id || id === MenuItems_constants/* MenuItems.logout.id */.sd.logout.id) {
      return null;
    }

    return /*#__PURE__*/react.createElement(LinkButton/* default */.Z, {
      key: id !== null && id !== void 0 ? id : href,
      idRipple: id !== null && id !== void 0 ? id : "",
      className: (HeaderLanding_module_default()).link,
      paddingLess: true,
      isOnLineOnly: isOnLineOnly,
      variant: LinkButton/* default.variant.clear */.Z.variant.clear,
      title: title !== null && title !== void 0 ? title : label,
      target: isExternal ? "_blank" : undefined // href to prevent error "no href value"
      ,
      href: href
    }, label);
  });
  var withSearch = isSetRPRAC || isSetCONFLICT || isSetTESTIMONIES;
  var btnSearch = /*#__PURE__*/react.createElement(LinkButton/* default */.Z, {
    paddingLess: true,
    className: classnames_default()((HeaderLanding_module_default()).link, (HeaderLanding_module_default()).search, {
      invisible: isSetTESTIMONIES
    }),
    title: "search",
    href: routes_constants/* NEXT_URLS.searchLocal */.h.searchLocal
  }, /*#__PURE__*/react.createElement(IconView/* default */.Z, {
    icon: assets_EgwWebFont/* default.search */.Z.search
  }));
  var jsxBtnTheme = (landingBookViewConfig === null || landingBookViewConfig === void 0 ? void 0 : landingBookViewConfig.hasDarkMode) && /*#__PURE__*/react.createElement(ButtonTheme, {
    classNameButton: classnames_default()((HeaderLanding_module_default()).link, (HeaderLanding_module_default())["theme-icon"])
  });
  var rightSideBtn1;

  if (isSetRPRAC || isSetCONFLICT || isSetTESTIMONIES) {
    rightSideBtn1 = isReaderPage ? jsxBtnTheme : /*#__PURE__*/react.createElement(components/* Button */.zx, {
      title: t("share"),
      className: classnames_default()((HeaderLanding_module_default()).link, landing_constants/* LANDING_SELECTORS.buttonShare.substring */.QR.buttonShare.substring(1)),
      onClick: function onClick() {
        dispatch(actions/* systemActions.actionCopy */.nm.actionCopy(window.location.origin, {
          successMessage: t("linkCopied"),
          errorMessage: t("linkNotCopied")
        }));
      }
    }, /*#__PURE__*/react.createElement(IconView/* default */.Z, {
      icon: assets_EgwWebFont/* default.share */.Z.share
    }));
  } else {
    rightSideBtn1 = shareData ? /*#__PURE__*/react.createElement(ButtonShare/* default */.Z, {
      text: shareData.text,
      refCode: shareData.refCode,
      title: shareData.title,
      url: shareData.url,
      className: (HeaderLanding_module_default()).link
    }) : jsxBtnTheme;
  }

  return /*#__PURE__*/react.createElement("header", {
    className: classnames_default()((HeaderLanding_module_default()).root, (_classnames = {}, HeaderLanding_defineProperty(_classnames, (HeaderLanding_module_default())["big-landing-header"], isBigLanding), HeaderLanding_defineProperty(_classnames, (HeaderLanding_module_default())["asi-header"], isSetRPRAC), _classnames))
  }, /*#__PURE__*/react.createElement(Container/* default */.Z, {
    className: (HeaderLanding_module_default()).inner
  }, /*#__PURE__*/react.createElement("div", {
    className: (HeaderLanding_module_default())["btn-left"]
  }, /*#__PURE__*/react.createElement(components/* Button */.zx, {
    id: landing_constants/* LANDING_SELECTORS.btnOpen.substring */.QR.btnOpen.substring(1),
    className: (HeaderLanding_module_default())["btn-open"],
    active: isOpen,
    title: t("menu"),
    onClick: toggle
  }, /*#__PURE__*/react.createElement(IconView/* default */.Z, {
    icon: assets_EgwWebFont/* default.burger-menu */.Z["burger-menu"]
  })), /*#__PURE__*/react.createElement("div", {
    id: HeaderLanding_constants/* EL_ID_PORTAL_HEADER_ACTIONS_LEFT */.O
  })), !isBigLanding && /*#__PURE__*/react.createElement(Logotype/* default */.Z, {
    className: (HeaderLanding_module_default()).header__logo,
    onClick: function onClick(e) {
      e.preventDefault();
      router.push(routes_constants/* NEXT_URLS.home */.h.home, undefined, {
        shallow: true
      });
    },
    isShowRegistered: false,
    text: "Ellen G. White"
  }), withSearch && btnSearch, isBigLanding && /*#__PURE__*/react.createElement("div", null), /*#__PURE__*/react.createElement("div", {
    className: classnames_default()((HeaderLanding_module_default()).navigation, (_classnames2 = {}, HeaderLanding_defineProperty(_classnames2, (HeaderLanding_module_default()).open, isOpen), HeaderLanding_defineProperty(_classnames2, (HeaderLanding_module_default())["with-btn-install"], !isBigLanding && !!btnInstallPWA), HeaderLanding_defineProperty(_classnames2, (HeaderLanding_module_default())["with-btn-theme"], !isBigLanding && !!rightSideBtn1), HeaderLanding_defineProperty(_classnames2, (HeaderLanding_module_default())["with-btn-search"], withSearch), _classnames2))
  }, jsxLinks, !isBigLanding && rightSideBtn1, !isBigLanding && btnInstallPWA, withSearch && btnSearch), /*#__PURE__*/react.createElement("div", {
    id: HeaderLanding_constants/* EL_ID_PORTAL_HEADER_ACTIONS */.T
  })), !isOpen && /*#__PURE__*/react.createElement(PanelHeaderMenu/* default */.Z, {
    isOpen: false,
    isHiddenByCSS: landing_constants/* LANDING_SELECTORS.mobileMenuBlock.substring */.QR.mobileMenuBlock.substring(1),
    links: linksFinal,
    onClickLink: handleClickItem,
    onClose: toggle
  }), /*#__PURE__*/react.createElement(PanelHeaderMenu/* default */.Z, {
    isOpen: isOpen,
    links: linksFinal,
    onClickLink: handleClickItem,
    onClose: toggle
  }));
};

HeaderLanding.propTypes = {
  bookId: (prop_types_default()).string
};
/* harmony default export */ var Header_HeaderLanding = (HeaderLanding);
// EXTERNAL MODULE: ../shared/contexts/AudioContext.js
var AudioContext = __webpack_require__(77926);
// EXTERNAL MODULE: ./src/next/store/actions/toc.actions.js
var toc_actions = __webpack_require__(4164);
// EXTERNAL MODULE: ../shared/store/toc/selectors.js
var selectors = __webpack_require__(8962);
// EXTERNAL MODULE: ../shared/utils/reader/reader.js
var reader = __webpack_require__(18664);
// EXTERNAL MODULE: ./src/next/contexts/swipeable.js
var swipeable = __webpack_require__(33021);
// EXTERNAL MODULE: ../shared/store/mainTree/hooks-selectors.js
var hooks_selectors = __webpack_require__(13812);
// EXTERNAL MODULE: ../shared/components/Portal/PortalMainAfter/PortalMainAfter.js
var PortalMainAfter = __webpack_require__(25539);
// EXTERNAL MODULE: ./src/next/components/TopPanel/TopPanel.constants.js
var TopPanel_constants = __webpack_require__(19158);
// EXTERNAL MODULE: ../shared/store/system/selectors.js
var system_selectors = __webpack_require__(91809);
// EXTERNAL MODULE: ../shared/components/Typography/Typography.js
var Typography = __webpack_require__(21766);
// EXTERNAL MODULE: ./src/next/components/TopPanel/top-panel.module.scss
var top_panel_module = __webpack_require__(35150);
var top_panel_module_default = /*#__PURE__*/__webpack_require__.n(top_panel_module);
;// CONCATENATED MODULE: ./src/next/components/TopPanel/TopPanelLoader.js
function TopPanelLoader_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }










var TopPanelLoader = function TopPanelLoader() {
  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var isTopPanelVisible = (0,es/* useSelector */.v9)(system_selectors/* selectorSystemIsTopPanelVisible */.eq);
  return /*#__PURE__*/react.createElement("div", {
    id: TopPanel_constants/* EL_ID_TOP_PANEL */.d,
    className: classnames_default()((top_panel_module_default())["top-panel"], TopPanelLoader_defineProperty({}, (top_panel_module_default()).hidden, !isTopPanelVisible))
  }, /*#__PURE__*/react.createElement(Typography/* default */.Z, {
    variant: "h2",
    className: (top_panel_module_default())["title-wrap"]
  }, /*#__PURE__*/react.createElement(Typography/* default */.Z, {
    className: (top_panel_module_default()).title,
    threeDots: true,
    fontFamily: Typography/* default.fontFamily.bebas */.Z.fontFamily.bebas
  }, t("loading"), "\u2026")));
};

/* harmony default export */ var TopPanel_TopPanelLoader = (TopPanelLoader);
// EXTERNAL MODULE: ./src/next/components/MainLayout/main-layout.module.scss
var main_layout_module = __webpack_require__(43333);
var main_layout_module_default = /*#__PURE__*/__webpack_require__.n(main_layout_module);
;// CONCATENATED MODULE: ./src/next/components/MainLayout/MainLayout.js
function MainLayout_extends() { MainLayout_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return MainLayout_extends.apply(this, arguments); }

function MainLayout_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function MainLayout_slicedToArray(arr, i) { return MainLayout_arrayWithHoles(arr) || MainLayout_iterableToArrayLimit(arr, i) || MainLayout_unsupportedIterableToArray(arr, i) || MainLayout_nonIterableRest(); }

function MainLayout_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function MainLayout_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return MainLayout_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return MainLayout_arrayLikeToArray(o, minLen); }

function MainLayout_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function MainLayout_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function MainLayout_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }































var AdvSearchView = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 604).then(__webpack_require__.bind(__webpack_require__, 41604));
}, {
  ssr: false
});
var SmallPlayer = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 623).then(__webpack_require__.bind(__webpack_require__, 94623));
}, {
  ssr: false
}); // dynamic, to prevent a console error: Hydration failed due to the UI mismatch…

var TopPanel = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 53743));
}, {
  ssr: false,
  loading: TopPanel_TopPanelLoader
});

var MainLayout = function MainLayout(_ref) {
  var children = _ref.children,
      breadcrumbs = _ref.breadcrumbs,
      afterBreadcrumbsSlot = _ref.afterBreadcrumbsSlot,
      contentWrapperTag = _ref.contentWrapperTag,
      isLoading = _ref.isLoading,
      fullVersionLinkCustom = _ref.fullVersionLinkCustom,
      _ref$isVisibleFooter = _ref.isVisibleFooter,
      isVisibleFooter = _ref$isVisibleFooter === void 0 ? true : _ref$isVisibleFooter;

  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var dispatch = (0,es/* useDispatch */.I0)();
  var router = (0,next_router.useRouter)();

  var _usePagePropsContext = (0,pageProps/* usePagePropsContext */.b)(),
      isLanding = _usePagePropsContext.isLanding,
      isBigLanding = _usePagePropsContext.isBigLanding;

  var _useFullScreen = (0,hooks/* useFullScreen */.p0)(),
      setFullScreen = _useFullScreen.setFullScreen,
      disableFullScreen = _useFullScreen.disableFullScreen;

  var _useState = (0,react.useState)(isLoading),
      _useState2 = MainLayout_slicedToArray(_useState, 2),
      isVisibleLoader = _useState2[0],
      setVisibleLoader = _useState2[1];

  var _useAudioContext = (0,AudioContext/* useAudioContext */.YC)(),
      playChapterAndShowPlayer = _useAudioContext.playChapterAndShowPlayer,
      chapterId = _useAudioContext.chapterId;

  var _useModalContext = (0,modal/* useModalContext */.v)(),
      showDialog = _useModalContext.showDialog,
      onClose = _useModalContext.onClose;

  var showAdvSearchPanel = (0,es/* useSelector */.v9)(function (state) {
    return state.system.showAdvSearchPanel;
  });
  var fullVersionLink = fullVersionLinkCustom || (0,url_url/* getMainAppHost */.oq)() + router.asPath;
  var isRouteHome = router.route === routes_constants/* NEXT_URLS.home */.h.home;
  var isReaderPage = router.asPath.includes(routes_constants/* NEXT_URLS.read */.h.read);
  var isLandingReaderPage = isLanding && isReaderPage;
  var isTopPanelShown = breadcrumbs || afterBreadcrumbsSlot;
  var initActionURL = (0,react.useMemo)(function () {
    return (0,init_actions/* parseHashInitAction */.tE)(router.asPath);
  }, [router.asPath]);
  var idInitActionURL, nameActionInitActionURL, positionInitActionURL;

  if (initActionURL) {
    idInitActionURL = initActionURL.id;
    nameActionInitActionURL = initActionURL.action;
    positionInitActionURL = initActionURL.position;
  }

  var idOriginBookInitAction = idInitActionURL ? (0,content/* getBookIdNumber */.o8)(idInitActionURL) : undefined;
  var bookInitAction = (0,hooks_selectors/* useSelectorBook */.j)(idOriginBookInitAction);
  var tocItems = (0,es/* useSelector */.v9)(selectors/* selectorTocItems */.L);
  var tocInitAction = idOriginBookInitAction ? tocItems[idOriginBookInitAction] : null; // Fetches the toc of the init action book.

  (0,react.useEffect)(function () {
    if (idOriginBookInitAction) {
      dispatch(toc_actions/* tocActions.fetch */.b.fetch(idOriginBookInitAction));
    }
  }, [idOriginBookInitAction]); // Fetches the book of the init action.

  (0,react.useEffect)(function () {
    if (idOriginBookInitAction) {
      dispatch(actions/* mainTreeActions.fetchBook */.Ze.fetchBook(idOriginBookInitAction));
    }
  }, [idOriginBookInitAction]); // Does a URL init action if the url has one.

  (0,react.useEffect)(function () {
    if (!idInitActionURL || !bookInitAction || !tocInitAction) {
      return undefined;
    }

    var timeout;

    if (nameActionInitActionURL === init_actions/* URLInitAction.listen */.WU.listen) {
      timeout = setTimeout(function () {
        playChapterAndShowPlayer(idInitActionURL, positionInitActionURL, {
          fromML: true,
          onError: function onError() {
            var title = bookInitAction.title;
            var chapterSuitable = (0,reader/* getReaderAudioChapter */.mT)(tocInitAction, idInitActionURL);
            showDialog(t("doYouWannaPlay", {
              title: title
            }), chapterSuitable.title || chapterSuitable.refcode_short, function () {
              playChapterAndShowPlayer(idInitActionURL, positionInitActionURL, {
                fromML: true
              });
              onClose();
            }, {
              positiveBtn: t("yes"),
              negativeBtn: t("no"),
              noCancelable: true,
              onCancel: onClose
            });
          }
        });
      }, 0);
    }

    return function () {
      clearTimeout(timeout);
    };
  }, [bookInitAction, tocInitAction]); // Regulates full screen for some cases.

  (0,react.useEffect)(function () {
    if (!isLanding || isLandingReaderPage) {
      setFullScreen();
    } else {
      disableFullScreen();
    }
  }, [isLanding, isLandingReaderPage, setFullScreen]); // Regulates the <body/> class names "is-home" and "is-reader".

  (0,react.useEffect)(function () {
    if (isRouteHome) {
      __webpack_require__.g.window.document.body.classList.add("is-home");
    } else {
      __webpack_require__.g.window.document.body.classList.remove("is-home");
    }

    if (isReaderPage) {
      __webpack_require__.g.window.document.documentElement.classList.add("is-reader");
    } else {
      __webpack_require__.g.window.document.documentElement.classList.remove("is-reader");
    }
  }, [isReaderPage, isRouteHome]); // Delays the loader for little time loading processes.

  (0,react.useEffect)(function () {
    var timeout;

    if (isLoading) {
      timeout = setTimeout(function () {
        setVisibleLoader(true);
      }, 200);
    } else {
      setVisibleLoader(false);
    }

    return function () {
      clearTimeout(timeout);
    };
  }, [isLoading]);
  var ContentWrapper = contentWrapperTag || Container/* default */.Z;
  var header = isLanding ? /*#__PURE__*/react.createElement(Header_HeaderLanding, null) : /*#__PURE__*/react.createElement(Header/* default */.Z, {
    fullVersionLink: fullVersionLink
  });
  return /*#__PURE__*/react.createElement(react.Fragment, null, header, /*#__PURE__*/react.createElement(swipeable/* GlobalSwipeableProvider */.f, {
    tag: "main",
    className: (main_layout_module_default())["main-container"]
  }, /*#__PURE__*/react.createElement(cookiesNotification_CookiesNotification, null), showAdvSearchPanel && /*#__PURE__*/react.createElement(AdvSearchView, {
    onClose: function onClose() {
      return dispatch(actions/* systemActions.setShowAdvSearchPanel */.nm.setShowAdvSearchPanel(false));
    }
  }), /*#__PURE__*/react.createElement(ContentWrapper, {
    className: classnames_default()("content-wrap", (main_layout_module_default())["content-wrap"], MainLayout_defineProperty({
      hidden: showAdvSearchPanel
    }, (main_layout_module_default())["big-land-main"], isBigLanding))
  }, isTopPanelShown && /*#__PURE__*/react.createElement(TopPanel, null, breadcrumbs && /*#__PURE__*/react.createElement(Breadcrumbs_Breadcrumbs, MainLayout_extends({}, breadcrumbs, {
    isLanding: isLanding
  })), afterBreadcrumbsSlot), children)), /*#__PURE__*/react.createElement(PortalMainAfter/* default */.Z, null), isVisibleLoader && /*#__PURE__*/react.createElement("div", {
    className: (main_layout_module_default())["loader-popup"]
  }, t("loading"), "\u2026"), !(isLandingReaderPage || isReaderPage) && isVisibleFooter && /*#__PURE__*/react.createElement(Footer_Footer, {
    className: classnames_default()((main_layout_module_default())["footer-container"], {
      hidden: showAdvSearchPanel
    })
  }), chapterId && /*#__PURE__*/react.createElement(SmallPlayer, null));
};

MainLayout.propTypes = {
  isLoading: (prop_types_default()).bool,
  contentWrapperTag: (prop_types_default()).any,
  fullVersionLinkCustom: (prop_types_default()).string,
  breadcrumbs: (prop_types_default()).object,
  children: (prop_types_default()).node,
  afterBreadcrumbsSlot: (prop_types_default()).node,
  bookTitles: (prop_types_default()).array,
  isVisibleFooter: (prop_types_default()).bool
};
/* harmony default export */ var MainLayout_MainLayout = (MainLayout);

/***/ }),

/***/ 86024:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b": function() { return /* binding */ PlayControl; },
  "Z": function() { return /* binding */ Player_PlayerControls; }
});

// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/next/router.js
var next_router = __webpack_require__(86677);
// EXTERNAL MODULE: ../node_modules/next-i18next/dist/esm/index.js + 22 modules
var esm = __webpack_require__(60098);
// EXTERNAL MODULE: ../shared/assets/EgwWebFont.js
var EgwWebFont = __webpack_require__(59034);
// EXTERNAL MODULE: ../shared/contexts/AudioContext.js
var AudioContext = __webpack_require__(77926);
// EXTERNAL MODULE: ./src/next/utils/routes/routes.constants.js
var routes_constants = __webpack_require__(46072);
// EXTERNAL MODULE: ../shared/contexts/AudioContext.hooks.js
var AudioContext_hooks = __webpack_require__(81852);
// EXTERNAL MODULE: ../shared/utils/number/number.js
var number = __webpack_require__(50150);
// EXTERNAL MODULE: ../shared/utils/reader/reader.js
var reader = __webpack_require__(18664);
// EXTERNAL MODULE: ../shared/contexts/TranslateContext.js
var TranslateContext = __webpack_require__(48081);
// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__(23615);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ../node_modules/classnames/index.js
var classnames = __webpack_require__(60042);
// EXTERNAL MODULE: ../shared/components/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(75448);
// EXTERNAL MODULE: ../shared/components/player/PlayerUIKit/PlayerUIKit.module.scss
var PlayerUIKit_module = __webpack_require__(93511);
var PlayerUIKit_module_default = /*#__PURE__*/__webpack_require__.n(PlayerUIKit_module);
;// CONCATENATED MODULE: ../shared/components/player/PlayerUIKit/PlayerUIKit.js
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








var PlayControls = function PlayControls(_ref) {
  var disabled = _ref.disabled,
      isAudioPlaying = _ref.isAudioPlaying,
      onSkipPrevClick = _ref.onSkipPrevClick,
      onSkipNextClick = _ref.onSkipNextClick,
      onSeekPrevClick = _ref.onSeekPrevClick,
      onSeekNextClick = _ref.onSeekNextClick,
      onTogglePlayClick = _ref.onTogglePlayClick,
      _ref$isSeekBackDisabl = _ref.isSeekBackDisabled,
      isSeekBackDisabled = _ref$isSeekBackDisabl === void 0 ? false : _ref$isSeekBackDisabl,
      _ref$isSeekForwardDis = _ref.isSeekForwardDisabled,
      isSeekForwardDisabled = _ref$isSeekForwardDis === void 0 ? false : _ref$isSeekForwardDis,
      _ref$isSkipForwardDis = _ref.isSkipForwardDisabled,
      isSkipForwardDisabled = _ref$isSkipForwardDis === void 0 ? false : _ref$isSkipForwardDis,
      _ref$isSkipBackDisabl = _ref.isSkipBackDisabled,
      isSkipBackDisabled = _ref$isSkipBackDisabl === void 0 ? false : _ref$isSkipBackDisabl,
      _ref$isTogglePlayDisa = _ref.isTogglePlayDisabled,
      isTogglePlayDisabled = _ref$isTogglePlayDisa === void 0 ? false : _ref$isTogglePlayDisa,
      _ref$showSkipButtons = _ref.showSkipButtons,
      showSkipButtons = _ref$showSkipButtons === void 0 ? true : _ref$showSkipButtons,
      _ref$showSeekButtons = _ref.showSeekButtons,
      showSeekButtons = _ref$showSeekButtons === void 0 ? true : _ref$showSeekButtons,
      className = _ref.className,
      style = _ref.style;

  var _useSharedTranslation = (0,TranslateContext/* useSharedTranslation */.G)(),
      t = _useSharedTranslation.t;

  return /*#__PURE__*/react.createElement("div", {
    className: classnames((PlayerUIKit_module_default())["player-controls"], className, _defineProperty({}, (PlayerUIKit_module_default())["skip-buttons-shown"], showSkipButtons)),
    style: style
  }, showSeekButtons && /*#__PURE__*/react.createElement(IconButton/* default */.Z, {
    showIcon: true,
    icon: EgwWebFont/* default.chevron-double-left */.Z["chevron-double-left"],
    onClick: onSeekPrevClick,
    title: t("seekBack"),
    disabled: disabled || isSeekBackDisabled
  }), showSkipButtons && /*#__PURE__*/react.createElement(IconButton/* default */.Z, {
    showIcon: true,
    icon: EgwWebFont/* default.skip-back */.Z["skip-back"],
    onClick: onSkipPrevClick,
    title: t("skipBack"),
    disabled: disabled || isSkipBackDisabled
  }), /*#__PURE__*/react.createElement(IconButton/* default */.Z, {
    showIcon: true,
    icon: isAudioPlaying ? EgwWebFont/* default.pause */.Z.pause : EgwWebFont/* default.play */.Z.play,
    onClick: onTogglePlayClick,
    title: t("isPlaying"),
    disabled: disabled || isTogglePlayDisabled
  }), showSkipButtons && /*#__PURE__*/react.createElement(IconButton/* default */.Z, {
    showIcon: true,
    icon: EgwWebFont/* default.skip-forward */.Z["skip-forward"],
    onClick: onSkipNextClick,
    title: t("skipForward"),
    disabled: disabled || isSkipForwardDisabled
  }), showSeekButtons && /*#__PURE__*/react.createElement(IconButton/* default */.Z, {
    showIcon: true,
    icon: EgwWebFont/* default.chevron-double-right */.Z["chevron-double-right"],
    onClick: onSeekNextClick,
    title: t("seekForward"),
    disabled: disabled || isSeekForwardDisabled
  }));
};
PlayControls.propTypes = {
  className: (prop_types_default()).string,
  isAudioPlaying: (prop_types_default()).bool,
  isSeekBackDisabled: (prop_types_default()).bool,
  isSeekForwardDisabled: (prop_types_default()).bool,
  isSkipForwardDisabled: (prop_types_default()).bool,
  isSkipBackDisabled: (prop_types_default()).bool,
  isTogglePlayDisabled: (prop_types_default()).bool,
  disabled: (prop_types_default()).bool,
  showSkipButtons: (prop_types_default()).bool,
  onSkipPrevClick: (prop_types_default()).func,
  onSkipNextClick: (prop_types_default()).func,
  onSeekPrevClick: (prop_types_default()).func,
  onSeekNextClick: (prop_types_default()).func,
  onTogglePlayClick: (prop_types_default()).func
};
;// CONCATENATED MODULE: ./src/next/components/Player/PlayerControls.js












var useHandleClickPlayBtn = function useHandleClickPlayBtn() {
  var router = (0,next_router.useRouter)();
  var isReader = router.asPath.includes(routes_constants/* NEXT_URLS.read */.h.read);

  var _useAudioContext = (0,AudioContext/* useAudioContext */.YC)(),
      toggleChapterPlaying = _useAudioContext.toggleChapterPlaying;

  return function () {
    if (isReader) {
      (0,reader/* dispatchWindowEventPlayAudioInReader */.IW)();
    } else {
      toggleChapterPlaying();
    }
  };
};

var PlayControl = function PlayControl() {
  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var _useAudioContext2 = (0,AudioContext/* useAudioContext */.YC)(),
      isPlaying = _useAudioContext2.isPlaying;

  var handleClickPlay = useHandleClickPlayBtn();
  return /*#__PURE__*/react.createElement(IconButton/* default */.Z, {
    className: "header__btn-play",
    icon: isPlaying ? EgwWebFont/* default.pause-circle */.Z["pause-circle"] : EgwWebFont/* default.play-header */.Z["play-header"],
    title: isPlaying ? t("pause") : t("play"),
    active: isPlaying,
    onClick: handleClickPlay
  });
};
var SKIP = 10;

var PlayerControls = function PlayerControls(_ref) {
  var className = _ref.className;

  var _useAudioContextWithC = (0,AudioContext_hooks/* useAudioContextWithCurrentTime */.bL)((0,AudioContext/* useAudioContext */.YC)(), {
    enabled: true,
    delayUpdateTime: 1000
  }),
      isPlaying = _useAudioContextWithC.isPlaying,
      seekPlayer = _useAudioContextWithC.seekPlayer,
      skipPlayer = _useAudioContextWithC.skipPlayer,
      canSeekBack = _useAudioContextWithC.canSeekBack,
      canSeekForward = _useAudioContextWithC.canSeekForward,
      timePosition = _useAudioContextWithC.timePosition,
      duration = _useAudioContextWithC.duration;

  var handleClickPlay = useHandleClickPlayBtn();
  return /*#__PURE__*/react.createElement(PlayControls, {
    className: className,
    style: {
      width: "unset",
      gridColumnGap: "0",
      padding: "0 0.45rem"
    },
    isAudioPlaying: isPlaying,
    isSeekBackDisabled: !canSeekBack,
    onSeekPrevClick: function onSeekPrevClick() {
      return seekPlayer(false);
    },
    isSkipBackDisabled: !canSeekBack && timePosition < 0.8,
    onSkipPrevClick: function onSkipPrevClick() {
      return skipPlayer(-SKIP);
    },
    onTogglePlayClick: handleClickPlay,
    isSkipForwardDisabled: !canSeekForward && (0,number/* isDeltaEquals */.pU)(timePosition, duration, 0.8),
    onSkipNextClick: function onSkipNextClick() {
      return skipPlayer(SKIP);
    },
    isSeekForwardDisabled: !canSeekForward,
    onSeekNextClick: function onSeekNextClick() {
      return seekPlayer(true);
    }
  });
};

/* harmony default export */ var Player_PlayerControls = (PlayerControls);

/***/ }),

/***/ 41058:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _shared_components_IconView_IconView__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20844);
/* harmony import */ var src_assets_EgwWebFont__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37462);
/* harmony import */ var _components_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78239);
/* harmony import */ var _SharePopup__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75702);







var ButtonShare = function ButtonShare(_ref) {
  var url = _ref.url,
      text = _ref.text,
      refCode = _ref.refCode,
      title = _ref.title,
      className = _ref.className;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_SharePopup__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
    text: text,
    refCode: refCode,
    title: title,
    url: url,
    renderButton: function renderButton(_ref2) {
      var show = _ref2.show,
          onClick = _ref2.onClick;
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_index__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .zx, {
        active: show,
        className: className,
        onClick: onClick
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_shared_components_IconView_IconView__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        icon: src_assets_EgwWebFont__WEBPACK_IMPORTED_MODULE_3__/* ["default"].share */ .Z.share
      }));
    }
  });
};

ButtonShare.propTypes = {
  url: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  text: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  refCode: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  title: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  className: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string)
};
/* harmony default export */ __webpack_exports__["Z"] = (ButtonShare);

/***/ }),

/***/ 75702:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SharePopup_SharePopup; }
});

// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/next-i18next/dist/esm/index.js + 22 modules
var esm = __webpack_require__(60098);
// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__(23615);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ../node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(34412);
// EXTERNAL MODULE: ../node_modules/next/dynamic.js
var dynamic = __webpack_require__(65218);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/next/components/index.js + 9 modules
var components = __webpack_require__(78239);
// EXTERNAL MODULE: ../shared/utils/url/url.js
var url = __webpack_require__(59916);
// EXTERNAL MODULE: ../shared/assets/EgwWebFont.js
var EgwWebFont = __webpack_require__(59034);
;// CONCATENATED MODULE: ../shared/utils/share/share.js


var makeMessageText = function makeMessageText(maxLength) {
  var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  var refcode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
  var text = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";
  var refCodeAndUrlString = refcode || url ? " ".concat(refcode, " ").concat(url) : "";
  var textMaxAllowedLength = maxLength - refCodeAndUrlString.length;

  if (text.length > textMaxAllowedLength) {
    text = text.substr(0, textMaxAllowedLength - 1) + "…";
  }

  var finalText = text + refCodeAndUrlString;
  return finalText.trim().length ? encodeURIComponent(finalText) : "";
};
var ShareActions = [{
  icon: EgwWebFont/* default.telegram-circle */.Z["telegram-circle"],
  title: "Telegram",
  service: "telegram_share",
  action: function action(shareData) {
    var url = shareData.url,
        text = shareData.text,
        refcode = shareData.refcode;
    var content = makeMessageText(200, "", refcode, text);
    var shareUrl = "https://t.me/share/url?url=".concat(encodeURIComponent(normilizeUrl(url)), "&text=").concat(content);
    window.open(shareUrl, "_blank");
  }
}, {
  icon: EgwWebFont/* default.facebook-circle */.Z["facebook-circle"],
  title: "Facebook",
  service: "facebook",
  action: function action(shareData) {
    var url = shareData.url,
        text = shareData.text,
        refcode = shareData.refcode;
    var content = makeMessageText(400, "", refcode, text);
    var quote = "";

    if (content) {
      quote = "&quote=".concat(content);
    }
    /*let sharerUrl =
      `https://www.facebook.com/dialog/share?app_id=${FacebookId}` +
      `&display=page&href=${encodeURIComponent(normilizeUrl(url))}${quote}`;*/


    var sharerUrl = "https://www.facebook.com/sharer.php?u=".concat(encodeURIComponent(normilizeUrl(url)), "&quote=").concat(quote);
    window.open(sharerUrl, "_blank");
  }
}, {
  icon: EgwWebFont/* default.twitter-circle */.Z["twitter-circle"],
  title: "X (Twitter)",
  service: "twitter",
  action: function action(shareData) {
    var url = shareData.url,
        text = shareData.text,
        refcode = shareData.refcode;
    var shareUrl = normilizeUrl(url);
    var maxLength = 280 - (shareUrl || "").length;
    var content = makeMessageText(maxLength, "", refcode, text);
    var sharerUrl = "https://twitter.com/share?text=".concat(content, "&url=").concat(encodeURIComponent(shareUrl));
    window.open(sharerUrl, "_blank");
  }
}, {
  icon: EgwWebFont/* default.whatsapp-circle */.Z["whatsapp-circle"],
  title: "WhatsApp",
  service: "whatsapp",
  action: function action(shareData) {
    var url = shareData.url,
        text = shareData.text,
        refcode = shareData.refcode;
    var content = makeMessageText(400, normilizeUrl(url), refcode, text);
    var sharerUrl = "https://api.whatsapp.com/send?text=".concat(content);
    window.open(sharerUrl, "_blank");
  }
}, {
  icon: EgwWebFont/* default.email-circle */.Z["email-circle"],
  title: "Email",
  service: "email",
  action: function action(shareData) {
    var url = shareData.url,
        _shareData$title = shareData.title,
        title = _shareData$title === void 0 ? "" : _shareData$title,
        text = shareData.text,
        refcode = shareData.refcode;
    var shareText = makeMessageText(1300 - url.length, "", refcode, text);
    var content = "".concat(shareText, "\n").concat(encodeURIComponent(url));
    var sharerUrl = "mailto:?subject=".concat(title, "&body=").concat(content);
    window.open(sharerUrl, "_blank");
  }
}, {
  icon: EgwWebFont/* default.copy-link */.Z["copy-link"],
  title: "Link",
  service: "link",
  justCopy: true
}, {
  icon: EgwWebFont/* default.print-circle */.Z["print-circle"],
  title: "printPage",
  service: "print",
  action: function action() {
    window.print();
  }
}];
var normilizeUrl = function normilizeUrl(url) {
  if (url.indexOf("http") !== 0) {
    if (false) {}

    return window.location.origin + url;
  }

  return url;
};
// EXTERNAL MODULE: ./src/next/store/actions/index.js + 6 modules
var actions = __webpack_require__(62013);
// EXTERNAL MODULE: ./src/assets/CommonIcons.js
var CommonIcons = __webpack_require__(64666);
// EXTERNAL MODULE: ./src/assets/EgwWebFont.js
var assets_EgwWebFont = __webpack_require__(37462);
// EXTERNAL MODULE: ../shared/components/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(75448);
// EXTERNAL MODULE: ../shared/utils/content/content.js
var content = __webpack_require__(69051);
// EXTERNAL MODULE: ./src/next/components/SharePopup/share-popup.module.scss
var share_popup_module = __webpack_require__(62803);
var share_popup_module_default = /*#__PURE__*/__webpack_require__.n(share_popup_module);
;// CONCATENATED MODULE: ./src/next/components/SharePopup/SharePopup.js













var DropDown = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 68551));
}, {
  ssr: false
});

var SharePopup = function SharePopup(_ref) {
  var renderButton = _ref.renderButton,
      url = _ref.url,
      refCode = _ref.refCode,
      text = _ref.text,
      title = _ref.title;
  var dispatch = (0,es/* useDispatch */.I0)();

  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t;

  return /*#__PURE__*/react.createElement(DropDown, {
    button: function button(btnProps) {
      var show = btnProps.show,
          onClick = btnProps.onClick;
      return typeof renderButton === "function" ? renderButton(btnProps) : /*#__PURE__*/react.createElement(IconButton/* default */.Z, {
        active: show,
        icon: assets_EgwWebFont/* default.share */.Z.share,
        onClick: onClick,
        title: t("shareText")
      });
    },
    body: function body(_ref2) {
      var hide = _ref2.hide;
      return /*#__PURE__*/react.createElement("div", {
        className: (share_popup_module_default())["share-body"]
      }, ShareActions.map(function (_ref3, index) {
        var icon = _ref3.icon,
            btnTitle = _ref3.title,
            service = _ref3.service,
            action = _ref3.action,
            shareViaHtmlAttrs = _ref3.shareViaHtmlAttrs,
            justCopy = _ref3.justCopy;

        if (shareViaHtmlAttrs) {
          return /*#__PURE__*/react.createElement("a", {
            key: index,
            tabIndex: 0,
            "data-service": service,
            "data-url": url,
            href: "#"
          }, /*#__PURE__*/react.createElement(components/* Button */.zx, {
            onClick: hide
          }, /*#__PURE__*/react.createElement(CommonIcons/* GoogleTranslateIcon */.ct, {
            title: title
          })));
        }

        var iconView;

        if (typeof icon === "number") {
          iconView = /*#__PURE__*/react.createElement("i", {
            title: btnTitle,
            className: "egw-font-icon"
          }, String.fromCodePoint(icon));
        } else {
          var Tag = icon;
          iconView = /*#__PURE__*/react.createElement(Tag, {
            title: btnTitle
          });
        }

        return /*#__PURE__*/react.createElement(components/* Button */.zx, {
          tabIndex: 0,
          key: index,
          onClick: function onClick(e) {
            if (action) {
              action({
                url: url,
                title: title,
                refcode: refCode,
                text: (0,content/* removeTags */.av)(text)
              });
            } else if (justCopy) {
              dispatch(actions/* systemActions.actionCopy */.nm.actionCopy(url, {
                successMessage: t("linkCopied"),
                errorMessage: t("linkNotCopied")
              }));
            }

            hide(e);
          },
          "data-service": service,
          "data-url": url
        }, iconView);
      }));
    }
  });
};

SharePopup.propTypes = {
  renderButton: (prop_types_default()).func,
  refCode: (prop_types_default()).string,
  title: (prop_types_default()).string,
  text: (prop_types_default()).string,
  url: (prop_types_default()).string
};
/* harmony default export */ var SharePopup_SharePopup = (SharePopup);

/***/ }),

/***/ 34824:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60042);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60098);
/* harmony import */ var _shared_utils_theme_theme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93752);
/* harmony import */ var _assets_CommonIcons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64666);
/* harmony import */ var _hooks_useTheme__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88130);
/* harmony import */ var _themeMenu_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10980);
/* harmony import */ var _themeMenu_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_themeMenu_module_scss__WEBPACK_IMPORTED_MODULE_6__);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }








var themeIcons = {
  dy: _assets_CommonIcons__WEBPACK_IMPORTED_MODULE_4__/* .ThemeDayIcon */ .CR,
  dw: _assets_CommonIcons__WEBPACK_IMPORTED_MODULE_4__/* .ThemeDawnIcon */ .PU,
  dk: _assets_CommonIcons__WEBPACK_IMPORTED_MODULE_4__/* .ThemeDuskIcon */ .Ew,
  dm: _assets_CommonIcons__WEBPACK_IMPORTED_MODULE_4__/* .ThemeDarkIcon */ .Z6,
  adm: _assets_CommonIcons__WEBPACK_IMPORTED_MODULE_4__/* .ThemeHumanBlackIcon */ .T4,
  ady: _assets_CommonIcons__WEBPACK_IMPORTED_MODULE_4__/* .ThemeHumanWhiteIcon */ .Oi
};

var ThemeMenu = function ThemeMenu() {
  var _useTranslation = (0,next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)(),
      t = _useTranslation.t;

  var _useTheme = (0,_hooks_useTheme__WEBPACK_IMPORTED_MODULE_5__/* .useTheme */ .Fg)(),
      activeTheme = _useTheme.activeTheme,
      updateTheme = _useTheme.updateTheme;

  var themeModes = Object.entries(_shared_utils_theme_theme__WEBPACK_IMPORTED_MODULE_3__/* .Theme */ .Q2);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("ul", {
    className: (_themeMenu_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["theme-menu"])
  }, themeModes.map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        id = _ref2[0],
        data = _ref2[1];

    var ThemeIcon = themeIcons[data.id];

    if (!ThemeIcon) {
      return null;
    }

    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", {
      key: id,
      className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_themeMenu_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["theme-menu_list-item"]), _defineProperty({}, (_themeMenu_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["is-current"]), activeTheme === id)),
      onClick: function onClick() {
        return updateTheme(id);
      }
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ThemeIcon, null), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
      className: (_themeMenu_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["theme-menu_list-title"])
    }, t(data.label)));
  }));
};

/* harmony default export */ __webpack_exports__["Z"] = (ThemeMenu);

/***/ }),

/***/ 39036:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_ThreeDots; }
});

// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(56253);
// EXTERNAL MODULE: ../node_modules/classnames/index.js
var classnames = __webpack_require__(60042);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../shared/components/DropDown/DropDownVariantIconButton.js
var DropDownVariantIconButton = __webpack_require__(26976);
// EXTERNAL MODULE: ../shared/components/DropDown/DropDownVariantButton.js
var DropDownVariantButton = __webpack_require__(12346);
// EXTERNAL MODULE: ../shared/assets/EgwWebFont.js
var EgwWebFont = __webpack_require__(59034);
// EXTERNAL MODULE: ../shared/components/Button/Button.constants.js
var Button_constants = __webpack_require__(29718);
// EXTERNAL MODULE: ../shared/utils/react.js
var utils_react = __webpack_require__(97993);
// EXTERNAL MODULE: ../shared/utils/viewmode.js
var viewmode = __webpack_require__(24064);
;// CONCATENATED MODULE: ../shared/utils/panel/Panel.utils.js
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }




var ICONS_SORTED_BY = {
  ORDER: "ORDER",
  PRIORITY: "PRIORITY",
  HIDDEN_ORDER: "HIDDEN_ORDER"
};
var renderIcons = function renderIcons(icons, fnHideThreeDots) {
  return icons.map(function (_ref) {
    var render = _ref.render,
        key = _ref.key;
    return /*#__PURE__*/react.createElement(react.Fragment, {
      key: key
    }, (0,utils_react/* handleReactSlot */.u)(render, key, fnHideThreeDots ? {
      hide: fnHideThreeDots
    } : undefined));
  });
};
var renderColumnIcons = function renderColumnIcons(icons) {
  var maxRows = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 8;
  var iconsArray = [];
  var currentIteration = 1;
  var totalIteration = 1;
  var currentArray = [];
  icons.forEach(function (icon) {
    currentArray.push(icon);

    if (currentIteration > maxRows || icons.length === totalIteration) {
      iconsArray.push(currentArray);
      currentArray = [];
      currentIteration = 0;
    }

    currentIteration++;
    totalIteration++;
  });
  return iconsArray.map(function (icons, key) {
    return /*#__PURE__*/React.createElement("div", {
      className: "icons-column",
      key: key
    }, renderIcons(icons));
  });
};
var getIconsSorted = function getIconsSorted(icons) {
  var sortedBy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ICONS_SORTED_BY.ORDER;

  var clonedIcons = _toConsumableArray(icons);

  if (sortedBy === ICONS_SORTED_BY.PRIORITY) {
    clonedIcons.sort(function (a, b) {
      var _a$priority, _b$priority;

      return ((_a$priority = a.priority) !== null && _a$priority !== void 0 ? _a$priority : Infinity) > ((_b$priority = b.priority) !== null && _b$priority !== void 0 ? _b$priority : Infinity) ? 1 : -1;
    });
  } else if (sortedBy === ICONS_SORTED_BY.HIDDEN_ORDER) {
    clonedIcons.sort(function (a, b) {
      var _a$hiddenOrder, _b$hiddenOrder;

      return ((_a$hiddenOrder = a.hiddenOrder) !== null && _a$hiddenOrder !== void 0 ? _a$hiddenOrder : Infinity) > ((_b$hiddenOrder = b.hiddenOrder) !== null && _b$hiddenOrder !== void 0 ? _b$hiddenOrder : Infinity) ? 1 : -1;
    });
  } else {
    clonedIcons.sort(function (a, b) {
      var _a$order, _b$order;

      return ((_a$order = a.order) !== null && _a$order !== void 0 ? _a$order : Infinity) > ((_b$order = b.order) !== null && _b$order !== void 0 ? _b$order : Infinity) ? 1 : -1;
    });
  }

  return clonedIcons.filter(function (icon) {
    return icon.isShown;
  });
};
var getControlPanelIcons = function getControlPanelIcons(icons, _ref2) {
  var isCollapsed = _ref2.isCollapsed,
      parentWidth = _ref2.parentWidth,
      initialWidth = _ref2.initialWidth,
      widthBtnThreeDots = _ref2.widthBtnThreeDots,
      _ref2$defaultIconSize = _ref2.defaultIconSize,
      defaultIconSize = _ref2$defaultIconSize === void 0 ? (0,viewmode/* remToPx */.cv)(1.2 + 0.5) : _ref2$defaultIconSize;
  var widthBtn3DotsFinal = initialWidth || widthBtnThreeDots || defaultIconSize;
  var currentWidth = widthBtn3DotsFinal;
  var hiddenIcons = [];
  var visibleIcons = [];

  if (isCollapsed) {
    hiddenIcons = getIconsSorted(icons, ICONS_SORTED_BY.HIDDEN_ORDER);
  } else {
    var sortedIcons = getIconsSorted(icons);
    var sortedIconsByPriority = getIconsSorted(icons, ICONS_SORTED_BY.PRIORITY);

    var clonedSortedIconsByPriority = _toConsumableArray(sortedIconsByPriority);

    for (var i = 0; i < sortedIcons.length; i++) {
      var icon = sortedIcons[i];
      currentWidth += icon.width || defaultIconSize;
    }

    if (currentWidth >= parentWidth) {
      for (var j = 0; j < sortedIconsByPriority.length; j++) {
        var shiftedIcon = clonedSortedIconsByPriority.shift();

        if (!shiftedIcon) {
          continue;
        }

        var iconWidth = shiftedIcon.width || defaultIconSize;
        currentWidth = currentWidth - iconWidth;
        hiddenIcons.push(shiftedIcon);

        if (currentWidth < parentWidth) {
          if (j === 0 && widthBtn3DotsFinal >= iconWidth) {// prevent hide an icon and show 3 dots instead,
            // that has the same or even greater width
          } else {
            break;
          }
        }
      }
    }

    if (clonedSortedIconsByPriority.length > 0) {
      visibleIcons = getIconsSorted(clonedSortedIconsByPriority);
    }

    if (hiddenIcons.length > 0) {
      hiddenIcons = getIconsSorted(hiddenIcons, ICONS_SORTED_BY.HIDDEN_ORDER);
    }
  }

  return {
    hiddenIcons: hiddenIcons,
    visibleIcons: visibleIcons,
    showHiddenIcons: hiddenIcons.length > 0,
    showVisibleIcons: visibleIcons.length > 0,
    widthOccupied: currentWidth
  };
};
// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__(23615);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ../shared/components/DropDown/ThreeDots.constants.js
var _ThreeDotsProps;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var ThreeDotsProps = (_ThreeDotsProps = {
  className: (prop_types_default()).string,
  classNamePopupContent: (prop_types_default()).string,
  icons: (prop_types_default()).array,
  iconTitle: (prop_types_default()).string,
  idButton: (prop_types_default()).string
}, _defineProperty(_ThreeDotsProps, "idButton", (prop_types_default()).string), _defineProperty(_ThreeDotsProps, "isApplyDefault3DotsStylesToPopup", (prop_types_default()).bool), _defineProperty(_ThreeDotsProps, "isShowIconInTextMode", (prop_types_default()).bool), _defineProperty(_ThreeDotsProps, "isCollapsed", (prop_types_default()).bool), _defineProperty(_ThreeDotsProps, "isDotsPositionAfter", (prop_types_default()).bool), _defineProperty(_ThreeDotsProps, "isMobile", (prop_types_default()).bool), _defineProperty(_ThreeDotsProps, "textMode", (prop_types_default()).bool), _defineProperty(_ThreeDotsProps, "widthAvailable", (prop_types_default()).number), _defineProperty(_ThreeDotsProps, "btnThreeDotsWidth", (prop_types_default()).number), _defineProperty(_ThreeDotsProps, "onShow", (prop_types_default()).func), _defineProperty(_ThreeDotsProps, "children", (prop_types_default()).any), _ThreeDotsProps);
// EXTERNAL MODULE: ../shared/components/DropDown/ThreeDots.module.scss
var ThreeDots_module = __webpack_require__(68537);
var ThreeDots_module_default = /*#__PURE__*/__webpack_require__.n(ThreeDots_module);
;// CONCATENATED MODULE: ../shared/components/DropDown/ThreeDots.js
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { ThreeDots_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function ThreeDots_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }












var BUTTON_PROPS_TEXT_MODE = {
  fontFamily: Button_constants/* BUTTON_FONT_FAMILY.bebas */.Il.bebas
};

var ThreeDots = function ThreeDots(_ref) {
  var className = _ref.className,
      icons = _ref.icons,
      widthAvailable = _ref.widthAvailable,
      iconTitle = _ref.iconTitle,
      _ref$isApplyDefault3D = _ref.isApplyDefault3DotsStylesToPopup,
      isApplyDefault3DotsStylesToPopup = _ref$isApplyDefault3D === void 0 ? true : _ref$isApplyDefault3D,
      isShowIconInTextMode = _ref.isShowIconInTextMode,
      isCollapsed = _ref.isCollapsed,
      isDotsPositionAfter = _ref.isDotsPositionAfter,
      classNamePopupContent = _ref.classNamePopupContent,
      btnThreeDotsWidth = _ref.btnThreeDotsWidth,
      idButton = _ref.idButton,
      idPopup = _ref.idPopup,
      isMobile = _ref.isMobile,
      textMode = _ref.textMode,
      onShow = _ref.onShow,
      children = _ref.children;
  var widthBtn = btnThreeDotsWidth !== null && btnThreeDotsWidth !== void 0 ? btnThreeDotsWidth : (0,viewmode/* remToPx */.cv)(2.4);
  var hiddenIcons, visibleIcons;

  if (icons) {
    var result = getControlPanelIcons(icons, {
      widthBtnThreeDots: widthBtn,
      isCollapsed: isCollapsed !== null && isCollapsed !== void 0 ? isCollapsed : isMobile || textMode,
      parentWidth: widthAvailable
    });
    hiddenIcons = result.hiddenIcons;
    visibleIcons = result.visibleIcons;
  }

  var buttonPropsFinal = textMode ? _objectSpread(_objectSpread({}, BUTTON_PROPS_TEXT_MODE), {}, {
    id: idButton
  }) : idButton ? {
    id: idButton
  } : undefined;
  var jsxDots;
  var showTextButton = textMode && !isMobile && !isShowIconInTextMode;

  if (children || hiddenIcons && hiddenIcons.length && (hiddenIcons.length > 1 || hiddenIcons[0].width > widthBtn || showTextButton)) {
    var _classnames;

    var popupPropsFinal = {
      beautyGapHorizontal: 0,
      beautyGapVertical: 0,
      renderViewClassName: classnames_default()(classNamePopupContent, (_classnames = {}, ThreeDots_defineProperty(_classnames, (ThreeDots_module_default())["labels-mode"], textMode), ThreeDots_defineProperty(_classnames, (ThreeDots_module_default())["popup-content-default"], isApplyDefault3DotsStylesToPopup), _classnames)),
      id: idPopup
    };

    var jsxChildren = function jsxChildren(_ref2) {
      var hide = _ref2.hide;
      return children ? (0,utils_react/* handleReactSlot */.u)(children, {
        hide: hide
      }) : renderIcons(hiddenIcons, hide);
    };

    if (showTextButton) {
      jsxDots = /*#__PURE__*/react.createElement(DropDownVariantButton/* default */.Z, {
        className: className,
        onShow: onShow,
        label: iconTitle,
        buttonProps: buttonPropsFinal,
        popupProps: popupPropsFinal
      }, jsxChildren);
    } else {
      jsxDots = /*#__PURE__*/react.createElement(DropDownVariantIconButton/* default */.Z, {
        className: className,
        showIcon: true,
        isPopupCoversButtonByDefault: !isMobile,
        icon: EgwWebFont/* default.dots-vertical */.Z["dots-vertical"],
        iconTitle: iconTitle,
        buttonProps: buttonPropsFinal,
        popupProps: popupPropsFinal
      }, jsxChildren);
    }
  }

  return /*#__PURE__*/react.createElement(react.Fragment, null, !isDotsPositionAfter && jsxDots, visibleIcons && renderIcons(visibleIcons), isDotsPositionAfter && jsxDots);
};

ThreeDots.defaultProps = {
  withToggleDelayRestriction: true
};
ThreeDots.propTypes = ThreeDotsProps;
/* harmony default export */ var DropDown_ThreeDots = (ThreeDots);
;// CONCATENATED MODULE: ./src/next/components/ThreeDots.js
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }






var ThreeDots_ThreeDots = function ThreeDots(props) {
  return /*#__PURE__*/react.createElement(DropDown_ThreeDots, _extends({}, props, {
    isMobile: lib/* isMobile */.tq,
    textMode: false
  }));
};

ThreeDots_ThreeDots.propTypes = ThreeDotsProps;
/* harmony default export */ var components_ThreeDots = (ThreeDots_ThreeDots);

/***/ }),

/***/ 77084:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TileList_TileList; }
});

// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__(23615);
// EXTERNAL MODULE: ../node_modules/next-i18next/dist/esm/index.js + 22 modules
var esm = __webpack_require__(60098);
// EXTERNAL MODULE: ../node_modules/next/router.js
var next_router = __webpack_require__(86677);
// EXTERNAL MODULE: ../shared/components/IconView/IconView.js
var IconView = __webpack_require__(20844);
// EXTERNAL MODULE: ./src/next/components/Tile/tile.module.scss
var tile_module = __webpack_require__(74117);
var tile_module_default = /*#__PURE__*/__webpack_require__.n(tile_module);
;// CONCATENATED MODULE: ./src/next/components/Tile/Tile.js





var Tile = function Tile(_ref) {
  var imageUrl = _ref.imageUrl,
      image = _ref.image,
      title = _ref.title,
      linkAs = _ref.linkAs,
      count = _ref.count,
      _ref$newTab = _ref.newTab,
      newTab = _ref$newTab === void 0 ? false : _ref$newTab;
  var router = (0,next_router.useRouter)();

  var handleClick = function handleClick(e) {
    if (!newTab) {
      e.preventDefault();
      router.push(linkAs);
    }
  };

  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-no-target-blank
    react.createElement("a", {
      target: newTab ? "_blank" : "_self",
      rel: newTab ? "noreferrer" : "",
      className: (tile_module_default())["tile-list-item"],
      href: linkAs,
      onClick: handleClick
    }, imageUrl ? /*#__PURE__*/react.createElement("img", {
      alt: title,
      src: imageUrl,
      className: (tile_module_default())["tile-list-item__img"]
    }) : /*#__PURE__*/react.createElement(IconView/* default */.Z, {
      icon: image,
      className: (tile_module_default())["tile-list-item__icon"]
    }), /*#__PURE__*/react.createElement("div", {
      className: (tile_module_default())["wrapper-text"]
    }, /*#__PURE__*/react.createElement("span", {
      className: (tile_module_default())["tile-list-item__count"]
    }, count), /*#__PURE__*/react.createElement("span", {
      className: (tile_module_default())["tile-list-item__title"],
      dangerouslySetInnerHTML: {
        __html: title
      }
    })))
  );
};

/* harmony default export */ var Tile_Tile = (Tile);
// EXTERNAL MODULE: ./src/assets/CategoryIcons.js
var CategoryIcons = __webpack_require__(63666);
// EXTERNAL MODULE: ../shared/utils/theme/theme.js + 1 modules
var theme = __webpack_require__(93752);
// EXTERNAL MODULE: ./src/next/hooks/useTheme.js + 1 modules
var useTheme = __webpack_require__(88130);
// EXTERNAL MODULE: ./src/next/components/TileList/tile-list.module.scss
var tile_list_module = __webpack_require__(28790);
var tile_list_module_default = /*#__PURE__*/__webpack_require__.n(tile_list_module);
;// CONCATENATED MODULE: ./src/next/components/TileList/TileList.js
var _excluded = ["key", "title", "imageUrl", "count", "className", "id"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }










var TileList = function TileList(_ref) {
  var items = _ref.items;

  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var _useTheme = (0,useTheme/* useTheme */.Fg)(),
      activeTheme = _useTheme.activeTheme;

  var _useState = (0,react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      darkTheme = _useState2[0],
      setDarkTheme = _useState2[1]; // Fixes hydration error: Prop `className` did not match.


  (0,react.useEffect)(function () {
    setDarkTheme((0,theme/* isDarkTheme */.$o)(activeTheme));
  }, [activeTheme]);
  return /*#__PURE__*/react.createElement("div", {
    className: (tile_list_module_default())["tile-list"]
  }, items.map(function (_ref2) {
    var key = _ref2.key,
        title = _ref2.title,
        imageUrl = _ref2.imageUrl,
        count = _ref2.count,
        className = _ref2.className,
        id = _ref2.id,
        restProps = _objectWithoutProperties(_ref2, _excluded);

    return /*#__PURE__*/react.createElement(Tile_Tile, _extends({
      key: key,
      count: count ? "".concat(count, " ").concat(t("books")) : undefined,
      title: t(title),
      image: (0,CategoryIcons/* getImageByClass */.o)(className, darkTheme, id),
      imageUrl: imageUrl
    }, restProps));
  }));
};

TileList.propTypes = {
  items: prop_types.array
};
/* harmony default export */ var TileList_TileList = (TileList);

/***/ }),

/***/ 19158:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ EL_ID_TOP_PANEL; }
/* harmony export */ });
var EL_ID_TOP_PANEL = "topPanel";

/***/ }),

/***/ 53743:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60042);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34412);
/* harmony import */ var _shared_store_system_selectors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91809);
/* harmony import */ var _components_TopPanel_TopPanel_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19158);
/* harmony import */ var _top_panel_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35150);
/* harmony import */ var _top_panel_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_top_panel_module_scss__WEBPACK_IMPORTED_MODULE_6__);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









var TopPanel = function TopPanel(_ref) {
  var className = _ref.className,
      children = _ref.children;
  var isTopPanelVisible = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(_shared_store_system_selectors__WEBPACK_IMPORTED_MODULE_4__/* .selectorSystemIsTopPanelVisible */ .eq);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    id: _components_TopPanel_TopPanel_constants__WEBPACK_IMPORTED_MODULE_5__/* .EL_ID_TOP_PANEL */ .d,
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(className, (_top_panel_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["top-panel"]), _defineProperty({}, (_top_panel_module_scss__WEBPACK_IMPORTED_MODULE_6___default().hidden), !isTopPanelVisible))
  }, children);
};

TopPanel.propTypes = {
  className: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  children: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().any)
};
/* harmony default export */ __webpack_exports__["default"] = (TopPanel);

/***/ }),

/***/ 78239:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "UQ": function() { return /* reexport */ Accordion/* default */.Z; },
  "e0": function() { return /* reexport */ ArrowIcon/* default */.Z; },
  "i$": function() { return /* reexport */ Book_BookActions; },
  "F6": function() { return /* reexport */ BookList/* default */.Z; },
  "zx": function() { return /* reexport */ Button/* default */.Z; },
  "Nm": function() { return /* reexport */ Button_ButtonArrow; },
  "gY": function() { return /* reexport */ Button_ButtonQRCode; },
  "XZ": function() { return /* reexport */ Checkbox/* default */.Z; },
  "cO": function() { return /* reexport */ CheckboxGroup/* default */.Z; },
  "PZ": function() { return /* reexport */ CloseButton/* default */.Z; },
  "W2": function() { return /* reexport */ Container/* default */.Z; },
  "fG": function() { return /* reexport */ Delimiter/* default */.Z; },
  "Fb": function() { return /* reexport */ Head/* default */.Z; },
  "II": function() { return /* reexport */ Input/* default */.Z; },
  "Qj": function() { return /* reexport */ LinkButton/* default */.Z; },
  "Zn": function() { return /* reexport */ MainLayout/* default */.Z; },
  "po": function() { return /* reexport */ SharePopup/* default */.Z; },
  "o2": function() { return /* reexport */ subscriptions_SubscriptionsRead; },
  "Gj": function() { return /* reexport */ ThemeMenu/* default */.Z; },
  "GD": function() { return /* reexport */ TileList/* default */.Z; },
  "ZT": function() { return /* reexport */ Typography/* default */.Z; },
  "EB": function() { return /* reexport */ Typography_TypographyCropped; }
});

// UNUSED EXPORTS: Header, LanguageSelector, RadioGroup

// NAMESPACE OBJECT: ./src/next/components/index.js
var components_namespaceObject = {};
__webpack_require__.r(components_namespaceObject);
__webpack_require__.d(components_namespaceObject, {
  "UQ": function() { return Accordion/* default */.Z; },
  "e0": function() { return ArrowIcon/* default */.Z; },
  "i$": function() { return Book_BookActions; },
  "F6": function() { return BookList/* default */.Z; },
  "zx": function() { return Button/* default */.Z; },
  "Nm": function() { return Button_ButtonArrow; },
  "gY": function() { return Button_ButtonQRCode; },
  "XZ": function() { return Checkbox/* default */.Z; },
  "cO": function() { return CheckboxGroup/* default */.Z; },
  "PZ": function() { return CloseButton/* default */.Z; },
  "W2": function() { return Container/* default */.Z; },
  "fG": function() { return Delimiter/* default */.Z; },
  "Fb": function() { return Head/* default */.Z; },
  "II": function() { return Input/* default */.Z; },
  "Qj": function() { return LinkButton/* default */.Z; },
  "Zn": function() { return MainLayout/* default */.Z; },
  "po": function() { return SharePopup/* default */.Z; },
  "o2": function() { return subscriptions_SubscriptionsRead; },
  "Gj": function() { return ThemeMenu/* default */.Z; },
  "GD": function() { return TileList/* default */.Z; },
  "ZT": function() { return Typography/* default */.Z; },
  "EB": function() { return Typography_TypographyCropped; }
});

// EXTERNAL MODULE: ../shared/components/Button/Button.js
var Button = __webpack_require__(18170);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(34412);
// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__(23615);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ../node_modules/classnames/index.js
var classnames = __webpack_require__(60042);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../node_modules/next-i18next/dist/esm/index.js + 22 modules
var esm = __webpack_require__(60098);
// EXTERNAL MODULE: ../node_modules/next/router.js
var next_router = __webpack_require__(86677);
// EXTERNAL MODULE: ./src/next/contexts/subscriptions.js + 1 modules
var contexts_subscriptions = __webpack_require__(36895);
// EXTERNAL MODULE: ../shared/hooks/useShopBook.js
var useShopBook = __webpack_require__(36746);
// EXTERNAL MODULE: ./src/next/utils/routes/routes.js
var routes = __webpack_require__(69994);
// EXTERNAL MODULE: ../shared/utils/init-actions.js
var init_actions = __webpack_require__(4727);
// EXTERNAL MODULE: ../shared/utils/url/url.js
var url = __webpack_require__(59916);
// EXTERNAL MODULE: ../shared/components/Button/Button.constants.js
var Button_constants = __webpack_require__(29718);
// EXTERNAL MODULE: ../shared/contexts/AudioContext.js
var AudioContext = __webpack_require__(77926);
// EXTERNAL MODULE: ./src/next/store/actions/settings.actions.js
var settings_actions = __webpack_require__(90487);
// EXTERNAL MODULE: ./src/next/store/actions/toc.actions.js
var toc_actions = __webpack_require__(4164);
// EXTERNAL MODULE: ../shared/store/toc/selectors.js
var selectors = __webpack_require__(8962);
// EXTERNAL MODULE: ../shared/store/system/selectors.js
var system_selectors = __webpack_require__(91809);
// EXTERNAL MODULE: ../shared/utils/settings/constants.js + 1 modules
var constants = __webpack_require__(20467);
// EXTERNAL MODULE: ./src/next/utils/landing/landing.constants.js
var landing_constants = __webpack_require__(13257);
// EXTERNAL MODULE: ../shared/utils/multilang/constants.js
var multilang_constants = __webpack_require__(76439);
;// CONCATENATED MODULE: ./src/next/views/BookLanding/ShareMaterials.js
var _mapTitleSharingMater;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








var rootMaterialHref = "https://ellenwhite.ourproshop.com/#Category";
var mapTitleSharingMaterialHref = (_mapTitleSharingMater = {
  "108": "".concat(rootMaterialHref, "3"),
  // Steps to Christ
  "150": "".concat(rootMaterialHref, "4"),
  // Thoughts From the Mount of Blessing
  "15": "".concat(rootMaterialHref, "5"),
  // Christ’s Object Lessons
  "135": "".concat(rootMaterialHref, "6"),
  // The Ministry of Healing
  "29": "".concat(rootMaterialHref, "7"),
  // Education
  "84": "".concat(rootMaterialHref, "8"),
  // Patriarchs and Prophets
  "88": "".concat(rootMaterialHref, "9"),
  // Prophets and Kings
  "130": "".concat(rootMaterialHref, "10"),
  // The Desire of Ages
  "127": "".concat(rootMaterialHref, "11"),
  // The Acts of the Apostles
  "132": "".concat(rootMaterialHref, "12")
}, _defineProperty(_mapTitleSharingMater, landing_constants/* MAP_LANDING_BOOKS_SET_ID_TO_CONFIG */.c2[landing_constants/* idCategoryCOA */.$F].title, "".concat(rootMaterialHref, "14")), _defineProperty(_mapTitleSharingMater, landing_constants/* MAP_LANDING_BOOKS_SET_ID_TO_CONFIG */.c2[landing_constants/* idCategoryCONFLICT */.ts].title, "".concat(rootMaterialHref, "18")), _defineProperty(_mapTitleSharingMater, landing_constants/* MAP_LANDING_BOOKS_SET_ID_TO_CONFIG */.c2[landing_constants/* idCategoryRPRAC */.v_].title, "".concat(rootMaterialHref, "20")), _mapTitleSharingMater);

var ShareMaterials = function ShareMaterials(_ref) {
  var _ref$buttonVariant = _ref.buttonVariant,
      buttonVariant = _ref$buttonVariant === void 0 ? Button_constants/* BUTTON_VARIANT.outline */.RN.outline : _ref$buttonVariant,
      _ref$buttonColor = _ref.buttonColor,
      buttonColor = _ref$buttonColor === void 0 ? Button_constants/* BUTTON_COLOR.secondary */.tY.secondary : _ref$buttonColor,
      href = _ref.href;

  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t;

  return /*#__PURE__*/react.createElement(LinkButton/* default */.Z, {
    target: "_blank",
    variant: buttonVariant,
    color: buttonColor,
    href: href
  }, t(multilang_constants/* I18N_NAMESPACE.books */.E3.books + ":" + "sharingMaterials"));
};

ShareMaterials.propTypes = {
  buttonVariant: (prop_types_default()).string,
  buttonColor: (prop_types_default()).string,
  href: (prop_types_default()).string
};
/* harmony default export */ var BookLanding_ShareMaterials = (ShareMaterials);
// EXTERNAL MODULE: ./src/next/store/actions/index.js + 6 modules
var actions = __webpack_require__(62013);
// EXTERNAL MODULE: ./src/next/contexts/pageProps.js
var pageProps = __webpack_require__(2978);
// EXTERNAL MODULE: ./src/next/components/Book/BookActions.module.scss
var BookActions_module = __webpack_require__(91677);
var BookActions_module_default = /*#__PURE__*/__webpack_require__.n(BookActions_module);
;// CONCATENATED MODULE: ./src/next/components/Book/BookActions.js
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function BookActions_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }


























var ButtonSubscribe = function ButtonSubscribe(_ref) {
  var book = _ref.book;

  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var _useSubscriptionsCont = (0,contexts_subscriptions/* useSubscriptionsContext */.T)(),
      isSubscribedBook = _useSubscriptionsCont.isSubscribedBook;

  var subscription = isSubscribedBook(book);
  return /*#__PURE__*/react.createElement(LinkButton/* default */.Z, {
    isOnLineOnly: true,
    target: "_blank",
    variant: Button_constants/* BUTTON_VARIANT.outline */.RN.outline,
    color: Button/* default.color.secondary */.Z.color.secondary,
    href: "".concat((0,url/* getCPanelUrl */.gU)(), "/subscriptions/add")
  }, subscription ? t("subscribed") : t("subscribe"));
};

var BookActions = function BookActions(_ref2) {
  var _classNames4;

  var isOnlyReadButton = _ref2.isOnlyReadButton,
      isLanding = _ref2.isLanding,
      _ref2$buttonVariant = _ref2.buttonVariant,
      buttonVariant = _ref2$buttonVariant === void 0 ? Button_constants/* BUTTON_VARIANT.outline */.RN.outline : _ref2$buttonVariant,
      _ref2$buttonColor = _ref2.buttonColor,
      buttonColor = _ref2$buttonColor === void 0 ? Button_constants/* BUTTON_COLOR.secondary */.tY.secondary : _ref2$buttonColor,
      book = _ref2.book,
      hasBtnShareMaterials = _ref2.hasBtnShareMaterials,
      shareMaterialsTitleCustom = _ref2.shareMaterialsTitleCustom,
      isBookInfoActions = _ref2.isBookInfoActions,
      forceShowBuyBook = _ref2.forceShowBuyBook;

  var _useTranslation2 = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation2.t;

  var dispatch = (0,es/* useDispatch */.I0)();
  var router = (0,next_router.useRouter)();

  var _useAudioContext = (0,AudioContext/* useAudioContext */.YC)(),
      playChapterAndShowPlayer = _useAudioContext.playChapterAndShowPlayer;

  var _useShopBook = (0,useShopBook/* useShopBook */.q)(book),
      isAvailable = _useShopBook.isAvailable,
      shopPackage = _useShopBook.shopPackage;

  var _usePagePropsContext = (0,pageProps/* usePagePropsContext */.b)(),
      urlOrigin = _usePagePropsContext.urlOrigin;

  var tocItems = (0,es/* useSelector */.v9)(selectors/* selectorTocItems */.L);
  var onLine = (0,es/* useSelector */.v9)(system_selectors/* selectorSystemOnLine */.JU);

  var _useState = (0,react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isReadListenDisabled = _useState2[0],
      setIsReadListenDisabled = _useState2[1];

  var pageLink = urlOrigin + router.basePath + router.asPath.split("#")[0];
  var id = book.id,
      title = book.title,
      code = book.code,
      description = book.description,
      buy_link = book.buy_link;
  var _book$files = book.files,
      mobi = _book$files.mobi,
      mp3 = _book$files.mp3,
      epub = _book$files.epub,
      pdf = _book$files.pdf;
  var bookToc = book ? tocItems[book.book_id] : null;
  var bookHasToc = !!(bookToc !== null && bookToc !== void 0 && bookToc.length);

  var getIdAndPositionToOpenBook = function getIdAndPositionToOpenBook(isGonnaListen) {
    return new Promise(function (resolve) {
      dispatch(actions/* libraryActions.getIdAndPositionToOpenBook */.jK.getIdAndPositionToOpenBook(id, isGonnaListen, true, true, true, true, resolve));
    });
  };

  var getChapterIdToRead = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var res;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getIdAndPositionToOpenBook(false);

          case 2:
            res = _context.sent;
            return _context.abrupt("return", res.id);

          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));

    return function getChapterIdToRead() {
      return _ref3.apply(this, arguments);
    };
  }();

  var getPlayerDataToListen = function getPlayerDataToListen() {
    return getIdAndPositionToOpenBook(true);
  };

  var handleClickListen = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var _yield$getPlayerDataT, id, position;

      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return getPlayerDataToListen();

          case 2:
            _yield$getPlayerDataT = _context2.sent;
            id = _yield$getPlayerDataT.id;
            position = _yield$getPlayerDataT.position;

            if (id) {
              playChapterAndShowPlayer(id, position);
              dispatch(settings_actions/* settingsActions.updateSettings */.f.updateSettings(constants/* SETTING.syncPlayerAndReader.id */.Fy.syncPlayerAndReader.id, true));
            }

          case 6:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));

    return function handleClickListen() {
      return _ref4.apply(this, arguments);
    };
  }();

  var handleContextMenuListen = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var _yield$getPlayerDataT2, id, position;

      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return getPlayerDataToListen();

          case 2:
            _yield$getPlayerDataT2 = _context3.sent;
            id = _yield$getPlayerDataT2.id;
            position = _yield$getPlayerDataT2.position;
            return _context3.abrupt("return", (0,init_actions/* makeHashInitActionListen */.pk)(id, position));

          case 6:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));

    return function handleContextMenuListen() {
      return _ref5.apply(this, arguments);
    };
  }();

  var handleClickRead = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            dispatch(settings_actions/* settingsActions.updateSettings */.f.updateSettings(constants/* SETTING.syncPlayerAndReader.id */.Fy.syncPlayerAndReader.id, true));

            if (!onLine) {
              _context4.next = 11;
              break;
            }

            _context4.t0 = router;
            _context4.t1 = routes/* makeChapterUrl */.ME;
            _context4.next = 6;
            return getChapterIdToRead();

          case 6:
            _context4.t2 = _context4.sent;
            _context4.t3 = (0, _context4.t1)(_context4.t2);

            _context4.t0.push.call(_context4.t0, _context4.t3);

            _context4.next = 18;
            break;

          case 11:
            _context4.t4 = window.location;
            _context4.t5 = routes/* makeChapterUrl */.ME;
            _context4.next = 15;
            return getChapterIdToRead();

          case 15:
            _context4.t6 = _context4.sent;
            _context4.t7 = (0, _context4.t5)(_context4.t6);

            _context4.t4.assign.call(_context4.t4, _context4.t7);

          case 18:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));

    return function handleClickRead() {
      return _ref6.apply(this, arguments);
    };
  }();

  var handleContextMenuRead = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _context5.t0 = routes/* makeChapterUrl */.ME;
            _context5.next = 3;
            return getChapterIdToRead();

          case 3:
            _context5.t1 = _context5.sent;
            return _context5.abrupt("return", (0, _context5.t0)(_context5.t1));

          case 5:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));

    return function handleContextMenuRead() {
      return _ref7.apply(this, arguments);
    };
  }(); // Fetches book TOC.


  (0,react.useEffect)(function () {
    if (!bookToc) {
      dispatch(toc_actions/* tocActions.fetch */.b.fetch(book.book_id));
    }
  }, [bookToc, book]); // Disable buttons with debounce, to prevent disabled styles blinking.
  // It's too noticeable on Book.Set Home page carousel,
  // when changing current book of the books set.

  (0,react.useEffect)(function () {
    var idTimer;

    if (!bookHasToc) {
      idTimer = setTimeout(function () {
        setIsReadListenDisabled(true);
      }, 1250);
    }

    return function () {
      clearTimeout(idTimer);
      setIsReadListenDisabled(false);
    };
  }, [bookHasToc]); // On unmount: cancel possible running getting id and position to open a book.

  (0,react.useEffect)(function () {
    return function () {
      dispatch(actions/* libraryActions.cancelGetIdAndPositionToOpenBook */.jK.cancelGetIdAndPositionToOpenBook());
    };
  }, []);
  var readButton = /*#__PURE__*/react.createElement(Button/* default */.Z, {
    className: landing_constants/* LANDING_SELECTORS.readBookBtn.substring */.QR.readBookBtn.substring(1),
    isContextMenuCustom: true,
    disabled: isReadListenDisabled,
    onClick: handleClickRead,
    onContextMenu: handleContextMenuRead
  }, t("read"));
  var listenButton = /*#__PURE__*/react.createElement(Button/* default */.Z, {
    id: landing_constants/* LANDING_SELECTORS.listenBookBtn.substring */.QR.listenBookBtn.substring(1),
    isOnLineOnly: true,
    isContextMenuCustom: true,
    color: Button/* default.color.secondary */.Z.color.secondary,
    onClick: handleClickListen,
    onContextMenu: handleContextMenuListen,
    disabled: !book.is_audiobook || isReadListenDisabled
  }, t("listen"));

  if (isOnlyReadButton) {
    return readButton;
  }

  if (isBookInfoActions) {
    return /*#__PURE__*/react.createElement("div", {
      className: (BookActions_module_default())["book-info-actions"]
    }, readButton, listenButton, /*#__PURE__*/react.createElement(Button_ButtonQRCode, {
      withLabelBeforeIcon: "QR CODE",
      variant: Button/* default.variant.default */.Z.variant["default"],
      size: "1.2rem"
    }));
  }

  var shareHref = mapTitleSharingMaterialHref[shareMaterialsTitleCustom !== null && shareMaterialsTitleCustom !== void 0 ? shareMaterialsTitleCustom : book.book_id] || "";
  return /*#__PURE__*/react.createElement("div", {
    className: classnames_default()((BookActions_module_default())["book-actions"], BookActions_defineProperty({}, (BookActions_module_default())["book-actions_landing"], isLanding))
  }, /*#__PURE__*/react.createElement("div", {
    className: classnames_default()((BookActions_module_default())["book-details-actions-row"], BookActions_defineProperty({}, (BookActions_module_default())["book-details-actions-row_landing"], isLanding))
  }, !isAvailable ? /*#__PURE__*/react.createElement(LinkButton/* default */.Z, {
    isOnLineOnly: true,
    href: (0,url/* getMainAppHost */.oq)() + router.asPath,
    variant: Button/* default.variant.default */.Z.variant["default"],
    color: Button/* default.color.tertiary */.Z.color.tertiary
  }, t("buyBook")) : readButton, shopPackage && !isAvailable ? /*#__PURE__*/react.createElement(LinkButton/* default */.Z, {
    isOnLineOnly: true,
    target: "_blank",
    href: (0,url/* getMainAppHost */.oq)() + router.asPath,
    variant: Button_constants/* BUTTON_VARIANT.outline */.RN.outline,
    color: Button/* default.color.tertiary */.Z.color.tertiary
  }, t("buySet")) : listenButton), /*#__PURE__*/react.createElement("div", {
    className: classnames_default()((BookActions_module_default())["book-details-actions-row"], BookActions_defineProperty({}, (BookActions_module_default())["book-details-actions-row_landing"], isLanding))
  }, /*#__PURE__*/react.createElement(LinkButton/* default */.Z, {
    id: landing_constants/* LANDING_SELECTORS.pdfBookBtn.substring */.QR.pdfBookBtn.substring(1),
    isOnLineOnly: true,
    isContextMenuCustom: true,
    target: "_blank",
    variant: buttonVariant,
    color: buttonColor,
    size: isLanding ? undefined : Button_constants/* BUTTON_SIZES.small */.Gt.small,
    href: (0,url/* makeResourceUrl */.c7)(pdf),
    disabled: !pdf
  }, t("pdf")), /*#__PURE__*/react.createElement(LinkButton/* default */.Z, {
    id: landing_constants/* LANDING_SELECTORS.ePubBookBtn.substring */.QR.ePubBookBtn.substring(1),
    isOnLineOnly: true,
    isContextMenuCustom: true,
    target: "_blank",
    variant: buttonVariant,
    color: buttonColor,
    size: isLanding ? undefined : Button_constants/* BUTTON_SIZES.small */.Gt.small,
    href: (0,url/* makeResourceUrl */.c7)(epub),
    disabled: !epub
  }, t("epub")), !isLanding && /*#__PURE__*/react.createElement(LinkButton/* default */.Z, {
    isOnLineOnly: true,
    variant: Button_constants/* BUTTON_VARIANT.outline */.RN.outline,
    color: Button/* default.color.secondary */.Z.color.secondary,
    size: Button_constants/* BUTTON_SIZES.small */.Gt.small,
    href: (0,url/* makeResourceUrl */.c7)(mobi),
    disabled: !mobi
  }, t("mobi")), !isLanding && /*#__PURE__*/react.createElement(LinkButton/* default */.Z, {
    isOnLineOnly: true,
    variant: Button_constants/* BUTTON_VARIANT.outline */.RN.outline,
    color: Button/* default.color.secondary */.Z.color.secondary,
    size: Button_constants/* BUTTON_SIZES.small */.Gt.small,
    href: (0,url/* makeResourceUrl */.c7)(mp3),
    disabled: !mp3
  }, t("mp3"))), /*#__PURE__*/react.createElement("div", {
    className: classnames_default()((BookActions_module_default())["book-details-actions-row"], (_classNames4 = {}, BookActions_defineProperty(_classNames4, (BookActions_module_default())["book-details-actions-row_landing"], isLanding), BookActions_defineProperty(_classNames4, (BookActions_module_default())["actions-row-only-buy"], !(hasBtnShareMaterials && shareHref)), _classNames4))
  }, isLanding && (buy_link || forceShowBuyBook) && /*#__PURE__*/react.createElement(LinkButton/* default */.Z, {
    isOnLineOnly: true,
    isContextMenuCustom: true,
    target: "_blank",
    variant: buttonVariant,
    color: buttonColor,
    size: isLanding ? undefined : Button_constants/* BUTTON_SIZES.medium */.Gt.medium,
    href: buy_link === null ? "" : buy_link,
    disabled: buy_link === null
  }, t("buyPrintedBook")), hasBtnShareMaterials && shareHref ? /*#__PURE__*/react.createElement(BookLanding_ShareMaterials, {
    buttonVariant: buttonVariant,
    buttonColor: buttonColor,
    href: shareHref
  }) : // Don't show "share" button if there is no "buy" button - requirement.
  isLanding && !buy_link ? null : /*#__PURE__*/react.createElement(SharePopup/* default */.Z, {
    url: pageLink,
    title: title,
    refCode: code,
    text: description,
    renderButton: function renderButton(_ref8) {
      var show = _ref8.show,
          onClick = _ref8.onClick;
      return /*#__PURE__*/react.createElement(Button/* default */.Z, {
        style: {
          width: "100%"
        },
        active: show,
        variant: buttonVariant,
        color: buttonColor,
        size: isLanding ? undefined : Button_constants/* BUTTON_SIZES.medium */.Gt.medium,
        onClick: onClick
      }, t("share"));
    }
  })), !isLanding && /*#__PURE__*/react.createElement("div", {
    className: classnames_default()((BookActions_module_default())["book-details-actions-row"], BookActions_defineProperty({}, (BookActions_module_default())["book-details-actions-row_landing"], isLanding))
  }, /*#__PURE__*/react.createElement(ButtonSubscribe, {
    book: book
  })));
};

BookActions.propTypes = {
  isLanding: (prop_types_default()).bool,
  buttonVariant: (prop_types_default()).string,
  buttonColor: (prop_types_default()).string,
  isOnlyReadButton: (prop_types_default()).bool,
  book: (prop_types_default()).object,
  hasBtnBuyBook: (prop_types_default()).bool,
  hasBtnShareBook: (prop_types_default()).bool,
  hasBtnShareMaterials: (prop_types_default()).bool,
  shareMaterialsTitleCustom: (prop_types_default()).string,
  urlOrigin: (prop_types_default()).string,
  isBookInfoActions: (prop_types_default()).bool,
  forceShowBuyBook: (prop_types_default()).bool
};
/* harmony default export */ var Book_BookActions = (BookActions);
// EXTERNAL MODULE: ./src/next/components/Button/LinkButton.js
var LinkButton = __webpack_require__(30508);
// EXTERNAL MODULE: ../shared/components/Button/CloseButton/CloseButton.js
var CloseButton = __webpack_require__(72064);
// EXTERNAL MODULE: ./src/next/components/Container/Container.js
var Container = __webpack_require__(84611);
// EXTERNAL MODULE: ./src/next/components/MainLayout/MainLayout.js + 7 modules
var MainLayout = __webpack_require__(19162);
// EXTERNAL MODULE: ./src/next/components/ThemeMenu/ThemeMenu.js
var ThemeMenu = __webpack_require__(34824);
// EXTERNAL MODULE: ./src/next/components/Head/Head.js + 4 modules
var Head = __webpack_require__(36037);
// EXTERNAL MODULE: ./src/next/components/Header/Header.js
var Header = __webpack_require__(75580);
// EXTERNAL MODULE: ./src/next/components/Delimiter/Delimiter.js
var Delimiter = __webpack_require__(50478);
// EXTERNAL MODULE: ./src/next/components/TileList/TileList.js + 1 modules
var TileList = __webpack_require__(77084);
// EXTERNAL MODULE: ./src/next/components/Book/BookList.js
var BookList = __webpack_require__(97855);
// EXTERNAL MODULE: ./src/next/components/SharePopup/SharePopup.js + 1 modules
var SharePopup = __webpack_require__(75702);
// EXTERNAL MODULE: ./src/next/components/LanguageSelector/LanguageSelector.js
var LanguageSelector = __webpack_require__(139);
// EXTERNAL MODULE: ./src/next/components/Accordion/Accordion.js
var Accordion = __webpack_require__(98861);
// EXTERNAL MODULE: ../shared/components/ArrowIcon/ArrowIcon.js + 1 modules
var ArrowIcon = __webpack_require__(93588);
// EXTERNAL MODULE: ../node_modules/next/dynamic.js
var dynamic = __webpack_require__(65218);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../shared/utils/subscriptions.js
var subscriptions = __webpack_require__(8816);
// EXTERNAL MODULE: ./src/assets/CommonIcons.js
var CommonIcons = __webpack_require__(64666);
// EXTERNAL MODULE: ./src/next/components/subscriptions/subscriptionSwitcher.module.scss
var subscriptionSwitcher_module = __webpack_require__(94770);
var subscriptionSwitcher_module_default = /*#__PURE__*/__webpack_require__.n(subscriptionSwitcher_module);
;// CONCATENATED MODULE: ./src/next/components/subscriptions/SubscriptionSwitcher.js
function SubscriptionSwitcher_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }












var SubscriptionSwitcher = function SubscriptionSwitcher(_ref) {
  var subscriptionContent = _ref.subscriptionContent,
      currentIndex = _ref.currentIndex;

  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var _useSubscriptionsCont = (0,contexts_subscriptions/* useSubscriptionsContext */.T)(),
      date = _useSubscriptionsCont.date;

  var router = (0,next_router.useRouter)();

  var onNavByList = function onNavByList(diff) {
    router.replace((0,subscriptions/* makeSubsReadUrl */.z)(date, subscriptionContent[currentIndex + diff].book_id));
  };

  var onSelectHandler = function onSelectHandler(bookId) {
    router.replace((0,subscriptions/* makeSubsReadUrl */.z)(date, bookId));
  };

  return /*#__PURE__*/react.createElement("div", {
    className: (subscriptionSwitcher_module_default())["subs-switcher"]
  }, /*#__PURE__*/react.createElement(Button/* default */.Z, {
    disabled: !subscriptionContent[currentIndex - 1],
    className: (subscriptionSwitcher_module_default())["subs-switcher-icon"],
    onClick: function onClick() {
      return onNavByList(-1);
    }
  }, /*#__PURE__*/react.createElement(CommonIcons/* ChevronLeftIcon */.wy, null)), /*#__PURE__*/react.createElement(components_namespaceObject.DropDown, {
    button: function button(_ref2) {
      var show = _ref2.show,
          onClick = _ref2.onClick;
      return /*#__PURE__*/react.createElement(Button/* default */.Z, {
        active: show,
        title: t("subscriptionsList"),
        className: classnames_default()((subscriptionSwitcher_module_default())["subs-switcher-icon"], (subscriptionSwitcher_module_default())["subs-switcher-icon-bird"]),
        onClick: onClick
      }, /*#__PURE__*/react.createElement(CommonIcons/* SubscribeIcon */.bv, null));
    },
    body: function body(_ref3) {
      var hide = _ref3.hide;
      return /*#__PURE__*/react.createElement("div", {
        className: (subscriptionSwitcher_module_default())["popup-subs-list"]
      }, subscriptionContent.map(function (item, index) {
        return /*#__PURE__*/react.createElement("div", {
          key: item.book_id,
          className: classnames_default()((subscriptionSwitcher_module_default())["popup-subs-item"], SubscriptionSwitcher_defineProperty({}, (subscriptionSwitcher_module_default())["is-active"], currentIndex === index)),
          onClick: function onClick() {
            onSelectHandler(item.book_id);
            hide();
          }
        }, /*#__PURE__*/react.createElement("span", {
          className: (subscriptionSwitcher_module_default())["popup-subs-item-text"]
        }, item.book_title));
      }));
    }
  }), /*#__PURE__*/react.createElement(Button/* default */.Z, {
    disabled: !subscriptionContent[currentIndex + 1],
    className: (subscriptionSwitcher_module_default())["subs-switcher-icon"],
    onClick: function onClick() {
      return onNavByList(1);
    }
  }, /*#__PURE__*/react.createElement(CommonIcons/* ChevronRightIcon */.XC, null)));
};

SubscriptionSwitcher.propTypes = {
  currentIndex: (prop_types_default()).number,
  subscriptionContent: (prop_types_default()).array
};
/* harmony default export */ var subscriptions_SubscriptionSwitcher = (SubscriptionSwitcher);
// EXTERNAL MODULE: ./src/next/components/subscriptions/Subscriptions.utils.js
var Subscriptions_utils = __webpack_require__(58753);
// EXTERNAL MODULE: ../shared/hooks/useMediaQuery.js
var useMediaQuery = __webpack_require__(38295);
// EXTERNAL MODULE: ../shared/components/IconView/IconView.js
var IconView = __webpack_require__(20844);
// EXTERNAL MODULE: ./src/next/components/subscriptions/SubscriptionsDatePicker.js + 2 modules
var SubscriptionsDatePicker = __webpack_require__(63086);
// EXTERNAL MODULE: ../shared/components/DateSwitcher/dateSwitcher/DateSwitcher.js
var DateSwitcher = __webpack_require__(67442);
// EXTERNAL MODULE: ../shared/utils/date/index.js
var utils_date = __webpack_require__(96112);
// EXTERNAL MODULE: ./src/assets/EgwWebFont.js
var EgwWebFont = __webpack_require__(37462);
// EXTERNAL MODULE: ./src/next/components/subscriptions/subscriptions.module.scss
var subscriptions_module = __webpack_require__(90843);
var subscriptions_module_default = /*#__PURE__*/__webpack_require__.n(subscriptions_module);
;// CONCATENATED MODULE: ./src/next/components/subscriptions/SubsReadTopPanel.js
var _excluded = ["currentSub", "onDateChange", "openReaderHandler"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



















var DropDown = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 68551));
}, {
  ssr: false
});

var SubsReadTopPanel = function SubsReadTopPanel(_ref) {
  var currentSub = _ref.currentSub,
      onDateChange = _ref.onDateChange,
      openReaderHandler = _ref.openReaderHandler,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var _useSubscriptionsCont = (0,contexts_subscriptions/* useSubscriptionsContext */.T)(),
      subscriptions = _useSubscriptionsCont.subscriptions,
      date = _useSubscriptionsCont.date;

  var isMobile = (0,useMediaQuery/* default */.Z)(useMediaQuery/* MEDIA_QUERIES.untilTablet */.q.untilTablet);
  var shareData = (0,Subscriptions_utils/* getShareData */.X)(currentSub);
  var threeDotsIcons = /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(subscriptions_SubscriptionSwitcher, restProps), /*#__PURE__*/react.createElement(SharePopup/* default */.Z, _extends({}, shareData, {
    renderButton: function renderButton(_ref2) {
      var show = _ref2.show,
          onClick = _ref2.onClick;
      return /*#__PURE__*/react.createElement(IconView/* default */.Z, {
        icon: EgwWebFont/* default.share */.Z.share,
        className: (subscriptions_module_default())["subs-share-icon"],
        active: show,
        onClick: onClick
      });
    }
  })));
  return /*#__PURE__*/react.createElement("div", {
    className: classnames_default()((subscriptions_module_default())["subs-top-panel"], (subscriptions_module_default())["subs-reader-top-panel"])
  }, isMobile && /*#__PURE__*/react.createElement(DropDown, {
    button: function button(_ref3) {
      var show = _ref3.show,
          onClick = _ref3.onClick;
      return /*#__PURE__*/react.createElement(Button/* default */.Z, {
        active: show,
        paddingLess: true,
        onClick: onClick
      }, /*#__PURE__*/react.createElement(IconView/* default */.Z, {
        icon: EgwWebFont/* default.dots-vertical */.Z["dots-vertical"]
      }));
    },
    body: /*#__PURE__*/react.createElement("div", {
      className: (subscriptions_module_default())["three-dots-popup"]
    }, threeDotsIcons)
  }), /*#__PURE__*/react.createElement(DateSwitcher/* default */.Z, {
    SubscriptionsDatePicker: SubscriptionsDatePicker/* SubscriptionsDatePicker */.O,
    date: (0,utils_date/* formatServerDateToJSDate */.IS)(date),
    onDateChange: onDateChange
  }), !isMobile && threeDotsIcons, /*#__PURE__*/react.createElement("div", {
    className: (subscriptions_module_default())["subs-top-panel-actions"]
  }, /*#__PURE__*/react.createElement(Button/* default */.Z, {
    rootTagName: "a",
    href: "".concat((0,url/* getSubsEditUrl */.iQ)(), "/edit/").concat(currentSub === null || currentSub === void 0 ? void 0 : currentSub.subscription),
    target: "_blank",
    title: t("subscriptions_edit"),
    className: (subscriptions_module_default())["subs-top-panel-action"],
    disabled: !(subscriptions !== null && subscriptions !== void 0 && subscriptions.length)
  }, /*#__PURE__*/react.createElement(IconView/* default */.Z, {
    icon: EgwWebFont/* default.edit */.Z.edit
  })), /*#__PURE__*/react.createElement(Button/* default */.Z, {
    onClick: openReaderHandler,
    href: (0,url/* getSubsAddUrl */.Dt)(),
    target: "_blank",
    title: t("read"),
    className: (subscriptions_module_default())["subs-top-panel-action"]
  }, /*#__PURE__*/react.createElement(IconView/* default */.Z, {
    icon: EgwWebFont/* default.read */.Z.read
  }))));
};

SubsReadTopPanel.propTypes = {
  currentSub: (prop_types_default()).object,
  onDateChange: (prop_types_default()).func,
  renderActions: (prop_types_default()).func,
  openReaderHandler: (prop_types_default()).func
};
/* harmony default export */ var subscriptions_SubsReadTopPanel = (SubsReadTopPanel);
// EXTERNAL MODULE: ../shared/utils/content/content.constants.js
var content_constants = __webpack_require__(5626);
;// CONCATENATED MODULE: ./src/next/components/subscriptions/SubsReadViewElement.js








var SubsReadViewElement = function SubsReadViewElement(_ref) {
  var item = _ref.item,
      bookType = _ref.bookType;

  var makeHeaderComponent = function makeHeaderComponent(Comp, _ref2) {
    var id = _ref2.id,
        parent = _ref2.parent,
        content = _ref2.content,
        element_subtype = _ref2.element_subtype;
    var Tag = Comp;
    var bookTitle = "";

    if (Comp === "h1") {
      Tag = "h2";
      bookTitle = "book-title";
    }

    return /*#__PURE__*/react.createElement("div", {
      className: classnames_default()((subscriptions_module_default())[content_constants/* CONTENT_CLASSES.PARAGRAPH */.J8.PARAGRAPH], (subscriptions_module_default())[element_subtype], (subscriptions_module_default())["has-reader-view-element-indent-top"]),
      "data-chapter": parent ? parent.id : null,
      "data-id": id
    }, /*#__PURE__*/react.createElement(Tag, {
      className: classnames_default()(bookType, (subscriptions_module_default())[bookTitle]),
      dangerouslySetInnerHTML: {
        __html: content
      }
    }));
  };

  var makeParagraph = function makeParagraph(para) {
    var id = para.id,
        parent = para.parent,
        content = para.content,
        element_subtype = para.element_subtype,
        refcodeShort = para.refcode_short;
    var trans = para.translations;
    var bibleRefCode;

    if (para.treeLabel && para.treeLabel !== content_constants/* TREE_LABEL_HIDE_IN_TREE */.Vz) {
      bibleRefCode = /*#__PURE__*/react.createElement("span", {
        className: (subscriptions_module_default())["bible-number"]
      }, para.treeLabel);
    }

    return /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement("div", {
      className: (subscriptions_module_default())["has-reader-view-element-indent-top"]
    }), bibleRefCode, /*#__PURE__*/react.createElement("span", {
      "data-chapter": parent ? parent.id : null,
      className: classnames_default()((subscriptions_module_default())[content_constants/* CONTENT_CLASSES.PARAGRAPH */.J8.PARAGRAPH], (subscriptions_module_default())[element_subtype]),
      "data-id": id
    }, /*#__PURE__*/react.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: content
      }
    }), trans && trans.length > 0 && /*#__PURE__*/react.createElement(IconView/* default */.Z, {
      icon: EgwWebFont/* default.translation */.Z.translation,
      className: (subscriptions_module_default())["reader-translate-icon"],
      "data-translations": id
    })), refcodeShort && /*#__PURE__*/react.createElement("span", {
      className: (subscriptions_module_default())[content_constants/* CONTENT_CLASSES.REF_CODE */.J8.REF_CODE]
    }, refcodeShort));
  };

  var itemType = item.element_type;

  if (itemType.indexOf("h") === 0 || itemType === "table") {
    return makeHeaderComponent(itemType, item);
  }

  return makeParagraph(item);
};

SubsReadViewElement.propTypes = {
  content: (prop_types_default()).array,
  bookType: (prop_types_default()).string
};
/* harmony default export */ var subscriptions_SubsReadViewElement = (SubsReadViewElement);
// EXTERNAL MODULE: ./src/next/hocs/withLogin.js + 1 modules
var withLogin = __webpack_require__(37482);
;// CONCATENATED MODULE: ./src/next/components/subscriptions/SubscriptionsRead.js
function SubscriptionsRead_slicedToArray(arr, i) { return SubscriptionsRead_arrayWithHoles(arr) || SubscriptionsRead_iterableToArrayLimit(arr, i) || SubscriptionsRead_unsupportedIterableToArray(arr, i) || SubscriptionsRead_nonIterableRest(); }

function SubscriptionsRead_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function SubscriptionsRead_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return SubscriptionsRead_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return SubscriptionsRead_arrayLikeToArray(o, minLen); }

function SubscriptionsRead_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function SubscriptionsRead_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function SubscriptionsRead_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }














var SubscriptionsRead = function SubscriptionsRead() {
  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var _useSubscriptionsCont = (0,contexts_subscriptions/* useSubscriptionsContext */.T)(),
      fetchContent = _useSubscriptionsCont.fetchContent,
      content = _useSubscriptionsCont.content,
      date = _useSubscriptionsCont.date;

  var router = (0,next_router.useRouter)();

  var _router$query$subscri = SubscriptionsRead_slicedToArray(router.query.subscription, 3),
      path = _router$query$subscri[0],
      bookId = _router$query$subscri[2];

  (0,react.useEffect)(function () {
    if (!content.length) {
      fetchContent();
    }
  }, [content, fetchContent]);
  var currentContent = content[date] || [];
  var bookIndex = currentContent.findIndex(function (item) {
    return item.book_id === parseInt(bookId, 10);
  });
  var index = bookIndex === -1 ? 0 : bookIndex;
  var currentSub = currentContent[index];
  var readContent = (0,react.useMemo)(function () {
    if (!currentSub) {
      return [];
    }

    var readContent = currentSub.content.map(function (item, index) {
      return {
        id: index,
        content: item,
        "element_type": "p"
      };
    });
    readContent.unshift({
      id: "head",
      content: currentSub.book_title,
      className: currentSub.book_type,
      "element_type": "h2"
    });
    return readContent;
  }, [currentSub]);

  var onDateChange = function onDateChange(newDate) {
    router.push("".concat(url/* URLS.subscription */.ns.subscription, "/").concat(path, "/").concat((0,subscriptions/* validateDate */.qS)(newDate), "/").concat(bookId));
  };

  var openReaderHandler = function openReaderHandler() {
    router.push((0,routes/* makeChapterUrl */.ME)(currentSub === null || currentSub === void 0 ? void 0 : currentSub.start_para_id));
  };

  return /*#__PURE__*/react.createElement("div", {
    className: (subscriptions_module_default())["subs-reader-wrap"]
  }, /*#__PURE__*/react.createElement(subscriptions_SubsReadTopPanel, {
    currentSub: currentSub,
    subscriptionContent: currentContent,
    currentIndex: index,
    onDateChange: onDateChange,
    openReaderHandler: openReaderHandler
  }), readContent.length ? /*#__PURE__*/react.createElement("div", {
    className: classnames_default()((subscriptions_module_default())["subscription-read-view"])
  }, readContent.map(function (item) {
    return /*#__PURE__*/react.createElement(subscriptions_SubsReadViewElement, {
      item: item,
      key: "".concat(item.id, "-").concat(item.element_type),
      bookType: currentSub.book_type
    });
  })) : /*#__PURE__*/react.createElement("div", {
    className: (subscriptions_module_default())["text-no-subscriptions"]
  }, t("noSubsToRead")));
};

/* harmony default export */ var subscriptions_SubscriptionsRead = ((0,withLogin/* withLogin */.U)(SubscriptionsRead));
// EXTERNAL MODULE: ../shared/components/Input/Input.js + 1 modules
var Input = __webpack_require__(38081);
// EXTERNAL MODULE: ../shared/components/RadioButton/RadioGroup.js
var RadioGroup = __webpack_require__(85769);
// EXTERNAL MODULE: ../shared/components/Checkbox/CheckboxGroup.js
var CheckboxGroup = __webpack_require__(12727);
// EXTERNAL MODULE: ../shared/components/Checkbox/Checkbox.js
var Checkbox = __webpack_require__(66636);
// EXTERNAL MODULE: ../shared/components/Typography/Typography.js
var Typography = __webpack_require__(21766);
// EXTERNAL MODULE: ../shared/components/Button/ButtonMore/ButtonMore.js
var ButtonMore = __webpack_require__(14435);
// EXTERNAL MODULE: ../shared/components/Typography/TypographyCropped.module.scss
var TypographyCropped_module = __webpack_require__(90275);
var TypographyCropped_module_default = /*#__PURE__*/__webpack_require__.n(TypographyCropped_module);
;// CONCATENATED MODULE: ../shared/components/Typography/TypographyCropped.js
var TypographyCropped_excluded = ["lineNumber", "className", "classNameButtonMore", "style", "html", "defaultHTML", "disableGhostHTML"];

function TypographyCropped_extends() { TypographyCropped_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return TypographyCropped_extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { TypographyCropped_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function TypographyCropped_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function TypographyCropped_slicedToArray(arr, i) { return TypographyCropped_arrayWithHoles(arr) || TypographyCropped_iterableToArrayLimit(arr, i) || TypographyCropped_unsupportedIterableToArray(arr, i) || TypographyCropped_nonIterableRest(); }

function TypographyCropped_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function TypographyCropped_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return TypographyCropped_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return TypographyCropped_arrayLikeToArray(o, minLen); }

function TypographyCropped_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function TypographyCropped_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function TypographyCropped_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function TypographyCropped_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = TypographyCropped_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function TypographyCropped_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }








var TypographyCropped = function TypographyCropped(_ref) {
  var lineNumber = _ref.lineNumber,
      className = _ref.className,
      classNameButtonMore = _ref.classNameButtonMore,
      style = _ref.style,
      html = _ref.html,
      _ref$defaultHTML = _ref.defaultHTML,
      defaultHTML = _ref$defaultHTML === void 0 ? "" : _ref$defaultHTML,
      _ref$disableGhostHTML = _ref.disableGhostHTML,
      disableGhostHTML = _ref$disableGhostHTML === void 0 ? false : _ref$disableGhostHTML,
      restProps = TypographyCropped_objectWithoutProperties(_ref, TypographyCropped_excluded);

  var _useState = (0,react.useState)(_objectSpread({}, style)),
      _useState2 = TypographyCropped_slicedToArray(_useState, 2),
      finalStyle = _useState2[0],
      setFinalStyle = _useState2[1];

  var _useState3 = (0,react.useState)(null),
      _useState4 = TypographyCropped_slicedToArray(_useState3, 2),
      elTypography = _useState4[0],
      setElTypography = _useState4[1];

  var _useState5 = (0,react.useState)(0),
      _useState6 = TypographyCropped_slicedToArray(_useState5, 2),
      maxHeight = _useState6[0],
      setMaxHeight = _useState6[1];

  var _useState7 = (0,react.useState)(0),
      _useState8 = TypographyCropped_slicedToArray(_useState7, 2),
      heightWithMore = _useState8[0],
      setHeightWithMore = _useState8[1];

  var _useState9 = (0,react.useState)(false),
      _useState10 = TypographyCropped_slicedToArray(_useState9, 2),
      isMoreActive = _useState10[0],
      setIsMoreActive = _useState10[1];

  var _useState11 = (0,react.useState)(false),
      _useState12 = TypographyCropped_slicedToArray(_useState11, 2),
      isCropped = _useState12[0],
      setIsCropped = _useState12[1];

  var _useState13 = (0,react.useState)(disableGhostHTML ? html : defaultHTML),
      _useState14 = TypographyCropped_slicedToArray(_useState13, 2),
      text = _useState14[0],
      setText = _useState14[1];

  var handleClickMore = function handleClickMore() {
    setIsMoreActive(function (v) {
      return !v;
    });
  };

  (0,react.useEffect)(function () {
    if (elTypography) {
      var _style = window.getComputedStyle(elTypography);

      setHeightWithMore(parseFloat(_style["line-height"]) * (lineNumber - 1));
      setMaxHeight(parseFloat(_style["line-height"]) * lineNumber);
    }
  }, [elTypography, html]);
  (0,react.useEffect)(function () {
    setIsCropped(false);
    setIsMoreActive(false);
    setFinalStyle(_objectSpread({}, style));
  }, [html]);
  (0,react.useEffect)(function () {
    if (elTypography && maxHeight) {
      var shouldBeTruncated = elTypography.scrollHeight > maxHeight;
      setIsCropped(shouldBeTruncated);
      setText(html);

      if (shouldBeTruncated && heightWithMore) {
        var _styles = _objectSpread({}, style);

        if (!isMoreActive) {
          _styles.maxHeight = heightWithMore;
          _styles.overflow = "hidden";
        }

        setFinalStyle(_styles);
      }
    }
  }, [maxHeight, heightWithMore, elTypography, isMoreActive, html]);
  return /*#__PURE__*/react.createElement(react.Fragment, null, !disableGhostHTML && /*#__PURE__*/react.createElement(Typography/* default */.Z, TypographyCropped_extends({
    ref: setElTypography,
    className: classnames_default()(className, (TypographyCropped_module_default()).text, "hidden-height", "typoCropParaGhostClass"),
    style: finalStyle,
    dangerouslySetInnerHTML: {
      __html: html
    }
  }, restProps)), /*#__PURE__*/react.createElement(Typography/* default */.Z, TypographyCropped_extends({
    className: classnames_default()(className, (TypographyCropped_module_default()).text),
    style: finalStyle,
    dangerouslySetInnerHTML: {
      __html: text
    }
  }, restProps)), /*#__PURE__*/react.createElement(ButtonMore/* default */.Z, {
    style: {
      display: isCropped || disableGhostHTML ? "block" : "none"
    },
    "data-line-number": lineNumber,
    className: classnames_default()((TypographyCropped_module_default())["button-more"], classNameButtonMore),
    isMoreActive: isMoreActive,
    onClick: handleClickMore
  }));
};

TypographyCropped.propTypes = {
  heightRem: (prop_types_default()).number,
  style: (prop_types_default()).object,
  crop: (prop_types_default()).bool
};
/* harmony default export */ var Typography_TypographyCropped = (TypographyCropped);
// EXTERNAL MODULE: ./src/next/components/Button/ButtonArrow.module.scss
var ButtonArrow_module = __webpack_require__(40517);
var ButtonArrow_module_default = /*#__PURE__*/__webpack_require__.n(ButtonArrow_module);
;// CONCATENATED MODULE: ./src/next/components/Button/ButtonArrow.js







var ButtonArrow = function ButtonArrow(_ref) {
  var id = _ref.id,
      secondary = _ref.secondary,
      className = _ref.className;

  var handleButtonClick = function handleButtonClick(e) {
    e.preventDefault();
    var page = document.getElementById(id);
    page.scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
  };

  return /*#__PURE__*/react.createElement("div", {
    className: classnames_default()((ButtonArrow_module_default()).root, className)
  }, /*#__PURE__*/react.createElement(Button/* default */.Z, {
    "data-id": id,
    className: classnames_default()((ButtonArrow_module_default()).button, landing_constants/* LANDING_SELECTORS.buttonArrowClass.substring */.QR.buttonArrowClass.substring(1)),
    variant: Button/* default.variant.outline */.Z.variant.outline,
    color: secondary ? Button/* default.color.light */.Z.color.light : Button/* default.color.quaternary */.Z.color.quaternary,
    onClick: handleButtonClick
  }, /*#__PURE__*/react.createElement(ArrowIcon/* default */.Z, {
    className: (ButtonArrow_module_default()).icon,
    size: "1.2rem",
    variant: "arrow",
    direction: "down"
  })));
};

ButtonArrow.propTypes = {
  id: (prop_types_default()).string,
  secondary: (prop_types_default()).bool,
  className: (prop_types_default()).string
};
/* harmony default export */ var Button_ButtonArrow = (ButtonArrow);
// EXTERNAL MODULE: ../shared/contexts/modal.js
var modal = __webpack_require__(26933);
// EXTERNAL MODULE: ./src/next/components/CreateQRcode/CreateQRcode.js
var CreateQRcode = __webpack_require__(44809);
;// CONCATENATED MODULE: ./src/next/components/Button/ButtonQRCode.js
function ButtonQRCode_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }











var ButtonQRCode = function ButtonQRCode(_ref) {
  var withLabel = _ref.withLabel,
      withLabelBeforeIcon = _ref.withLabelBeforeIcon,
      className = _ref.className,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "2.2rem" : _ref$size,
      isHeaderIcon = _ref.isHeaderIcon,
      variant = _ref.variant;

  var _useModalContext = (0,modal/* useModalContext */.v)(),
      showModal = _useModalContext.showModal;

  var handleButtonClick = function handleButtonClick() {
    var url = window.location.origin;
    showModal( /*#__PURE__*/react.createElement(CreateQRcode/* default */.Z, {
      value: url
    }));
  };

  return /*#__PURE__*/react.createElement(Button/* default */.Z, {
    classNameRipple: classnames_default()(landing_constants/* LANDING_SELECTORS.btnQR.substring */.QR.btnQR.substring(1), ButtonQRCode_defineProperty({}, landing_constants/* LANDING_SELECTORS.btnQRSmall.substring */.QR.btnQRSmall.substring(1), !isHeaderIcon)),
    className: className,
    variant: variant ? variant : Button/* default.variant.clear */.Z.variant.clear,
    color: Button/* default.color.icon */.Z.color.icon,
    onClick: handleButtonClick,
    style: {
      height: "auto"
    }
  }, withLabelBeforeIcon, /*#__PURE__*/react.createElement(IconView/* default */.Z, {
    style: {
      fontSize: size,
      paddingLeft: withLabelBeforeIcon ? "0.5rem" : 0
    },
    icon: EgwWebFont/* default */.Z[isHeaderIcon ? "qr-code-mobile-menu" : "qr-code"],
    size: size
  }), withLabel && /*#__PURE__*/react.createElement(Typography/* default */.Z, {
    color: "inherit",
    style: {
      fontWeight: 400
    },
    variant: "h3",
    fontFamily: "bebas"
  }, "\xA0QR"));
};

ButtonQRCode.propTypes = {
  className: (prop_types_default()).string,
  withLabel: (prop_types_default()).bool,
  size: (prop_types_default()).string
};
/* harmony default export */ var Button_ButtonQRCode = (ButtonQRCode);
;// CONCATENATED MODULE: ./src/next/components/index.js


























/***/ }),

/***/ 58753:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ getShareData; }
/* harmony export */ });
/* harmony import */ var _utils_routes_routes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69994);

var getShareData = function getShareData(item) {
  var basePath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  var url = (0,_utils_routes_routes__WEBPACK_IMPORTED_MODULE_0__/* .makeShareChapterUrl */ .Dw)(basePath, item === null || item === void 0 ? void 0 : item.start_para_id);
  return {
    url: url,
    title: item === null || item === void 0 ? void 0 : item.label,
    text: decodeHTMLEntries(item === null || item === void 0 ? void 0 : item.content.join("\n").replace(/<\/?[^>]+(>|$)/g, "")),
    refCode: item === null || item === void 0 ? void 0 : item.start_refcode
  };
};

var decodeHTMLEntries = function decodeHTMLEntries(text) {
  var textArea = document.createElement("textarea");
  textArea.innerHTML = text;
  var decode = textArea.value;

  if (textArea.remove) {
    textArea.remove();
  }

  return decode;
};

/***/ }),

/***/ 63086:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* binding */ SubscriptionsDatePicker; }
});

// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__(23615);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./src/next/contexts/subscriptions.js + 1 modules
var subscriptions = __webpack_require__(36895);
// EXTERNAL MODULE: ../node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27693);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ../node_modules/classnames/index.js
var classnames = __webpack_require__(60042);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../shared/components/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(75448);
// EXTERNAL MODULE: ../shared/assets/EgwWebFont.js
var EgwWebFont = __webpack_require__(59034);
;// CONCATENATED MODULE: ../shared/components/DatePicker/DatePicker.utils.js
/**
 * @typedef {Object} DayDetails
 * @property {number} date
 * @property {number} month
 * @property {string} dayString
 * @property {(*|null)} reminder
 * @property {number} day
 * @property {number} timestamp
 * /

 /**
 * @param args
 * @returns {DayDetails}
 */
var getDayDetails = function getDayDetails(args) {
  var date = args.index - args.firstDay;
  var day = args.index % 7;
  var prevMonth = args.month - 1;
  var prevYear = args.year;

  if (prevMonth < 0) {
    prevMonth = 11;
    prevYear--;
  }

  var prevMonthNumberOfDays = getNumberOfDays(prevYear, prevMonth);

  var _date = (date < 0 ? prevMonthNumberOfDays + date : date % args.numberOfDays) + 1;

  var valid = date >= 0 && date < args.numberOfDays ? 1 : 0;
  var timestamp = new Date(args.year, args.month, _date).getTime();
  return {
    date: _date,
    day: day,
    valid: valid,
    timestamp: timestamp,
    reminder: args.reminders[timestamp] || null
  };
};
/**
 * @param {number} year
 * @param {number} month
 * @param {number} reminders
 * @returns {DayDetails[]}
 */


var getMonthDetails = function getMonthDetails(year, month, reminders) {
  var firstDay = new Date(year, month).getDay();
  var numberOfDays = getNumberOfDays(year, month);
  var monthArray = [];
  var currentDay = null;
  var index = 0;
  var reminderMap = {};

  for (var idx in reminders) {
    var tempDate = new Date(reminders[idx].timestamp);
    var startOfTheDay = new Date(tempDate.getFullYear(), tempDate.getMonth(), tempDate.getDate()).getTime();
    reminderMap[startOfTheDay] = reminders[idx];
  }

  for (var row = 0; row < 6; row++) {
    for (var col = 0; col < 7; col++) {
      currentDay = getDayDetails({
        index: index,
        numberOfDays: numberOfDays,
        firstDay: firstDay,
        year: year,
        month: month,
        reminders: reminderMap
      });
      monthArray.push(currentDay);
      index++;
    }
  }

  return monthArray;
};
var getNumberOfDays = function getNumberOfDays(year, month) {
  return 32 - new Date(year, month, 32).getDate();
};
// EXTERNAL MODULE: ../shared/utils/date/index.js
var utils_date = __webpack_require__(96112);
// EXTERNAL MODULE: ../shared/components/Typography/Typography.js
var Typography = __webpack_require__(21766);
// EXTERNAL MODULE: ../shared/components/DatePicker/DatePicker.module.scss
var DatePicker_module = __webpack_require__(65012);
var DatePicker_module_default = /*#__PURE__*/__webpack_require__.n(DatePicker_module);
;// CONCATENATED MODULE: ../shared/components/DatePicker/DatePicker.js
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }











var DAYS_IN_WEEK = 7;
var weekNames = new Array(DAYS_IN_WEEK).fill("");

var DatePicker = function DatePicker(_ref) {
  var calendar = _ref.calendar,
      onFetchMonthData = _ref.onFetchMonthData,
      date = _ref.date,
      minDate = _ref.minDate,
      maxDate = _ref.maxDate,
      onDateChange = _ref.onDateChange;

  var _useState = (0,react.useState)(date),
      _useState2 = _slicedToArray(_useState, 2),
      monthDate = _useState2[0],
      setMonthDate = _useState2[1];

  var monthDateInstance = dayjs_min_default()(monthDate);
  var currentDateInstance = dayjs_min_default()(date);
  var monthDetails = getMonthDetails(monthDateInstance.year(), monthDateInstance.month());
  /**
   * @type {DayDetails[][]}
   */

  var weeks = [];

  for (var i = 0; i < monthDetails.length; i += DAYS_IN_WEEK) {
    var chunk = monthDetails.slice(i, i + DAYS_IN_WEEK);
    weeks.push(chunk);
  }

  var handleMonthChange = function handleMonthChange(newDate) {
    setMonthDate(newDate);

    if (onFetchMonthData) {
      onFetchMonthData(newDate);
    }
  };

  var renderDay = function renderDay(_ref2, index) {
    var _calendar$year, _classnames;

    var timestamp = _ref2.timestamp,
        date = _ref2.date,
        valid = _ref2.valid;
    var dateInstance = dayjs_min_default()(timestamp);
    var monthFinal = dateInstance.month() + 1;
    var dateInServerFormat = (0,utils_date/* formatToServerDate */.xH)(dateInstance);
    var validFinal = valid && (!maxDate || (0,utils_date/* isSameDateMonthYear */.KA)(dateInstance, maxDate) || dateInstance.isBefore(maxDate)) && (!minDate || (0,utils_date/* isSameDateMonthYear */.KA)(dateInstance, minDate) || dayjs_min_default()(dateInstance).isAfter(minDate));
    var year = dateInstance.year();
    var selected = (0,utils_date/* isSameDateMonthYear */.KA)(currentDateInstance, dateInstance);
    var read, unread, calendarSubsCount;
    var calendarMonthSubscriptionInfo = calendar === null || calendar === void 0 ? void 0 : (_calendar$year = calendar[year]) === null || _calendar$year === void 0 ? void 0 : _calendar$year[monthFinal];

    if (calendarMonthSubscriptionInfo) {
      var dateInfo = calendarMonthSubscriptionInfo.find(function (dateItem) {
        return dateItem.date === dateInServerFormat;
      });

      if (dateInfo && !dateInstance.isAfter(new Date())) {
        var unreadCount = dateInfo.unread,
            total = dateInfo.total;
        calendarSubsCount = total;
        unread = calendarSubsCount && unreadCount !== 0;
        read = calendarSubsCount && unreadCount === 0;
      }
    }

    return /*#__PURE__*/react.createElement("button", {
      disabled: !validFinal || selected,
      key: index,
      className: classnames_default()((DatePicker_module_default()).day, (_classnames = {}, _defineProperty(_classnames, (DatePicker_module_default()).selected, validFinal && selected), _defineProperty(_classnames, (DatePicker_module_default()).read, read), _defineProperty(_classnames, (DatePicker_module_default()).unread, unread), _defineProperty(_classnames, (DatePicker_module_default()).disabled, !validFinal), _classnames)),
      onClick: function onClick() {
        if (onDateChange) {
          var _date = new Date(timestamp);

          _date.setHours(12);

          onDateChange(_date);
        }
      }
    }, date, !!calendarSubsCount && /*#__PURE__*/react.createElement("div", {
      className: (DatePicker_module_default()).indicator
    }));
  };

  var renderWeekName = function renderWeekName(_, dayIndex) {
    return /*#__PURE__*/react.createElement(Typography/* default */.Z, {
      key: dayIndex,
      className: (DatePicker_module_default())["week-name"],
      variant: Typography/* default.variant.h5 */.Z.variant.h5,
      color: Typography/* default.color.gray */.Z.color.gray
    }, dayjs_min_default()().day(dayIndex).format("dd"));
  };

  var renderWeek = function renderWeek(days, index) {
    return /*#__PURE__*/react.createElement("div", {
      key: index,
      className: (DatePicker_module_default()).week
    }, days.map(renderDay));
  };

  return /*#__PURE__*/react.createElement("div", {
    className: (DatePicker_module_default()).root
  }, /*#__PURE__*/react.createElement("div", {
    className: (DatePicker_module_default()).head
  }, /*#__PURE__*/react.createElement(IconButton/* default */.Z, {
    className: classnames_default()((DatePicker_module_default()).arrow, (DatePicker_module_default()).prev),
    icon: EgwWebFont/* default.chevron-left */.Z["chevron-left"],
    disabled: minDate && dayjs_min_default()(minDate).month() === monthDateInstance.month(),
    onClick: function onClick() {
      return handleMonthChange(monthDateInstance.subtract(1, "month"));
    }
  }), /*#__PURE__*/react.createElement(Typography/* default */.Z, {
    className: (DatePicker_module_default()).title,
    variant: Typography/* default.variant.h5 */.Z.variant.h5,
    color: Typography/* default.color.textInactive */.Z.color.textInactive
  }, dayjs_min_default()(monthDate).format("MMMM YYYY")), /*#__PURE__*/react.createElement(IconButton/* default */.Z, {
    className: classnames_default()((DatePicker_module_default()).arrow, (DatePicker_module_default()).next),
    icon: EgwWebFont/* default.chevron-right */.Z["chevron-right"],
    disabled: maxDate && dayjs_min_default()(maxDate).month() === monthDateInstance.month(),
    onClick: function onClick() {
      return handleMonthChange(monthDateInstance.add(1, "month"));
    }
  })), /*#__PURE__*/react.createElement("div", {
    className: (DatePicker_module_default())["week-names"]
  }, weekNames.map(renderWeekName)), /*#__PURE__*/react.createElement("div", {
    className: (DatePicker_module_default()).body
  }, weeks.map(renderWeek)));
};

DatePicker.propTypes = {
  date: (prop_types_default()).object,
  minDate: (prop_types_default()).object,
  onDateChange: (prop_types_default()).func
};
/* harmony default export */ var DatePicker_DatePicker = (DatePicker);
;// CONCATENATED MODULE: ./src/next/components/subscriptions/SubscriptionsDatePicker.js




var SubscriptionsDatePicker = function SubscriptionsDatePicker(_ref) {
  var date = _ref.date,
      minDate = _ref.minDate,
      onDateChange = _ref.onDateChange;

  var _useSubscriptionsCont = (0,subscriptions/* useSubscriptionsContext */.T)(),
      fetchMonthData = _useSubscriptionsCont.fetchMonthData,
      calendar = _useSubscriptionsCont.calendar;

  (0,react.useEffect)(function () {
    fetchMonthData(date, true);
  }, [fetchMonthData]);
  return /*#__PURE__*/react.createElement(DatePicker_DatePicker, {
    maxDate: new Date(),
    calendar: calendar,
    onFetchMonthData: fetchMonthData,
    date: date,
    minDate: minDate,
    onDateChange: onDateChange
  });
};
SubscriptionsDatePicker.propTypes = {
  date: (prop_types_default()).object,
  minDate: (prop_types_default()).object,
  onDateChange: (prop_types_default()).func
};

/***/ }),

/***/ 33021:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ useGlobalSwipeable; },
/* harmony export */   "f": function() { return /* binding */ GlobalSwipeableProvider; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var _shared_components_Swipeable_Swipeable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60914);
/* harmony import */ var _shared_hooks_useObserverPattern__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77423);



var GlobalSwipeableContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});
var GlobalSwipeableProvider = function GlobalSwipeableProvider(_ref) {
  var className = _ref.className,
      tag = _ref.tag,
      children = _ref.children;

  var _useObserverPattern = (0,_shared_hooks_useObserverPattern__WEBPACK_IMPORTED_MODULE_2__/* .useObserverPattern */ .U)(),
      addSwipedListener = _useObserverPattern.addObserverListener,
      removeSwipedListener = _useObserverPattern.removeObserverListener,
      handleSwiped = _useObserverPattern.notifyObserverListeners;

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(GlobalSwipeableContext.Provider, {
    value: {
      addSwipedListener: addSwipedListener,
      removeSwipedListener: removeSwipedListener
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_shared_components_Swipeable_Swipeable__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
    tag: tag,
    className: className,
    onSwiped: handleSwiped
  }, children));
};
var useGlobalSwipeable = function useGlobalSwipeable() {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(GlobalSwipeableContext);
};

/***/ }),

/***/ 37482:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U": function() { return /* binding */ withLogin; }
});

// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ./src/next/contexts/auth.js
var auth = __webpack_require__(89284);
// EXTERNAL MODULE: ../node_modules/next-i18next/dist/esm/index.js + 22 modules
var esm = __webpack_require__(60098);
// EXTERNAL MODULE: ./src/assets/CommonIcons.js
var CommonIcons = __webpack_require__(64666);
// EXTERNAL MODULE: ../shared/components/Button/Button.js
var Button = __webpack_require__(18170);
// EXTERNAL MODULE: ../shared/components/Button/Button.constants.js
var Button_constants = __webpack_require__(29718);
// EXTERNAL MODULE: ./src/next/components/pleaseSignInPage/PleaseSignInPage.module.scss
var PleaseSignInPage_module = __webpack_require__(88567);
var PleaseSignInPage_module_default = /*#__PURE__*/__webpack_require__.n(PleaseSignInPage_module);
;// CONCATENATED MODULE: ./src/next/components/pleaseSignInPage/PleaseSignInPage.js








var PleaseSignInPage = function PleaseSignInPage() {
  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t;

  var _useAuthContext = (0,auth/* useAuthContext */.E)(),
      login = _useAuthContext.login;

  var onAuthHandler = function onAuthHandler() {
    login();
  };

  return /*#__PURE__*/react.createElement("div", {
    className: (PleaseSignInPage_module_default())["please-sign-in-page"]
  }, /*#__PURE__*/react.createElement("div", {
    className: (PleaseSignInPage_module_default())["please-sign-in-page-header"]
  }, /*#__PURE__*/react.createElement(CommonIcons/* SignInIcon */.GQ, {
    className: (PleaseSignInPage_module_default())["sign-in-icon"]
  })), /*#__PURE__*/react.createElement("div", {
    className: (PleaseSignInPage_module_default())["please-sign-in-page-content"]
  }, /*#__PURE__*/react.createElement("p", {
    className: (PleaseSignInPage_module_default()).text
  }, t("pleaseSignInText")), /*#__PURE__*/react.createElement(Button/* default */.Z, {
    className: (PleaseSignInPage_module_default())["please-sign-in-page-button"],
    onClick: onAuthHandler
  }, t("signIn"))));
};

/* harmony default export */ var pleaseSignInPage_PleaseSignInPage = (PleaseSignInPage);
// EXTERNAL MODULE: ../shared/components/Loader/Loader.js + 1 modules
var Loader = __webpack_require__(63975);
;// CONCATENATED MODULE: ./src/next/hocs/withLogin.js




var withLogin = function withLogin(Page) {
  return function (props) {
    var _useAuthContext = (0,auth/* useAuthContext */.E)(),
        isLogin = _useAuthContext.isLogin,
        loading = _useAuthContext.loading;

    if (loading) {
      return /*#__PURE__*/react.createElement(Loader["default"], {
        align: "flex-center",
        isPositionAbsolute: true
      });
    }

    return isLogin ? /*#__PURE__*/react.createElement(Page, props) : /*#__PURE__*/react.createElement(pleaseSignInPage_PleaseSignInPage, null);
  };
};

/***/ }),

/***/ 66040:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p0": function() { return /* reexport safe */ _useFullScreen__WEBPACK_IMPORTED_MODULE_1__.Z; }
/* harmony export */ });
/* harmony import */ var _ssr__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11456);
/* harmony import */ var _useFullScreen__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37588);
/* harmony import */ var _shared_hooks_useMediaQuery__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38295);
/* harmony import */ var _useUiLanguagesTranslated__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35328);
/* harmony import */ var _hooks_ssr_useStoreSSRInitialDataBook__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(79497);
/* harmony import */ var _hooks_ssr_useStoreSSRInitialDataChapterParas__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(91289);
/* harmony import */ var _hooks_ssr_useStoreSSRInitialDataTOC__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88915);








/***/ }),

/***/ 11456:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Kh": function() { return /* reexport safe */ _useStoreSSRInitialDataBook__WEBPACK_IMPORTED_MODULE_2__.K; },
/* harmony export */   "gA": function() { return /* reexport safe */ _useStoreSSRInitialDataTOC__WEBPACK_IMPORTED_MODULE_1__.g; },
/* harmony export */   "qi": function() { return /* reexport safe */ _useStoreSSRInitialDataChapterParas__WEBPACK_IMPORTED_MODULE_0__.q; }
/* harmony export */ });
/* harmony import */ var _useStoreSSRInitialDataChapterParas__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91289);
/* harmony import */ var _useStoreSSRInitialDataTOC__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88915);
/* harmony import */ var _useStoreSSRInitialDataBook__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79497);




/***/ }),

/***/ 79497:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ useStoreSSRInitialDataBook; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34412);
/* harmony import */ var _store_actions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62013);


 // Use this hook to store the initial data from SSR to redux.

var useStoreSSRInitialDataBook = function useStoreSSRInitialDataBook(bookOrBooks) {
  var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (bookOrBooks) {
      dispatch(_store_actions__WEBPACK_IMPORTED_MODULE_2__/* .mainTreeActions.addBooks */ .Ze.addBooks(bookOrBooks));
    }
  }, []);
};

/***/ }),

/***/ 91289:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ useStoreSSRInitialDataChapterParas; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34412);
/* harmony import */ var _store_actions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62013);


 // Use this hook to store the initial data from SSR to redux.

var useStoreSSRInitialDataChapterParas = function useStoreSSRInitialDataChapterParas(itemOrItems) {
  var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var store = function store(_ref) {
      var chapterId = _ref.chapterId,
          paras = _ref.paras,
          highlight = _ref.highlight;

      if (chapterId && paras !== null && paras !== void 0 && paras.length) {
        dispatch(_store_actions__WEBPACK_IMPORTED_MODULE_2__/* .paragraphsReducerActions.fetchChapterParasSuccess */ .Kd.fetchChapterParasSuccess(chapterId, paras, highlight));
      }
    };

    if (Array.isArray(itemOrItems)) {
      itemOrItems.forEach(store);
    } else {
      store(itemOrItems);
    }
  }, []);
};

/***/ }),

/***/ 88915:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ useStoreSSRInitialDataTOC; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34412);
/* harmony import */ var _store_actions_toc_actions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4164);


 // Use this hook to store the initial data from SSR to redux.

var useStoreSSRInitialDataTOC = function useStoreSSRInitialDataTOC(itemOrItems) {
  var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var store = function store(toc) {
      if (toc !== null && toc !== void 0 && toc[0]) {
        var bookId = toc[0].id.split(".")[0];
        dispatch(_store_actions_toc_actions__WEBPACK_IMPORTED_MODULE_2__/* .tocActions.setItem */ .b.setItem(bookId, toc));
      }
    };

    if (Array.isArray(itemOrItems === null || itemOrItems === void 0 ? void 0 : itemOrItems[0])) {
      itemOrItems.forEach(store);
    } else {
      store(itemOrItems);
    }
  }, []);
};

/***/ }),

/***/ 37588:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var _shared_utils_theme_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93752);
/* harmony import */ var _shared_utils_viewmode__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24064);
/* harmony import */ var _shared_hooks_useCookiesWithOptions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65482);
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }






var useFullScreen = function useFullScreen() {
  var _useCookiesWithOption = (0,_shared_hooks_useCookiesWithOptions__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)([_shared_utils_theme_theme__WEBPACK_IMPORTED_MODULE_1__/* .COOKIE_KEY_FULLSCREEN */ .vj]),
      _useCookiesWithOption2 = _slicedToArray(_useCookiesWithOption, 2),
      cookie = _useCookiesWithOption2[0],
      setCookie = _useCookiesWithOption2[1];

  var fullScreen = cookie.fullScreen;
  var updateFullScreen = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (stateNew, updateCookie) {
    var classList = document.body.classList;

    if (updateCookie) {
      setCookie(_shared_utils_theme_theme__WEBPACK_IMPORTED_MODULE_1__/* .COOKIE_KEY_FULLSCREEN */ .vj, stateNew ? stateNew : "");
    }

    if (stateNew) {
      if (!classList.contains(_shared_utils_viewmode__WEBPACK_IMPORTED_MODULE_2__/* .VIEW_MODE.FULLSCREEN */ .WF.FULLSCREEN)) {
        classList.add(_shared_utils_viewmode__WEBPACK_IMPORTED_MODULE_2__/* .VIEW_MODE.FULLSCREEN */ .WF.FULLSCREEN);
      }
    } else {
      classList.remove(_shared_utils_viewmode__WEBPACK_IMPORTED_MODULE_2__/* .VIEW_MODE.FULLSCREEN */ .WF.FULLSCREEN);
    }
  }, [setCookie]);
  var setFullScreen = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    updateFullScreen(fullScreen);
  }, [updateFullScreen, fullScreen]);
  var disableFullScreen = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    updateFullScreen(false);
  }, [updateFullScreen]);
  var toggleFullScreen = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    updateFullScreen(!fullScreen, true);
  }, [fullScreen, updateFullScreen]);
  return {
    fullScreen: Boolean(fullScreen),
    toggleFullScreen: toggleFullScreen,
    setFullScreen: setFullScreen,
    disableFullScreen: disableFullScreen
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (useFullScreen);

/***/ }),

/***/ 69286:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

 // Use this hook to check if client specific UI (e.g. hide or show some elements) can be
// applied to the DOM without the React Hydration Error: "Hydration failed due to the UI mismatch…"
// https://nextjs.org/docs/messages/react-hydration-error

var useIsDOMHydratedAfterSSR = function useIsDOMHydratedAfterSSR() {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      hydrated = _useState2[0],
      setHydrated = _useState2[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    setHydrated(true);
  }, []);
  return hydrated;
};

/* harmony default export */ __webpack_exports__["Z"] = (useIsDOMHydratedAfterSSR);

/***/ }),

/***/ 35328:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60098);
/* harmony import */ var _shared_utils_select__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48018);
/* harmony import */ var _shared_utils_multilang_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76439);





var useUiLanguagesTranslated = function useUiLanguagesTranslated() {
  var _useTranslation = (0,next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)(),
      t = _useTranslation.t;

  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return _shared_utils_multilang_constants__WEBPACK_IMPORTED_MODULE_2__/* .UL_LANGUAGES.map */ .CZ.map(function (language) {
      return (0,_shared_utils_select__WEBPACK_IMPORTED_MODULE_3__/* .makeOption */ .D)(language.id, t(language.key));
    });
  }, [t]);
};

/* harmony default export */ __webpack_exports__["Z"] = (useUiLanguagesTranslated);

/***/ }),

/***/ 67052:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ LANDING_SECTION; }
/* harmony export */ });
var LANDING_SECTION = {
  SPALSH: "splash",
  ABOUT: "about",
  LANGUAGES: "languages",
  AUTHOR: "author",
  MORE_BOOKS: "MORE_BOOKS"
};

/***/ }),

/***/ 79309:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IV": function() { return /* binding */ LANDING_SECTION; },
/* harmony export */   "_S": function() { return /* binding */ LANDING_EXPANDABLE; },
/* harmony export */   "eT": function() { return /* binding */ LANDING_FAQ; },
/* harmony export */   "li": function() { return /* binding */ LANDING_STATEMENTS; },
/* harmony export */   "vG": function() { return /* binding */ BIG_LANDING_LINKS; }
/* harmony export */ });
var LANDING_SECTION = {
  SPLASH: "Splash",
  ADVANTAGES: "Advantages",
  ABOUT: "About",
  AUTHOR: "Author",
  STATEMENTS: "Statements",
  CONTENTS: "Contents",
  FAQ: "FAQ"
};
var LANDING_EXPANDABLE = {
  ABOUT: "about-text",
  AUTHOR: "author-text"
};
var BIG_LANDING_LINKS = [{
  href: "/read/132.2",
  label: "Read",
  id: "openReaderHeadMenuButton"
}, {
  href: "/#" + LANDING_SECTION.ADVANTAGES,
  label: "Advantages",
  id: "openAdvantagesHeadMenuButton"
}, {
  href: "/#" + LANDING_SECTION.ABOUT,
  label: "About",
  id: "openAboutHeadMenuButton"
}, {
  href: "/#" + LANDING_SECTION.STATEMENTS,
  label: "Statements",
  id: "openStatementsHeadMenuButton"
}, {
  href: "/#" + LANDING_SECTION.CONTENTS,
  label: "Contents",
  id: "openContentsHeadMenuButton"
}, {
  href: "/#" + LANDING_SECTION.FAQ,
  label: "FAQ",
  id: "openFAQHeadMenuButton"
}, {
  href: "/#" + LANDING_SECTION.AUTHOR,
  label: "The Author",
  id: "openAuthorHeadMenuButton"
}];
var LANDING_FAQ = [{
  id: "01",
  title: "What is \"The Great Controversy\" about?",
  message: "\"The Great Controversy\" is the last volume in the 'Conflict of the Ages' series that provides an exploration of the ongoing spiritual battle between God and Satan. It covers periods from the fall of Jerusalem to the end times, providing a historical, spiritual, and prophetic context that allows readers better to understand the biblical narrative and their role in it."
}, {
  id: "02",
  title: "Is \"The Great Controversy\" just for Christians?",
  message: "While the book uses a Christian framework, its exploration of the cosmic conflict, historical events, and their spiritual implications can enlighten anyone interested in spirituality, history, or the bigger questions of life and existence."
}, {
  id: "03",
  title: "Why is \"The Great Controversy\" relevant to my life today?",
  message: "\"The Great Controversy\" is not just about past events. It offers a perspective on the challenges and spiritual struggles we face daily. Understanding the 'bigger picture' can help you navigate these challenges with wisdom and resilience.\n    "
}, {
  id: "04",
  title: "I've heard \"The Great Controversy\" is a difficult read. Is that true?",
  message: "The book does delve into complex issues of faith, history, and spirituality, but it's written in a way that's intended to be accessible and engaging to all readers, regardless of their background."
}, {
  id: "05",
  title: "Will \"The Great Controversy\" conflict with my current beliefs?",
  message: "\"The Great Controversy\" is a resource that aims to enlighten and inform. While it might challenge some preconceptions, its primary goal is to enrich your understanding of the spiritual realm, not to discredit or override personal beliefs."
}, {
  id: "06",
  title: "Is this book biased towards a particular Christian denomination?",
  message: "While the book does have its roots in Seventh-day Adventist thought, its coverage of the great cosmic conflict is relevant to Christians of all denominations. The historical events and concepts explored are universal within Christianity.\n    "
}, {
  id: "07",
  title: "Why should I read \"The Great Controversy\" aside from other Christian literature?",
  message: "\"The Great Controversy\" provides a unique perspective on the spiritual battle between good and evil, examining this conflict's history and future implications. It offers insights that can enrich your understanding of your faith and spiritual journey.\n    "
}];
var LANDING_STATEMENTS = [{
  id: "01",
  message: "It is the restraining power of God that prevents mankind from passing fully\n    under the control of Satan.",
  ref: "p. 36"
}, {
  id: "02",
  message: "Christianity is a system, which, received and obeyed, would spread peace,\n    harmony, and happiness throughout the earth.",
  ref: "p. 46"
}, {
  id: "03",
  message: "In our time there is a wide departure from their doctrines and precepts, and\n    there is need of a return to the great Protestant principle\u2014the Bible, and the\n    Bible only, as the rule of faith and duty.",
  ref: "p. 204"
}, {
  id: "04",
  message: "We should choose the right because it is right, and leave consequences with God.",
  ref: "p. 460"
}, {
  id: "05",
  message: "The Christian's life should be one of faith, of victory, and joy in God.",
  ref: "p. 477"
}, {
  id: "06",
  message: "The great controversy is ended. Sin and sinners are no more. The entire universe is clean... From\n    the minutest atom to the greatest world, all things, animate and inanimate, in their unshadowed\n    beauty and perfect joy, declare that God is love.",
  ref: "p. 678"
}];

/***/ }),

/***/ 12727:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60042);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Checkbox__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66636);
/* harmony import */ var _utils_array__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21707);
/* harmony import */ var _utils_select__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48018);
/* harmony import */ var _CheckboxGroup_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66874);
/* harmony import */ var _CheckboxGroup_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_CheckboxGroup_module_scss__WEBPACK_IMPORTED_MODULE_5__);
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }









var CheckboxGroup = function CheckboxGroup(_ref) {
  var className = _ref.className,
      isTranslateLabels = _ref.isTranslateLabels,
      colClassName = _ref.colClassName,
      options = _ref.options,
      value = _ref.value,
      _onChange = _ref.onChange,
      isInline = _ref.isInline,
      disabled = _ref.disabled,
      ariaLabelledBy = _ref.ariaLabelledBy;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    "aria-labelledby": ariaLabelledBy,
    role: "group",
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("CheckboxGroup", (_CheckboxGroup_module_scss__WEBPACK_IMPORTED_MODULE_5___default().CheckboxGroup), (_CheckboxGroup_module_scss__WEBPACK_IMPORTED_MODULE_5___default())[colClassName], className)
  }, (options || []).map(function (item) {
    var key = (0,_utils_select__WEBPACK_IMPORTED_MODULE_6__/* .getOptionKey */ ._)(item);
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Checkbox__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
      key: key,
      isTranslateLabel: isTranslateLabels,
      title: item.label,
      isInline: isInline,
      disabled: disabled === null || disabled === void 0 ? void 0 : disabled.includes(key),
      checked: value.includes(key),
      onChange: function onChange() {
        var valueNew = _toConsumableArray(value);

        (0,_utils_array__WEBPACK_IMPORTED_MODULE_4__/* .toggleInArray */ .rO)(valueNew, key);

        _onChange(valueNew, key);
      }
    });
  }));
};

CheckboxGroup.propTypes = {
  options: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().array),
  value: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().array),
  onChange: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().func),
  className: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  colClassName: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string)
};
/* harmony default export */ __webpack_exports__["Z"] = (CheckboxGroup);

/***/ }),

/***/ 67442:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27693);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60042);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _shared_components_Button_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18170);
/* harmony import */ var _shared_components_IconView_IconView__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20844);
/* harmony import */ var _shared_contexts_TranslateContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48081);
/* harmony import */ var _shared_assets_EgwWebFont__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(59034);
/* harmony import */ var _shared_components_modal_Modal__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(58411);
/* harmony import */ var _date_switcher_module_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(84001);
/* harmony import */ var _date_switcher_module_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_date_switcher_module_scss__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _shared_components_Portal_PortalMainAfter_constants__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(265);
/* harmony import */ var _shared_components_Portal_Portal__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(64976);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }














var formatDate = function formatDate(date) {
  return dayjs__WEBPACK_IMPORTED_MODULE_2___default()(date).format("DD.MM");
};

var DateSwitcher = function DateSwitcher(_ref) {
  var SubscriptionsDatePicker = _ref.SubscriptionsDatePicker,
      date = _ref.date,
      onDateChange = _ref.onDateChange,
      className = _ref.className;

  var _useSharedTranslation = (0,_shared_contexts_TranslateContext__WEBPACK_IMPORTED_MODULE_6__/* .useSharedTranslation */ .G)(),
      t = _useSharedTranslation.t;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      localModalContent = _useState2[0],
      setLocalModalContent = _useState2[1];

  var openCalendar = function openCalendar() {
    setLocalModalContent( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(SubscriptionsDatePicker, {
      date: date,
      onDateChange: handleModalDateChange
    }));
  };

  var closeCalendar = function closeCalendar() {
    setLocalModalContent(null);
  };

  var _useMemo = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    var tomorrow = dayjs__WEBPACK_IMPORTED_MODULE_2___default()(date).add(1, "day");
    var yesterday = dayjs__WEBPACK_IMPORTED_MODULE_2___default()(date).subtract(1, "day");
    var isActualTomorrow = dayjs__WEBPACK_IMPORTED_MODULE_2___default()(tomorrow).isAfter(new Date());
    return [yesterday, tomorrow, isActualTomorrow];
  }, [date]),
      _useMemo2 = _slicedToArray(_useMemo, 3),
      yesterday = _useMemo2[0],
      tomorrow = _useMemo2[1],
      isActualTomorrow = _useMemo2[2];

  var handleDateChange = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (next) {
    if (next && isActualTomorrow) {
      return;
    }

    var changedDate;

    if (next) {
      changedDate = tomorrow;
    } else {
      changedDate = yesterday;
    }

    onDateChange(changedDate.toDate());
  }, [yesterday, onDateChange, tomorrow, isActualTomorrow]);

  var handleModalDateChange = function handleModalDateChange(newDate) {
    onDateChange(newDate);
    closeCalendar();
  };

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_date_switcher_module_scss__WEBPACK_IMPORTED_MODULE_10___default()["date-switcher"]), className)
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_shared_components_Button_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    title: t("calendar"),
    className: (_date_switcher_module_scss__WEBPACK_IMPORTED_MODULE_10___default()["date-switcher-icon-calendar"]),
    onClick: openCalendar
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_shared_components_IconView_IconView__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
    icon: _shared_assets_EgwWebFont__WEBPACK_IMPORTED_MODULE_7__/* ["default"].calendar */ .Z.calendar
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: (_date_switcher_module_scss__WEBPACK_IMPORTED_MODULE_10___default()["date-switcher-controls-container"])
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: (_date_switcher_module_scss__WEBPACK_IMPORTED_MODULE_10___default()["date-switcher-date-container"]),
    onClick: function onClick() {
      return handleDateChange();
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_shared_components_IconView_IconView__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
    icon: _shared_assets_EgwWebFont__WEBPACK_IMPORTED_MODULE_7__/* ["default"]["chevron-left"] */ .Z["chevron-left"],
    className: (_date_switcher_module_scss__WEBPACK_IMPORTED_MODULE_10___default()["date-switcher-date-icon"])
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: (_date_switcher_module_scss__WEBPACK_IMPORTED_MODULE_10___default()["date-switcher-date-text"])
  }, formatDate(yesterday))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: (_date_switcher_module_scss__WEBPACK_IMPORTED_MODULE_10___default()["date-switcher-date-current"])
  }, formatDate(date)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_date_switcher_module_scss__WEBPACK_IMPORTED_MODULE_10___default()["date-switcher-date-container"]), _defineProperty({}, (_date_switcher_module_scss__WEBPACK_IMPORTED_MODULE_10___default()["is-disabled"]), isActualTomorrow)),
    onClick: function onClick() {
      return handleDateChange(true);
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: (_date_switcher_module_scss__WEBPACK_IMPORTED_MODULE_10___default()["date-switcher-date-text"])
  }, formatDate(tomorrow)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_shared_components_IconView_IconView__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
    icon: _shared_assets_EgwWebFont__WEBPACK_IMPORTED_MODULE_7__/* ["default"]["chevron-right"] */ .Z["chevron-right"],
    className: (_date_switcher_module_scss__WEBPACK_IMPORTED_MODULE_10___default()["date-switcher-date-icon"])
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_shared_components_Portal_Portal__WEBPACK_IMPORTED_MODULE_9__["default"], {
    id: _shared_components_Portal_PortalMainAfter_constants__WEBPACK_IMPORTED_MODULE_11__/* .EL_ID_PORTAL_MAIN_AFTER */ .t
  }, localModalContent && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_shared_components_modal_Modal__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
    onClose: closeCalendar,
    props: {
      component: localModalContent
    }
  })));
};

DateSwitcher.propTypes = {
  SubscriptionsDatePicker: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().any),
  date: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().object),
  onDateChange: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().func),
  className: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string)
};
/* harmony default export */ __webpack_exports__["Z"] = (DateSwitcher);

/***/ }),

/***/ 25539:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var _shared_components_Portal_PortalMainAfter_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(265);
/* harmony import */ var _PortalMainAfter_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68059);
/* harmony import */ var _PortalMainAfter_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_PortalMainAfter_module_scss__WEBPACK_IMPORTED_MODULE_1__);




var PortalMainAfter = function PortalMainAfter() {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: (_PortalMainAfter_module_scss__WEBPACK_IMPORTED_MODULE_1___default().root),
    id: _shared_components_Portal_PortalMainAfter_constants__WEBPACK_IMPORTED_MODULE_2__/* .EL_ID_PORTAL_MAIN_AFTER */ .t
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (PortalMainAfter);

/***/ }),

/***/ 36746:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ useShopBook; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34412);
/* harmony import */ var _shared_store_shop_selectors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47108);
/* harmony import */ var _shared_utils_content_content__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69051);
/* harmony import */ var _shared_store_shop_actions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37623);






var findPackageForBook = function findPackageForBook(shopPackages, packageIds, book_id) {
  for (var i = 0; i < packageIds.length; i++) {
    var shopPackage = shopPackages[packageIds[i]];
    /* eslint-disable-next-line */

    var found = shopPackage.items.find(function (shopBook) {
      return shopBook.book_id === book_id;
    });

    if (found) {
      return {
        shopPackage: shopPackage,
        packageShopBookIds: shopPackage.items.map(function (shopBook) {
          return shopBook.book_id;
        })
      };
    }
  }

  return {
    shopPackage: null,
    packageShopBookIds: []
  };
};

var useShopBook = function useShopBook(book) {
  var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
  var shopBooks = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(_shared_store_shop_selectors__WEBPACK_IMPORTED_MODULE_4__/* .selectorShopBooks */ .af);
  var shopIds = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(_shared_store_shop_selectors__WEBPACK_IMPORTED_MODULE_4__/* .selectorShopIds */ .D);
  var pendingIds = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(_shared_store_shop_selectors__WEBPACK_IMPORTED_MODULE_4__/* .selectorPendingIds */ .ff);
  var packageIds = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(_shared_store_shop_selectors__WEBPACK_IMPORTED_MODULE_4__/* .selectorPackageIds */ .kW);
  var loadingPackages = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(_shared_store_shop_selectors__WEBPACK_IMPORTED_MODULE_4__/* .selectorLoadingPackages */ .SS);
  var shopPackages = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(_shared_store_shop_selectors__WEBPACK_IMPORTED_MODULE_4__/* .selectorShopPackages */ .J6);
  var isPackagesFetched = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(_shared_store_shop_selectors__WEBPACK_IMPORTED_MODULE_4__/* .selectorShopIsPackagesFetched */ .rG);
  var bookId = book === null || book === void 0 ? void 0 : book.book_id;
  var shopBook = shopBooks[bookId]; // if packages are fetched and there is no {shopBook},
  // then consider this book is not purchased.

  var isBookPermissionAuthOKValue = (0,_shared_utils_content_content__WEBPACK_IMPORTED_MODULE_2__/* .isBookPermissionPurchaseOK */ .hQ)(shopBook);

  var _findPackageForBook = findPackageForBook(shopPackages, packageIds, book === null || book === void 0 ? void 0 : book.book_id),
      shopPackage = _findPackageForBook.shopPackage,
      packageShopBookIds = _findPackageForBook.packageShopBookIds;

  var loading = pendingIds.has(bookId) || loadingPackages;
  var isForSale = book === null || book === void 0 ? void 0 : book.isForSale;
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (!loading && bookId && isForSale && !shopBook && !isPackagesFetched) {
      var booksToFetch = [bookId];
      dispatch(_shared_store_shop_actions__WEBPACK_IMPORTED_MODULE_3__/* ._sharedActionsShop.fetchShopBooks */ .h.fetchShopBooks(booksToFetch));
    }
  }, [shopIds, loading, bookId, book, shopBook, isPackagesFetched]);
  return {
    shopBook: shopBook,
    shopBooks: shopBooks,
    isAvailable: isBookPermissionAuthOKValue,
    shopPackage: shopPackage,
    packageShopBookIds: packageShopBookIds,
    packageIds: packageIds,
    loading: loading,
    isForSaleAndPurchased: isForSale && isBookPermissionAuthOKValue
  };
};

/***/ }),

/***/ 4727:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "WU": function() { return /* binding */ URLInitAction; },
/* harmony export */   "pk": function() { return /* binding */ makeHashInitActionListen; },
/* harmony export */   "tE": function() { return /* binding */ parseHashInitAction; }
/* harmony export */ });
/* harmony import */ var _url_url__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59916);
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }


var URLInitAction = {
  listen: "listen"
};
var DELIMITER_ACTION_DATA = ":";
var DELIMITER_DATA_VALUES = "|";
var makeHashInitActionListen = function makeHashInitActionListen(id, position) {
  if ("window" in __webpack_require__.g) {
    return window.location.pathname + "#initAction=listen" + DELIMITER_ACTION_DATA + id + (position === undefined ? "" : DELIMITER_DATA_VALUES + position);
  }

  return "";
};
var parseHashInitAction = function parseHashInitAction(url) {
  var parseUrl = (0,_url_url__WEBPACK_IMPORTED_MODULE_0__/* .parseUrlHash */ .sY)(url);

  if (parseUrl.initAction) {
    var _parseUrl$initAction$3 = parseUrl.initAction.split(DELIMITER_ACTION_DATA),
        _parseUrl$initAction$4 = _slicedToArray(_parseUrl$initAction$3, 2),
        action = _parseUrl$initAction$4[0],
        data = _parseUrl$initAction$4[1];

    if (action === URLInitAction.listen) {
      var _data$split3 = data.split(DELIMITER_DATA_VALUES),
          _data$split4 = _slicedToArray(_data$split3, 2),
          id = _data$split4[0],
          position = _data$split4[1];

      return {
        action: action,
        id: id,
        position: position
      };
    }
  }

  return null;
};

/***/ }),

/***/ 97476:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"accordion":"Accordion_accordion__oLx_m"};

/***/ }),

/***/ 91677:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768","desktop":"1024","md":"768","lg":"1024","book-actions":"BookActions_book-actions__F_JcT","book-info-actions":"BookActions_book-info-actions__YfupY","book-actions_modal":"BookActions_book-actions_modal__9Z_yE","book-details-actions-row":"BookActions_book-details-actions-row___oSYx","book-actions_landing":"BookActions_book-actions_landing__pcS7C","book-details-actions-row_landing":"BookActions_book-details-actions-row_landing__zsUND","actions-row-only-buy":"BookActions_actions-row-only-buy__nEEKw"};

/***/ }),

/***/ 60219:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768","desktop":"1024","md":"768","lg":"1024","book-wrapper":"book-list_book-wrapper__ZWHpr","book-list":"book-list_book-list__ak0k2","book-list-item":"book-list_book-list-item__QoRR5","book-list-item__image":"book-list_book-list-item__image__PijH1","book-list-item-code":"book-list_book-list-item-code__7FoRZ","book-list-item-title":"book-list_book-list-item-title__LnRJV","grid":"book-list_grid__cRW_F","list":"book-list_list__w8QWS"};

/***/ }),

/***/ 12501:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768","desktop":"1024","md":"768","lg":"1024","breadcrumbs":"breadcrumbs_breadcrumbs__y8rnV"};

/***/ }),

/***/ 40517:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768","desktop":"1024","md":"768","lg":"1024","root":"ButtonArrow_root__Qzv5O","button":"ButtonArrow_button__wGnIq","icon":"ButtonArrow_icon__WuApJ"};

/***/ }),

/***/ 55170:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"item":"DialogInstallInstructions_item__qcoNM","image":"DialogInstallInstructions_image__OkeV9"};

/***/ }),

/***/ 20162:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768","desktop":"1024","md":"768","lg":"1024","container":"container_container__OHmS3"};

/***/ }),

/***/ 4037:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768","desktop":"1024","md":"768","lg":"1024","qr-code_wrap":"CreateQRcode_qr-code_wrap__5AW4P","qr-code_input":"CreateQRcode_qr-code_input__A_zY_","qr-code-image":"CreateQRcode_qr-code-image__L08zd","qr-code_action":"CreateQRcode_qr-code_action__Kc2M3","qr-code-buttons":"CreateQRcode_qr-code-buttons__otsri","two-column":"CreateQRcode_two-column__V2uYw","qr-code_button":"CreateQRcode_qr-code_button__T9k31","qr-code_icon-button":"CreateQRcode_qr-code_icon-button__roLOH","qr-code_info_text":"CreateQRcode_qr-code_info_text__I7tNP","tooltip":"CreateQRcode_tooltip__WyutH","tooltiptext":"CreateQRcode_tooltiptext__8DEjv","active":"CreateQRcode_active__2QZvf"};

/***/ }),

/***/ 3797:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"delimiter":"delimiter_delimiter__J6281"};

/***/ }),

/***/ 99214:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"readerTranslationsPopupHeight":"7.1","tablet":"768","desktop":"1024","md":"768","lg":"1024","footer":"footer_footer__eCRo_","big-landing-footer":"footer_big-landing-footer__52KS1","footer-container":"footer_footer-container__ZLzUM","footer-logo":"footer_footer-logo__s5RiH","footer-logo-small":"footer_footer-logo-small__ftQ8_","footer-copyright":"footer_footer-copyright__t65SA","footer-logo-text":"footer_footer-logo-text__hDppP","footer-adventist":"footer_footer-adventist__5NJr8","asi-footer":"footer_asi-footer__7O6mS"};

/***/ }),

/***/ 89259:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"readerTranslationsPopupHeight":"7.1","tablet":"768","desktop":"1024","md":"768","lg":"1024","header":"Header_header__MwDFV","header__content-wrapper":"Header_header__content-wrapper__PzssL","dd-theme":"Header_dd-theme__TBb8f","header__go-to-full-app":"Header_header__go-to-full-app__wXG0g","header__logo":"Header_header__logo__isNI_","header__login":"Header_header__login__43DhO","header__search-help":"Header_header__search-help__YjApR","header__search-help__backdrop":"Header_header__search-help__backdrop__k9Fwk","header__three-dots":"Header_header__three-dots__xh1g0","three-dots_body":"Header_three-dots_body__xJgVn","btn-play":"Header_btn-play__q0s0x","header__btn-fullscreen":"Header_header__btn-fullscreen__VnRMU","header__btn-play":"Header_header__btn-play__OgsFe","logo__text-writings":"Header_logo__text-writings__Eu3Pv","header__btn-filter__mobile":"Header_header__btn-filter__mobile__TmVYh","header__btn-back":"Header_header__btn-back__04_k9","header-form":"Header_header-form__QiQRy","form-focused":"Header_form-focused__YbAdf","mode-blind":"Header_mode-blind__koVyK"};

/***/ }),

/***/ 82443:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"readerTranslationsPopupHeight":"7.1","tablet":"768","desktop":"1024","md":"768","lg":"1024","root":"HeaderLanding_root__s9dlP","inner":"HeaderLanding_inner__hboq7","link":"HeaderLanding_link__bgv_V","navigation":"HeaderLanding_navigation__dW_2e","with-btn-install":"HeaderLanding_with-btn-install__4_Mvc","with-btn-theme":"HeaderLanding_with-btn-theme__XHMok","with-btn-search":"HeaderLanding_with-btn-search__tVRwq","search":"HeaderLanding_search__n0oYP","btn-open":"HeaderLanding_btn-open__Tpc9z","btn-left":"HeaderLanding_btn-left__K1cvZ","btn-play":"HeaderLanding_btn-play__W6URd","big-landing-header":"HeaderLanding_big-landing-header__H4jJh","asi-header":"HeaderLanding_asi-header__cwS3w","header__logo":"HeaderLanding_header__logo__2PiQY","theme-icon":"HeaderLanding_theme-icon__s40UK","is-last-input-mouse":"HeaderLanding_is-last-input-mouse__tva6_","backdrop":"HeaderLanding_backdrop__eXvsS","navigation_qr-code-button":"HeaderLanding_navigation_qr-code-button__ztydC"};

/***/ }),

/***/ 72269:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"readerTranslationsPopupHeight":"7.1","tablet":"768","desktop":"1024","md":"768","lg":"1024","content":"PanelHeaderMenu_content__ZuZgn","inner":"PanelHeaderMenu_inner__qMVz5","link":"PanelHeaderMenu_link__fj1l_","item-icon":"PanelHeaderMenu_item-icon__TusFx","btn-qr":"PanelHeaderMenu_btn-qr__94Onw","dd-theme":"PanelHeaderMenu_dd-theme__A8lLS","btn-close":"PanelHeaderMenu_btn-close__o5kNP","wrap-actions":"PanelHeaderMenu_wrap-actions__MHO8F"};

/***/ }),

/***/ 41735:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768","desktop":"1024","md":"768","lg":"1024","language-selector":"LanguageSelector_language-selector__cCqtg","right":"LanguageSelector_right__tLabo","language-selector__inner":"LanguageSelector_language-selector__inner___woas","wrap-input":"LanguageSelector_wrap-input__i1te2","search-input":"LanguageSelector_search-input__WsRoV","search-input__input":"LanguageSelector_search-input__input__UssgY","language-selector-list":"LanguageSelector_language-selector-list__DH4MK","language-selector-list-item":"LanguageSelector_language-selector-list-item__OkXLJ","is-current":"LanguageSelector_is-current__r0byk","language-selector-list-title":"LanguageSelector_language-selector-list-title__c0txb","language-selector-img":"LanguageSelector_language-selector-img__9wiom","checkbox":"LanguageSelector_checkbox__uYvMB","can-look-through":"LanguageSelector_can-look-through__CWh_u","bounceOpacity":"LanguageSelector_bounceOpacity__8YJcG"};

/***/ }),

/***/ 43333:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"readerTranslationsPopupHeight":"7.1","tablet":"768","desktop":"1024","md":"768","lg":"1024","content-wrap":"main-layout_content-wrap__X7vL2","big-land-main":"main-layout_big-land-main__xEhG1","main-container":"main-layout_main-container__4bx4L","footer-container":"main-layout_footer-container__Z_9uG","loader-popup":"main-layout_loader-popup__JQmOy","mode-blind":"main-layout_mode-blind__TQCdJ"};

/***/ }),

/***/ 62803:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"share-body":"share-popup_share-body__6p67Y"};

/***/ }),

/***/ 10980:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768","desktop":"1024","md":"768","lg":"1024","theme-menu":"themeMenu_theme-menu__e0Dr9","theme-menu_list-item":"themeMenu_theme-menu_list-item__ovw3u","theme-menu_list-title":"themeMenu_theme-menu_list-title__0Fl8c","is-current":"themeMenu_is-current__j1eW7","mode-blind":"themeMenu_mode-blind__5yUh_"};

/***/ }),

/***/ 74117:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768","desktop":"1024","md":"768","lg":"1024","tile-list-item":"tile_tile-list-item__EeS_5","tile-list-item__icon":"tile_tile-list-item__icon__Qmvuj","wrapper-text":"tile_wrapper-text__FJ9gp","tile-list-item__img":"tile_tile-list-item__img___tixi","tile-list-item__title":"tile_tile-list-item__title__860Jj","tile-list-item__count":"tile_tile-list-item__count__yKsHb","is-last-input-mouse":"tile_is-last-input-mouse___7B_J","mode-blind":"tile_mode-blind__nKxgR"};

/***/ }),

/***/ 28790:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768","desktop":"1024","md":"768","lg":"1024","tile-list":"tile-list_tile-list__cz_iP"};

/***/ }),

/***/ 35150:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768","desktop":"1024","md":"768","lg":"1024","top-panel":"top-panel_top-panel__mw2wS","hidden":"top-panel_hidden__ucL9y"};

/***/ }),

/***/ 43278:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768","desktop":"1024","md":"768","lg":"1024","cookies-notification":"CookiesNotification_cookies-notification__W19o7","cookies-notification-wrapper":"CookiesNotification_cookies-notification-wrapper__A937x","cookies-notification-content":"CookiesNotification_cookies-notification-content__lul29","cookies-notification-content-title":"CookiesNotification_cookies-notification-content-title__bUve_","cookies-notification-content-text":"CookiesNotification_cookies-notification-content-text__ib6j0","cookies-notification-actions":"CookiesNotification_cookies-notification-actions__k2jSx","btn-cookies":"CookiesNotification_btn-cookies__kDX_X","hide-icon-container":"CookiesNotification_hide-icon-container__ZTWWx"};

/***/ }),

/***/ 88567:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768","desktop":"1024","md":"768","lg":"1024","please-sign-in-page":"PleaseSignInPage_please-sign-in-page__5dJOh","sign-in-icon":"PleaseSignInPage_sign-in-icon__lNlAW","please-sign-in-page-content":"PleaseSignInPage_please-sign-in-page-content__6YWu1","text":"PleaseSignInPage_text__Q8mJt","please-sign-in-page-button":"PleaseSignInPage_please-sign-in-page-button__wPiWf"};

/***/ }),

/***/ 94770:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768","desktop":"1024","md":"768","lg":"1024","subs-switcher":"subscriptionSwitcher_subs-switcher__9wDLm","subs-switcher-icon":"subscriptionSwitcher_subs-switcher-icon__DtM8i","subs-switcher-icon-bird":"subscriptionSwitcher_subs-switcher-icon-bird__byOmt","popup-subs-list":"subscriptionSwitcher_popup-subs-list__NXMFL","popup-subs-item":"subscriptionSwitcher_popup-subs-item__wYvPj","popup-subs-item-text":"subscriptionSwitcher_popup-subs-item-text__sie9L","is-active":"subscriptionSwitcher_is-active__1E4kl"};

/***/ }),

/***/ 90843:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768","desktop":"1024","md":"768","lg":"1024","subs-item":"subscriptions_subs-item__MdjWl","subs-item-img-container":"subscriptions_subs-item-img-container__7DNIu","subs-item-img":"subscriptions_subs-item-img__nCoI5","subs-item-description":"subscriptions_subs-item-description__y79Kp","subs-item-title":"subscriptions_subs-item-title__8rl9S","subs-item-actions":"subscriptions_subs-item-actions__hWOHO","subs-item-action":"subscriptions_subs-item-action__lr5O1","active":"subscriptions_active__KqlAw","subs-item-action-icon":"subscriptions_subs-item-action-icon__BmdyR","subs-item-action-icon-selected":"subscriptions_subs-item-action-icon-selected___qDje","subs-item-content":"subscriptions_subs-item-content__c_ShL","subs-item-tap":"subscriptions_subs-item-tap__6boAr","subs-item-tap-text":"subscriptions_subs-item-tap-text__Nqf6Z","subs-default-text":"subscriptions_subs-default-text__YG2kQ","subs-thought-item":"subscriptions_subs-thought-item__J_Hkp","subs-thought-item-content":"subscriptions_subs-thought-item-content__nt0ub","subs-thought-item-title":"subscriptions_subs-thought-item-title__zoScu","subs-thought-item-title-text":"subscriptions_subs-thought-item-title-text__mX_AQ","subs-share-icon":"subscriptions_subs-share-icon__EST2V","subs-reader-wrap":"subscriptions_subs-reader-wrap__XKnjI","delete-sub-container":"subscriptions_delete-sub-container__uKjGu","subs-top-panel":"subscriptions_subs-top-panel__vQ__i","subs-reader-top-panel":"subscriptions_subs-reader-top-panel__IDtrv","subs-top-panel-col":"subscriptions_subs-top-panel-col__JD1zo","subs-top-panel-actions":"subscriptions_subs-top-panel-actions__rpGLG","subs-top-panel-action":"subscriptions_subs-top-panel-action__qeM_F","subscription-read-view":"subscriptions_subscription-read-view__4a073","subs-tabs":"subscriptions_subs-tabs__TMFki","subs-tabs-title":"subscriptions_subs-tabs-title__q4MU8","active-sub":"subscriptions_active-sub__N0R12","text-no-subscriptions":"subscriptions_text-no-subscriptions__wFKyF","three-dots-popup":"subscriptions_three-dots-popup__jReCa","date-switcher-icon-calendar":"subscriptions_date-switcher-icon-calendar___zK0X","mode-blind":"subscriptions_mode-blind__DFH2V","is-last-input-mouse":"subscriptions_is-last-input-mouse__UyglP"};

/***/ }),

/***/ 84353:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768","desktop":"1024","md":"768","lg":"1024","root":"BreadcrumbsButtonGoBack_root__hFdcf","title-wrap":"BreadcrumbsButtonGoBack_title-wrap___GftO","title":"BreadcrumbsButtonGoBack_title__GwUfi","icon":"BreadcrumbsButtonGoBack_icon__yqyPm","main-header-inner":"BreadcrumbsButtonGoBack_main-header-inner__UJP4Q"};

/***/ }),

/***/ 66874:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"radio-item":"CheckboxGroup_radio-item__Z2FQ3","active":"CheckboxGroup_active__wkc5G","inactive":"CheckboxGroup_inactive__wBckU","form-group-col2":"CheckboxGroup_form-group-col2__lkgpK","CheckboxGroup":"CheckboxGroup_CheckboxGroup__eOpRg","RadioGroup":"CheckboxGroup_RadioGroup__pkCcp","form-group-col3":"CheckboxGroup_form-group-col3__VdyYS"};

/***/ }),

/***/ 65012:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768","desktop":"1024","md":"768","lg":"1024","root":"DatePicker_root__gHEVu","head":"DatePicker_head__SOjXc","arrow":"DatePicker_arrow__Cts6H","body":"DatePicker_body__Voo_O","week-names":"DatePicker_week-names__Xxeg8","week-name":"DatePicker_week-name__CG9wK","week":"DatePicker_week__3mwy7","day":"DatePicker_day__h1wJD","read":"DatePicker_read__udOaZ","indicator":"DatePicker_indicator__0DBo1","unread":"DatePicker_unread__x_LE4","selected":"DatePicker_selected__PJ8E5","disabled":"DatePicker_disabled__YK8vk","is-last-input-mouse":"DatePicker_is-last-input-mouse__esLU1"};

/***/ }),

/***/ 84001:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"date-switcher":"date-switcher_date-switcher__Tjr3N","date-switcher-icon-calendar":"date-switcher_date-switcher-icon-calendar__40wq_","date-switcher-controls-container":"date-switcher_date-switcher-controls-container__OTkur","date-switcher-date-container":"date-switcher_date-switcher-date-container__EYb0W","is-disabled":"date-switcher_is-disabled__YcCn5","date-switcher-date-text":"date-switcher_date-switcher-date-text__sC_EU","date-switcher-date-icon":"date-switcher_date-switcher-date-icon__1rtsn","date-switcher-date-current":"date-switcher_date-switcher-date-current__Qb16R"};

/***/ }),

/***/ 68537:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"popup-content-default":"ThreeDots_popup-content-default__pmLjK","labels-mode":"ThreeDots_labels-mode__K6Uj7"};

/***/ }),

/***/ 68059:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768","desktop":"1024","md":"768","lg":"1024","root":"PortalMainAfter_root__wckEw"};

/***/ }),

/***/ 90275:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"text":"TypographyCropped_text__0vEJ2","button-more":"TypographyCropped_button-more__TeizV"};

/***/ }),

/***/ 93511:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768","desktop":"1024","md":"768","lg":"1024","player-controls":"PlayerUIKit_player-controls__C_kTt","timer-controls":"PlayerUIKit_timer-controls__719x_","volume-controls":"PlayerUIKit_volume-controls__MMzdN","progress-controls":"PlayerUIKit_progress-controls__aprrv","track-cover":"PlayerUIKit_track-cover__Aw9TU","icon-hover-slider":"PlayerUIKit_icon-hover-slider__sAYZt","is-expanded":"PlayerUIKit_is-expanded__Ntu9J","icon-hover-slider__slider-wrapper__inner":"PlayerUIKit_icon-hover-slider__slider-wrapper__inner__CnZui","is-disabled":"PlayerUIKit_is-disabled__QW9jc","has-slide-direction-left":"PlayerUIKit_has-slide-direction-left__8QWhj","icon-hover-slider__slider":"PlayerUIKit_icon-hover-slider__slider__IJxXd","icon-hover-slider__icon-wrapper":"PlayerUIKit_icon-hover-slider__icon-wrapper__GHSQV","icon-hover-slider__slider-wrapper":"PlayerUIKit_icon-hover-slider__slider-wrapper__Q4TJW","icon-hover-slider__slider-label-right":"PlayerUIKit_icon-hover-slider__slider-label-right__e9EAs","timer-controls-icon":"PlayerUIKit_timer-controls-icon__YB5Hn","timer-controls-icon__label":"PlayerUIKit_timer-controls-icon__label__YO34V","timer-controls-icon__svg":"PlayerUIKit_timer-controls-icon__svg__1lgZQ","text-controls":"PlayerUIKit_text-controls__hKwmd","value-is-not-zero":"PlayerUIKit_value-is-not-zero__Zm6jG","text-controls__text-current":"PlayerUIKit_text-controls__text-current__J2JaQ","text-controls__text":"PlayerUIKit_text-controls__text__X8_Jw","clickable":"PlayerUIKit_clickable__T_sv8","text-controls__controls":"PlayerUIKit_text-controls__controls__s1uZs","timer-controls__controls":"PlayerUIKit_timer-controls__controls__CXBi8","playback-controls":"PlayerUIKit_playback-controls__JHbsw","playback-controls__icon":"PlayerUIKit_playback-controls__icon__xChbw","with-slider":"PlayerUIKit_with-slider__HyHux","progress-controls__time-wrapper":"PlayerUIKit_progress-controls__time-wrapper__jfBWu","player-content__time-slider":"PlayerUIKit_player-content__time-slider__C_a9C","track-cover__text-wrapper":"PlayerUIKit_track-cover__text-wrapper__aynzF","track-cover__text-wrapper__text":"PlayerUIKit_track-cover__text-wrapper__text__zc4eO","track-cover__text-wrapper__text-track":"PlayerUIKit_track-cover__text-wrapper__text-track__slgyW","skip-buttons-shown":"PlayerUIKit_skip-buttons-shown__gSqI5","mode-mobile":"PlayerUIKit_mode-mobile__G7JJc","mode-text":"PlayerUIKit_mode-text__16YaO","progress-controls__time-wrapper__current":"PlayerUIKit_progress-controls__time-wrapper__current__5_OJc"};

/***/ })

}]);